"use strict";
(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[5728],{

/***/ 99566:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ AuthModal_AuthModal; }
});

// EXTERNAL MODULE: ../node_modules/.pnpm/react-redux@7.2.8_react-dom@17.0.2+react@17.0.2/node_modules/react-redux/es/index.js + 22 modules
var es = __webpack_require__(55304);
// EXTERNAL MODULE: ../node_modules/.pnpm/@vinted+web-ui@34.8.0_29a9e79dfb0433562b4e854f8f07c904/node_modules/@vinted/web-ui/dist/esm/lib/BottomSheet/BottomSheet.js + 5 modules
var BottomSheet = __webpack_require__(79607);
// EXTERNAL MODULE: ../node_modules/.pnpm/@vinted+web-ui@34.8.0_29a9e79dfb0433562b4e854f8f07c904/node_modules/@vinted/web-ui/dist/esm/lib/Modal/Modal.js
var Modal = __webpack_require__(73325);
// EXTERNAL MODULE: ../node_modules/.pnpm/@vinted+web-ui@34.8.0_29a9e79dfb0433562b4e854f8f07c904/node_modules/@vinted/web-ui/dist/esm/lib/Navigation/Navigation.js
var Navigation = __webpack_require__(92079);
// EXTERNAL MODULE: ../node_modules/.pnpm/@vinted+web-ui@34.8.0_29a9e79dfb0433562b4e854f8f07c904/node_modules/@vinted/web-ui/dist/esm/lib/Button/Button.js
var Button = __webpack_require__(10914);
// EXTERNAL MODULE: ../node_modules/.pnpm/@vinted+web-ui@34.8.0_29a9e79dfb0433562b4e854f8f07c904/node_modules/@vinted/web-ui/dist/esm/lib/Icon/Icon.js + 1 modules
var Icon = __webpack_require__(57645);
// EXTERNAL MODULE: ../app/hooks/useTranslate.ts
var useTranslate = __webpack_require__(63820);
// EXTERNAL MODULE: ../app/hooks/useBreakpoint.ts
var useBreakpoint = __webpack_require__(7250);
// EXTERNAL MODULE: ../app/state/auth/slice.ts
var slice = __webpack_require__(69472);
// EXTERNAL MODULE: ../app/state/auth/selectors.ts
var selectors = __webpack_require__(87728);
// EXTERNAL MODULE: ../node_modules/.pnpm/next@12.3.3_4afada721a4a39e35a1a66028f2134fd/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/defineProperty.js
var defineProperty = __webpack_require__(24057);
// EXTERNAL MODULE: ../app/components/ErrorState/ErrorState.tsx
var ErrorState = __webpack_require__(80811);
// EXTERNAL MODULE: ../app/state/auth/constants.ts
var constants = __webpack_require__(29702);
// EXTERNAL MODULE: ../app/libs/utils/object.ts
var object = __webpack_require__(55118);
// EXTERNAL MODULE: ../node_modules/.pnpm/react@17.0.2/node_modules/react/index.js
var react = __webpack_require__(49231);
// EXTERNAL MODULE: ../node_modules/.pnpm/@vinted+web-ui@34.8.0_29a9e79dfb0433562b4e854f8f07c904/node_modules/@vinted/web-ui/dist/esm/lib/Text/Text.js
var Text = __webpack_require__(73080);
// EXTERNAL MODULE: ../node_modules/.pnpm/@vinted+web-ui@34.8.0_29a9e79dfb0433562b4e854f8f07c904/node_modules/@vinted/web-ui/dist/esm/lib/Validation/Validation.js
var Validation = __webpack_require__(70347);
// EXTERNAL MODULE: ../node_modules/.pnpm/@vinted+web-ui@34.8.0_29a9e79dfb0433562b4e854f8f07c904/node_modules/@vinted/web-ui/dist/esm/lib/Cell/Cell.js
var Cell = __webpack_require__(36403);
// EXTERNAL MODULE: ../node_modules/.pnpm/@vinted+web-ui@34.8.0_29a9e79dfb0433562b4e854f8f07c904/node_modules/@vinted/web-ui/dist/esm/lib/Spacer/Spacer.js
var Spacer = __webpack_require__(12637);
// EXTERNAL MODULE: ../node_modules/.pnpm/@vinted+web-ui@34.8.0_29a9e79dfb0433562b4e854f8f07c904/node_modules/@vinted/web-ui/dist/esm/lib/Input/InputText/InputText.js
var InputText = __webpack_require__(45604);
// EXTERNAL MODULE: ../node_modules/.pnpm/@vinted+web-ui@34.8.0_29a9e79dfb0433562b4e854f8f07c904/node_modules/@vinted/web-ui/dist/esm/lib/Card/Card.js
var Card = __webpack_require__(86021);
// EXTERNAL MODULE: ../app/components/@support/FormattedMessage/FormattedMessage.tsx
var FormattedMessage = __webpack_require__(718);
// EXTERNAL MODULE: ../app/components/FaqEntryUrl/FaqEntryUrl.tsx
var FaqEntryUrl = __webpack_require__(94773);
// EXTERNAL MODULE: ../app/components/SeparatedList/SeparatedList.tsx
var SeparatedList = __webpack_require__(42792);
// EXTERNAL MODULE: ../app/components/Auth/hooks/useSuccessUrl.ts
var useSuccessUrl = __webpack_require__(75000);
// EXTERNAL MODULE: ../app/constants/auth.ts
var auth = __webpack_require__(2414);
// EXTERNAL MODULE: ../app/constants/faq-entry.ts
var faq_entry = __webpack_require__(23267);
// EXTERNAL MODULE: ../app/constants/index.ts
var app_constants = __webpack_require__(24203);
// EXTERNAL MODULE: ../app/constants/routes/index.ts
var routes = __webpack_require__(85263);
// EXTERNAL MODULE: ../app/data/api/account.ts
var account = __webpack_require__(33713);
// EXTERNAL MODULE: ../app/libs/utils/fingerprint.ts
var utils_fingerprint = __webpack_require__(64076);
// EXTERNAL MODULE: ../app/libs/utils/url.ts
var url = __webpack_require__(11985);
// EXTERNAL MODULE: ../app/libs/utils/window.ts
var utils_window = __webpack_require__(27329);
// EXTERNAL MODULE: ../app/data/api/response-codes.ts
var response_codes = __webpack_require__(25146);
// EXTERNAL MODULE: ../app/state/feature-switches/selectors.ts
var feature_switches_selectors = __webpack_require__(48615);
// EXTERNAL MODULE: ../node_modules/.pnpm/react@17.0.2/node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(20264);
;// CONCATENATED MODULE: ../app/pages/PasswordVerificationLogin/PasswordVerificationLogin.tsx






















const PasswordVerificationLogin = _ref => {
  let {
    email,
    idToken
  } = _ref;
  const translate = (0,useTranslate/* default */.Z)('user.wrong_email_in_registration');
  const successUrl = (0,useSuccessUrl/* default */.Z)();
  const isLoginWithoutEmailInModalEnabled = (0,es/* useSelector */.v9)((0,feature_switches_selectors/* getIsFeatureSwitchEnabled */.z)('login_without_email_in_modal'));
  const {
    0: password,
    1: setPassword
  } = (0,react.useState)('');
  const {
    0: validationErrors,
    1: setValidationErrors
  } = (0,react.useState)([]);
  const {
    0: isPasswordVisible,
    1: setIsPasswordVisible
  } = (0,react.useState)(false);

  const doAuthenticate = async () => {
    if (!email) return;
    const fingerprint = await (0,utils_fingerprint/* getFingerprint */.f)();
    const response = await (0,account/* authenticateUser */.So)({
      grantType: auth/* AuthenticateGrantType.Password */.Gg.Password,
      username: email,
      controlCode: idToken,
      password,
      fingerprint
    });

    if (response.code === response_codes/* ResponseCode.Required2FA */.Q.Required2FA && 'payload' in response && response.payload) {
      (0,utils_window/* navigateToPage */.ru)((0,routes/* CODE_LOGIN */.Le)({
        refUrl: successUrl,
        authProps: response.payload
      }));
      return;
    }

    if ('errors' in response) {
      setValidationErrors([response.message]);
      return;
    }

    (0,utils_window/* navigateToPage */.ru)((0,url/* getRefUrl */.y4)(routes/* ROOT_URL */.mY));
  };

  const handleInputChange = event => {
    setPassword(event.target.value);
  };

  const togglePasswordVisibility = () => {
    setIsPasswordVisible(prevState => !prevState);
  };

  const renderLink = (url, text) => /*#__PURE__*/(0,jsx_runtime.jsx)("a", {
    href: url,
    children: /*#__PURE__*/(0,jsx_runtime.jsx)(Text/* default */.Z, {
      bold: true,
      text: text,
      clickable: true
    })
  });

  const renderContactUsLink = url => renderLink(url, translate('contact_us'));

  const renderPasswordResetLink = url => renderLink(url, translate('reset_password'));

  const errorMessage = validationErrors.length ? /*#__PURE__*/(0,jsx_runtime.jsx)(Validation/* default */.Z, {
    text: validationErrors[0],
    theme: "warning"
  }) : null;
  const passwordIconName = isPasswordVisible ? 'eye-denied' : 'eye';

  const renderContent = () => /*#__PURE__*/(0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
    children: [/*#__PURE__*/(0,jsx_runtime.jsxs)(Cell/* default */.Z, {
      children: [/*#__PURE__*/(0,jsx_runtime.jsx)(Text/* default */.Z, {
        text: translate('heading', {
          registration_email: email
        }),
        alignment: Text/* default.Alignment.Center */.Z.Alignment.Center,
        width: Text/* default.Width.Parent */.Z.Width.Parent,
        type: Text/* default.Type.Heading */.Z.Type.Heading
      }), /*#__PURE__*/(0,jsx_runtime.jsx)(Spacer/* default */.Z, {
        size: Spacer/* default.Size.X2Large */.Z.Size.X2Large
      }), /*#__PURE__*/(0,jsx_runtime.jsx)(Spacer/* default */.Z, {}), /*#__PURE__*/(0,jsx_runtime.jsx)(FormattedMessage/* default */.Z, {
        id: "user.wrong_email_in_registration.error_explanation",
        values: {
          registration_email: /*#__PURE__*/(0,jsx_runtime.jsx)(Text/* default */.Z, {
            text: email,
            bold: true
          })
        }
      })]
    }), /*#__PURE__*/(0,jsx_runtime.jsx)(InputText/* InputTextWithForwardedRef */.M, {
      name: "password",
      placeholder: translate('placeholder'),
      validation: errorMessage,
      type: isPasswordVisible ? InputText/* InputTextWithForwardedRef.Type.Text */.M.Type.Text : InputText/* InputTextWithForwardedRef.Type.Password */.M.Type.Password,
      onChange: handleInputChange,
      value: password,
      suffix: /*#__PURE__*/(0,jsx_runtime.jsx)(Button/* ButtonWithForwardedRef */.I, {
        size: Button/* ButtonWithForwardedRef.Size.Medium */.I.Size.Medium,
        icon: /*#__PURE__*/(0,jsx_runtime.jsx)(Icon/* default */.Z, {
          name: passwordIconName,
          color: Icon/* default.Color.Gray3_v2 */.Z.Color.Gray3_v2,
          size: Icon/* default.Size.Small */.Z.Size.Small
        }),
        styling: Button/* ButtonWithForwardedRef.Styling.Flat */.I.Styling.Flat,
        onClick: togglePasswordVisibility
      })
    }), /*#__PURE__*/(0,jsx_runtime.jsx)(Cell/* default */.Z, {
      children: /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
        className: "u-text-center",
        children: /*#__PURE__*/(0,jsx_runtime.jsxs)(SeparatedList/* default */.Z, {
          separator: /*#__PURE__*/(0,jsx_runtime.jsx)(Spacer/* default */.Z, {
            size: Spacer/* default.Size.XLarge */.Z.Size.XLarge
          }),
          children: [/*#__PURE__*/(0,jsx_runtime.jsx)(Button/* ButtonWithForwardedRef */.I, {
            testId: "login-button",
            onClick: doAuthenticate,
            text: translate('button', {
              registration_email: email
            }),
            styling: Button/* ButtonWithForwardedRef.Styling.Filled */.I.Styling.Filled
          }), renderPasswordResetLink(routes/* FORGOT_PASSWORD_URL */.If), /*#__PURE__*/(0,jsx_runtime.jsx)(FaqEntryUrl/* default */.Z, {
            type: faq_entry/* FaqEntryType.CantLogin */.Z.CantLogin,
            accessChannel: app_constants/* AccessChannel.ProductLink */.Si.ProductLink,
            render: url => renderContactUsLink(url)
          })]
        })
      })
    }), /*#__PURE__*/(0,jsx_runtime.jsx)(Spacer/* default */.Z, {})]
  });

  return isLoginWithoutEmailInModalEnabled ? renderContent() : /*#__PURE__*/(0,jsx_runtime.jsx)(Card/* default */.Z, {
    children: renderContent()
  });
};

/* harmony default export */ var PasswordVerificationLogin_PasswordVerificationLogin = (PasswordVerificationLogin);
// EXTERNAL MODULE: ../app/components/ContentLoader/ContentLoader.tsx
var ContentLoader = __webpack_require__(72193);
// EXTERNAL MODULE: ../node_modules/.pnpm/@vinted+web-ui@34.8.0_29a9e79dfb0433562b4e854f8f07c904/node_modules/@vinted/web-ui/dist/esm/lib/Checkbox/Checkbox.js
var Checkbox = __webpack_require__(37929);
// EXTERNAL MODULE: ../app/components/List/List.tsx
var List = __webpack_require__(59567);
;// CONCATENATED MODULE: ../app/components/RandomUserSignup/RandomUserSignup.tsx











class RandomUserSignup extends react.Component {
  constructor() {
    var _this;

    super(...arguments);
    _this = this;

    (0,defineProperty/* default */.Z)(this, "state", {
      error: false,
      isLoading: false,
      isSettingsModalOpen: false,
      isGod: true
    });

    (0,defineProperty/* default */.Z)(this, "setError", function () {
      let error = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;

      _this.setState({
        error
      });
    });

    (0,defineProperty/* default */.Z)(this, "setIsLoading", function () {
      let isLoading = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : true;

      _this.setState({
        isLoading
      });
    });

    (0,defineProperty/* default */.Z)(this, "toggleModal", () => {
      this.setState(prevState => ({
        isSettingsModalOpen: !prevState.isSettingsModalOpen
      }));
    });

    (0,defineProperty/* default */.Z)(this, "generateUser", async () => {
      const {
        isLoading,
        isGod
      } = this.state;
      if (isLoading) return;
      this.setError();
      this.setIsLoading();

      try {
        await (0,account/* generateRandomUser */.mI)({
          isGod
        });
        (0,utils_window/* navigateToPage */.ru)(routes/* ROOT_URL */.mY);
      } catch (exception) {
        this.setError(true);
      } finally {
        this.setIsLoading(false);
      }
    });

    (0,defineProperty/* default */.Z)(this, "toggleIsGod", () => {
      this.setState(prevState => ({
        isGod: !prevState.isGod
      }));
    });

    (0,defineProperty/* default */.Z)(this, "renderModal", () => {
      const {
        isSettingsModalOpen,
        isLoading,
        isGod
      } = this.state;
      return /*#__PURE__*/(0,jsx_runtime.jsx)(Modal/* default */.Z, {
        show: isSettingsModalOpen,
        children: /*#__PURE__*/(0,jsx_runtime.jsxs)(List/* default */.Z, {
          children: [/*#__PURE__*/(0,jsx_runtime.jsx)(Cell/* default */.Z, {
            styling: Cell/* default.Styling.Wide */.Z.Styling.Wide,
            children: /*#__PURE__*/(0,jsx_runtime.jsx)(Text/* default */.Z, {
              type: Text/* default.Type.Title */.Z.Type.Title,
              alignment: Text/* default.Alignment.Center */.Z.Alignment.Center,
              width: Text/* default.Width.Parent */.Z.Width.Parent,
              text: "Generate user settings"
            })
          }), /*#__PURE__*/(0,jsx_runtime.jsx)(Cell/* default */.Z, {
            styling: Cell/* default.Styling.Wide */.Z.Styling.Wide,
            title: "Assign god role?",
            suffix: /*#__PURE__*/(0,jsx_runtime.jsx)(Checkbox/* CheckboxWithForwardedRef */.F, {
              name: "is_god",
              checked: isGod,
              onClick: this.toggleIsGod
            })
          }), /*#__PURE__*/(0,jsx_runtime.jsx)(Cell/* default */.Z, {
            styling: Cell/* default.Styling.Wide */.Z.Styling.Wide,
            children: /*#__PURE__*/(0,jsx_runtime.jsx)(Button/* ButtonWithForwardedRef */.I, {
              text: "Save",
              styling: Button/* ButtonWithForwardedRef.Styling.Filled */.I.Styling.Filled,
              isLoading: isLoading,
              onClick: this.toggleModal
            })
          })]
        })
      });
    });
  }

  render() {
    const {
      isLoading,
      error
    } = this.state;
    return /*#__PURE__*/(0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
      children: [error && /*#__PURE__*/(0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [/*#__PURE__*/(0,jsx_runtime.jsx)(Text/* default */.Z, {
          theme: "warning",
          type: Text/* default.Type.Subtitle */.Z.Type.Subtitle,
          alignment: Text/* default.Alignment.Center */.Z.Alignment.Center,
          width: Text/* default.Width.Parent */.Z.Width.Parent,
          text: "Server error"
        }), /*#__PURE__*/(0,jsx_runtime.jsx)(Spacer/* default */.Z, {})]
      }), /*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
        className: "u-flexbox",
        children: [/*#__PURE__*/(0,jsx_runtime.jsx)(Button/* ButtonWithForwardedRef */.I, {
          text: "Generate random user",
          isLoading: isLoading,
          onClick: this.generateUser
        }), /*#__PURE__*/(0,jsx_runtime.jsx)(Spacer/* default */.Z, {
          orientation: Spacer/* default.Orientation.Vertical */.Z.Orientation.Vertical
        }), /*#__PURE__*/(0,jsx_runtime.jsx)(Button/* ButtonWithForwardedRef */.I, {
          icon: /*#__PURE__*/(0,jsx_runtime.jsx)(Icon/* default */.Z, {
            name: "settings",
            color: Icon/* default.Color.Calypso */.Z.Color.Calypso
          }),
          inline: true,
          onClick: this.toggleModal
        })]
      }), this.renderModal()]
    });
  }

}

/* harmony default export */ var RandomUserSignup_RandomUserSignup = (RandomUserSignup);
// EXTERNAL MODULE: ../app/data/api/index.ts + 1 modules
var api = __webpack_require__(69170);
// EXTERNAL MODULE: ../app/hooks/useGoogleTagManagerTrack.ts + 1 modules
var useGoogleTagManagerTrack = __webpack_require__(76819);
// EXTERNAL MODULE: ../app/constants/google.ts
var google = __webpack_require__(31967);
// EXTERNAL MODULE: ../node_modules/.pnpm/lodash@4.17.21/node_modules/lodash/lodash.js
var lodash = __webpack_require__(61888);
// EXTERNAL MODULE: ../app/components/Auth/FacebookButton/useInitFacebook.ts
var useInitFacebook = __webpack_require__(2463);
;// CONCATENATED MODULE: ../app/components/Auth/FacebookButton/FacebookButton.tsx







const FacebookButton = _ref => {
  let {
    text,
    isLoading,
    onClick = lodash.noop,
    onSuccess,
    onFailure = lodash.noop
  } = _ref;
  const {
    0: isFbLoginLoading,
    1: setIsFbLoginLoading
  } = (0,react.useState)(false);
  const {
    isInitialized,
    isEnabled
  } = (0,useInitFacebook/* default */.Z)();

  const handleClick = () => {
    onClick();
    setIsFbLoginLoading(true);
    FB.login(response => {
      if (response.status !== auth/* FacebookLoginStatus.Connected */.Jt.Connected) {
        onFailure();
        setIsFbLoginLoading(false);
        return;
      }

      try {
        FB.api('/me', {
          fields: ['email', 'birthday', 'gender', 'name', 'first_name', 'last_name']
        }, fields => {
          onSuccess(response.authResponse.accessToken, fields);
        });
      } catch (exception) {
        var _window$apphealth;

        (_window$apphealth = window.apphealth) === null || _window$apphealth === void 0 ? void 0 : _window$apphealth.captureError(exception); // Calling success because the user is still allowed to login

        onSuccess(response.authResponse.accessToken, {});
      } finally {
        setIsFbLoginLoading(false);
      }
    }, {
      scope: auth/* FACEBOOK_PERMISSIONS */.gH
    });
  };

  if (!isEnabled) return null;
  return /*#__PURE__*/(0,jsx_runtime.jsx)(Button/* ButtonWithForwardedRef */.I, {
    theme: "amplified",
    iconName: "signup/facebook",
    onClick: handleClick,
    disabled: !isInitialized || isLoading || isFbLoginLoading,
    isLoading: isLoading || isFbLoginLoading,
    children: text
  });
};

/* harmony default export */ var FacebookButton_FacebookButton = (FacebookButton);
// EXTERNAL MODULE: ../app/hooks/useTracking/useTracking.ts
var useTracking = __webpack_require__(56068);
// EXTERNAL MODULE: ../app/constants/tracking/clickable-elements.ts
var clickable_elements = __webpack_require__(98495);
// EXTERNAL MODULE: ../app/libs/common/event-tracker/events.ts
var events = __webpack_require__(8351);
;// CONCATENATED MODULE: ../app/components/Auth/Facebook/Facebook.tsx























const Facebook = _ref => {
  let {
    setError
  } = _ref;
  const {
    track
  } = (0,useTracking/* default */.Z)();
  const translate = (0,useTranslate/* default */.Z)();
  const dispatch = (0,es/* useDispatch */.I0)();
  const isLoginWithoutEmailInModalEnabled = (0,es/* useSelector */.v9)((0,feature_switches_selectors/* getIsFeatureSwitchEnabled */.z)('login_without_email_in_modal'));
  const {
    googleTagManagerTrack
  } = (0,useGoogleTagManagerTrack/* default */.Z)();
  const successUrl = (0,useSuccessUrl/* default */.Z)();
  const {
    0: isLoading,
    1: setIsLoading
  } = (0,react.useState)(false);

  function handleClick() {
    track((0,events/* clickEvent */.Q5)({
      target: clickable_elements/* ClickableElement.LoginWithFacebook */.U.LoginWithFacebook
    }));
  }

  function trackError(error) {
    track((0,events/* authenticateFailEvent */.m2)({
      type: 'facebook',
      error
    }));
  }

  function handleLoginWithoutEmail(controlCode, email) {
    if (isLoginWithoutEmailInModalEnabled) {
      dispatch(slice/* actions.setExternalRegisterData */.Nw.setExternalRegisterData({
        view: constants/* AuthExternalRegisterView.PasswordVerification */.S4.PasswordVerification,
        data: {
          idToken: controlCode,
          email
        }
      }));
      return;
    }

    (0,utils_window/* navigateToPage */.ru)((0,url/* urlWithParams */.Iq)(routes/* LOGIN_WITHOUT_EMAIL_URL */.ao, {
      control_code: controlCode
    }));
  }

  async function handleSuccess(token, fields) {
    setIsLoading(true);
    const fingerprint = await (0,utils_fingerprint/* getFingerprint */.f)();
    const response = await (0,account/* authenticateUser */.So)({
      grantType: auth/* AuthenticateGrantType.Assertion */.Gg.Assertion,
      provider: auth/* AuthenticateProvider.Facebook */.WU.Facebook,
      assertion: token,
      fingerprint
    });

    if ('errors' in response) {
      var _response$payload; // TODO: handle ResponseCode.SessionFromTokenError


      if (response.code === response_codes/* ResponseCode.NotFound */.Q.NotFound && fields.email) {
        const realName = fields.name || [fields.first_name, fields.last_name].filter(Boolean).join(' ') || undefined;
        dispatch(slice/* actions.setExternalRegisterData */.Nw.setExternalRegisterData({
          view: constants/* AuthExternalRegisterView.FacebookRegister */.S4.FacebookRegister,
          data: {
            idToken: token,
            realName,
            email: fields.email
          }
        }));
      } else if (response.code === response_codes/* ResponseCode.LoginWithoutEmail */.Q.LoginWithoutEmail && (_response$payload = response.payload) !== null && _response$payload !== void 0 && _response$payload.control_code) {
        handleLoginWithoutEmail(response.payload.control_code, fields.email);
      } else if (response.code === response_codes/* ResponseCode.Required2FA */.Q.Required2FA && response.payload) {
        (0,utils_window/* navigateToPage */.ru)((0,routes/* CODE_LOGIN */.Le)({
          refUrl: successUrl,
          authProps: response.payload
        }));
      } else {
        if (fields.email) {
          trackError(response.message);
        } else {
          trackError("FB API didn't return an email");
        }

        setIsLoading(false);
        setError(response.message);
      }

      return;
    }

    const getCurrentUserResp = await (0,api/* getCurrentUser */.tse)();
    const userId = 'errors' in getCurrentUserResp ? undefined : getCurrentUserResp.user.id;
    googleTagManagerTrack(google/* GoogleTagManagerEvent.Login */.Nx.Login, {
      auth_type: 'facebook',
      user_email: fields.email
    });
    track((0,events/* authenticateSuccessEvent */.Xi)({
      type: 'facebook',
      userId
    }));
    (0,utils_window/* navigateToPage */.ru)(successUrl);
  }

  function handleFailure() {
    trackError('User closed screen or did not provide permissions');
  }

  return /*#__PURE__*/(0,jsx_runtime.jsx)(FacebookButton_FacebookButton, {
    text: translate('auth.select_type.actions.facebook'),
    isLoading: isLoading,
    onClick: handleClick,
    onSuccess: handleSuccess,
    onFailure: handleFailure
  });
};

/* harmony default export */ var Facebook_Facebook = (Facebook);
// EXTERNAL MODULE: ../app/libs/utils/authentication.ts
var authentication = __webpack_require__(85202);
// EXTERNAL MODULE: ../app/libs/utils/google.ts
var utils_google = __webpack_require__(89523);
;// CONCATENATED MODULE: ../app/components/Auth/GoogleOauthButton/GoogleOauthButton.tsx















const GoogleOauthButton = _ref => {
  let {
    onSuccess,
    onFailure
  } = _ref;
  const {
    0: isLoggingIn,
    1: setIsLoggingIn
  } = (0,react.useState)(false);
  const translate = (0,useTranslate/* default */.Z)('auth.select_type');
  const code = (0,url/* getNormalizedQueryParam */.ZB)('code');
  const state = (0,url/* getNormalizedQueryParam */.ZB)('state');
  const redirectUrl = (0,utils_google/* getGoogleRedirectUrl */.sR)(state);
  const successUrl = (0,useSuccessUrl/* default */.Z)((0,utils_window/* getRelativeUrl */.qC)());
  const {
    track
  } = (0,useTracking/* default */.Z)();
  const oauthUrl = (0,url/* urlWithParams */.Iq)(routes/* GOOGLE_OAUTH_URL */.Tc, {
    redirect_uri: successUrl
  });
  (0,react.useEffect)(() => {
    if (!code || !state || isLoggingIn) return;

    const fetchGoogleToken = async () => {
      const response = await (0,api/* getGoogleIdToken */.IcB)({
        code,
        state
      });

      if ('errors' in response) {
        onFailure();
        return;
      }

      const {
        id_token: token
      } = response;
      const {
        email,
        name
      } = (0,authentication/* decodeJwt */.t)(token);
      onSuccess({
        token,
        fields: {
          name,
          email
        },
        redirectUrl
      });
    };

    setIsLoggingIn(true);
    fetchGoogleToken();
  }, [code, isLoggingIn, redirectUrl, state, onSuccess, onFailure]);

  const handleClick = () => {
    setIsLoggingIn(true);
    track((0,events/* clickEvent */.Q5)({
      target: clickable_elements/* ClickableElement.LoginWithGoogle */.U.LoginWithGoogle
    }));
  };

  return /*#__PURE__*/(0,jsx_runtime.jsx)(Button/* ButtonWithForwardedRef */.I, {
    theme: "amplified",
    iconName: "signup/google",
    onClick: handleClick,
    url: oauthUrl,
    isLoading: isLoggingIn,
    text: translate('actions.google')
  });
};

/* harmony default export */ var GoogleOauthButton_GoogleOauthButton = (GoogleOauthButton);
;// CONCATENATED MODULE: ../app/components/Auth/Google/Google.tsx






















const Google = _ref => {
  let {
    setError
  } = _ref;
  const {
    track
  } = (0,useTracking/* default */.Z)();
  const translate = (0,useTranslate/* default */.Z)('auth.select_type');
  const dispatch = (0,es/* useDispatch */.I0)();
  const {
    googleTagManagerTrack
  } = (0,useGoogleTagManagerTrack/* default */.Z)();
  const isLoginWithoutEmailInModalEnabled = (0,es/* useSelector */.v9)((0,feature_switches_selectors/* getIsFeatureSwitchEnabled */.z)('login_without_email_in_modal'));
  const successUrl = (0,useSuccessUrl/* default */.Z)();

  function handleLoginWithoutEmail(controlCode, email) {
    if (isLoginWithoutEmailInModalEnabled) {
      dispatch(slice/* actions.setExternalRegisterData */.Nw.setExternalRegisterData({
        view: constants/* AuthExternalRegisterView.PasswordVerification */.S4.PasswordVerification,
        data: {
          idToken: controlCode,
          email
        }
      }));
      return;
    }

    (0,utils_window/* navigateToPage */.ru)((0,url/* urlWithParams */.Iq)(routes/* LOGIN_WITHOUT_EMAIL_URL */.ao, {
      control_code: controlCode
    }));
  }

  const handleSuccess = async _ref2 => {
    let {
      token,
      fields: {
        email,
        name
      },
      redirectUrl
    } = _ref2;
    const fingerprint = await (0,utils_fingerprint/* getFingerprint */.f)();
    const response = await (0,account/* authenticateUser */.So)({
      grantType: auth/* AuthenticateGrantType.Assertion */.Gg.Assertion,
      provider: auth/* AuthenticateProvider.Google */.WU.Google,
      assertion: token,
      fingerprint
    });

    if ('errors' in response) {
      var _response$payload; // TODO: handle ResponseCode.SessionFromTokenError


      if (response.code === response_codes/* ResponseCode.NotFound */.Q.NotFound) {
        dispatch(slice/* actions.setExternalRegisterData */.Nw.setExternalRegisterData({
          view: constants/* AuthExternalRegisterView.GoogleRegister */.S4.GoogleRegister,
          data: {
            idToken: token,
            realName: name,
            email
          }
        }));
      } else if (response.code === response_codes/* ResponseCode.LoginWithoutEmail */.Q.LoginWithoutEmail && (_response$payload = response.payload) !== null && _response$payload !== void 0 && _response$payload.control_code) {
        handleLoginWithoutEmail(response.payload.control_code, email);
      } else if (response.code === response_codes/* ResponseCode.Required2FA */.Q.Required2FA && response.payload) {
        (0,utils_window/* navigateToPage */.ru)((0,routes/* CODE_LOGIN */.Le)({
          refUrl: redirectUrl || successUrl,
          authProps: response.payload
        }));
      } else {
        setError(response.message);
      }

      return;
    }

    const getCurrentUserResp = await (0,api/* getCurrentUser */.tse)();
    const userId = 'errors' in getCurrentUserResp ? undefined : getCurrentUserResp.user.id;
    googleTagManagerTrack(google/* GoogleTagManagerEvent.Login */.Nx.Login, {
      auth_type: 'google',
      user_email: email
    });
    track((0,events/* authenticateSuccessEvent */.Xi)({
      type: 'google',
      userId
    }));
    (0,utils_window/* navigateToPage */.ru)(redirectUrl || successUrl);
  };

  const handleFailure = (0,react.useCallback)(() => {
    setError(translate('social_login_error'));
    track((0,events/* authenticateFailEvent */.m2)({
      type: 'google',
      error: 'User closed screen or did not provide permissions'
    }));
  }, [track, setError, translate]);
  return /*#__PURE__*/(0,jsx_runtime.jsx)(GoogleOauthButton_GoogleOauthButton, {
    onSuccess: handleSuccess,
    onFailure: handleFailure
  });
};

/* harmony default export */ var Google_Google = (Google);
// EXTERNAL MODULE: ../node_modules/.pnpm/immer@9.0.14/node_modules/immer/dist/immer.esm.mjs
var immer_esm = __webpack_require__(41581);
;// CONCATENATED MODULE: ../app/libs/utils/apple.ts
const initAppleId = clientId => {
  window.AppleID.auth.init({
    clientId,
    scope: 'name email',
    redirectURI: window.location.origin,
    state: 'init',
    usePopup: true
  });
};
// EXTERNAL MODULE: ../app/libs/utils/script.ts
var script = __webpack_require__(68046);
// EXTERNAL MODULE: ../app/state/next-env/selectors.ts
var next_env_selectors = __webpack_require__(53084);
;// CONCATENATED MODULE: ../app/components/Auth/AppleButton/AppleButton.tsx











const APPLE_SDK_URL = 'https://appleid.cdn-apple.com/appleauth/static/jsapi/appleid/1/en_US/appleid.auth.js';

const AppleButton = _ref => {
  let {
    text,
    isLoading,
    onClick = lodash.noop,
    onSuccess,
    onFailure = lodash.noop
  } = _ref;
  const {
    0: isLoadingAppleID,
    1: setIsLoadingAppleID
  } = (0,react.useState)(false);
  const {
    0: isInitialized,
    1: setIsInitialized
  } = (0,react.useState)(false);
  const clientId = (0,es/* useSelector */.v9)(next_env_selectors/* getAppleClientId */.$G);
  const onSuccessRef = (0,react.useRef)(onSuccess);
  onSuccessRef.current = onSuccess;
  const onFailureRef = (0,react.useRef)(onFailure);
  onFailureRef.current = onFailure;
  const handleAppleSignInSuccess = (0,react.useCallback)(event => {
    const {
      detail
    } = event;
    const {
      email,
      is_private_email = false
    } = (0,authentication/* decodeJwt */.t)(detail.authorization.id_token);
    const newDetail = (0,immer_esm/* produce */.Uy)(detail, draft => {
      if (is_private_email || !email || draft.user) return;
      draft.user = {
        name: {
          firstName: '',
          lastName: ''
        },
        email
      };
    });
    onSuccessRef.current(newDetail);
    setIsLoadingAppleID(false);
  }, []);
  const handleAppleSignInFailure = (0,react.useCallback)(() => {
    onFailureRef.current();
    setIsLoadingAppleID(false);
  }, []);
  (0,react.useEffect)(() => {
    document.addEventListener(auth/* AppleIDLoginStatus.Success */.m2.Success, handleAppleSignInSuccess);
    document.addEventListener(auth/* AppleIDLoginStatus.Failure */.m2.Failure, handleAppleSignInFailure);
    return () => {
      document.removeEventListener(auth/* AppleIDLoginStatus.Success */.m2.Success, handleAppleSignInSuccess);
      document.removeEventListener(auth/* AppleIDLoginStatus.Failure */.m2.Failure, handleAppleSignInFailure);
    };
  }, [handleAppleSignInFailure, handleAppleSignInSuccess]);
  (0,react.useEffect)(() => {
    async function initialize() {
      if (!clientId) return;
      await (0,script/* loadScript */.v)({
        id: 'apple-sdk',
        isAsync: true,
        src: APPLE_SDK_URL
      });
      initAppleId(clientId);
      setIsInitialized(true);
    }

    initialize();
  }, [clientId]);

  function handleClick() {
    var _window$AppleID;

    onClick();
    setIsLoadingAppleID(true);
    (_window$AppleID = window.AppleID) === null || _window$AppleID === void 0 ? void 0 : _window$AppleID.auth.signIn();
  }

  if (!clientId) return null;
  return /*#__PURE__*/(0,jsx_runtime.jsx)(Button/* ButtonWithForwardedRef */.I, {
    theme: "amplified",
    iconName: "signup/apple",
    iconPosition: Button/* ButtonWithForwardedRef.IconPosition.Left */.I.IconPosition.Left,
    onClick: handleClick,
    disabled: !isInitialized || isLoading || isLoadingAppleID,
    isLoading: isLoading || isLoadingAppleID,
    text: text
  });
};

/* harmony default export */ var AppleButton_AppleButton = (AppleButton);
;// CONCATENATED MODULE: ../app/components/Auth/Apple/Apple.tsx























const Apple = _ref => {
  let {
    setError
  } = _ref;
  const {
    track
  } = (0,useTracking/* default */.Z)();
  const translate = (0,useTranslate/* default */.Z)();
  const dispatch = (0,es/* useDispatch */.I0)();
  const isLoginWithoutEmailInModalEnabled = (0,es/* useSelector */.v9)((0,feature_switches_selectors/* getIsFeatureSwitchEnabled */.z)('login_without_email_in_modal'));
  const {
    googleTagManagerTrack
  } = (0,useGoogleTagManagerTrack/* default */.Z)();
  const {
    0: isLoading,
    1: setIsLoading
  } = (0,react.useState)(false);
  const successUrl = (0,useSuccessUrl/* default */.Z)();

  function handleClick() {
    track((0,events/* clickEvent */.Q5)({
      target: clickable_elements/* ClickableElement.LoginWithApple */.U.LoginWithApple
    }));
  }

  function trackError(message) {
    track((0,events/* authenticateFailEvent */.m2)({
      type: 'apple',
      error: message
    }));
  }

  function setExternalRegisterData(idToken, user) {
    dispatch(slice/* actions.setExternalRegisterData */.Nw.setExternalRegisterData({
      view: constants/* AuthExternalRegisterView.AppleRegister */.S4.AppleRegister,
      data: {
        idToken,
        realName: (user === null || user === void 0 ? void 0 : user.name) && "".concat(user.name.firstName, " ").concat(user.name.lastName),
        email: user === null || user === void 0 ? void 0 : user.email
      }
    }));
  }

  function handleLoginWithoutEmail(controlCode, email) {
    if (isLoginWithoutEmailInModalEnabled) {
      dispatch(slice/* actions.setExternalRegisterData */.Nw.setExternalRegisterData({
        view: constants/* AuthExternalRegisterView.PasswordVerification */.S4.PasswordVerification,
        data: {
          idToken: controlCode,
          email
        }
      }));
      return;
    }

    (0,utils_window/* navigateToPage */.ru)((0,url/* urlWithParams */.Iq)(routes/* LOGIN_WITHOUT_EMAIL_URL */.ao, {
      control_code: controlCode
    }));
  }

  async function handleSuccess(_ref2) {
    let {
      authorization: {
        id_token
      },
      user
    } = _ref2;
    setIsLoading(true);
    const fingerprint = await (0,utils_fingerprint/* getFingerprint */.f)();
    const response = await (0,account/* authenticateUser */.So)({
      grantType: auth/* AuthenticateGrantType.Assertion */.Gg.Assertion,
      provider: auth/* AuthenticateProvider.Apple */.WU.Apple,
      assertion: id_token,
      fingerprint
    });

    if ('errors' in response) {
      var _response$payload; // TODO: handle ResponseCode.SessionFromTokenError


      if (response.code === response_codes/* ResponseCode.NotFound */.Q.NotFound || response.code === response_codes/* ResponseCode.ValidationError */.Q.ValidationError) {
        setExternalRegisterData(id_token, user);
      } else if (response.code === response_codes/* ResponseCode.LoginWithoutEmail */.Q.LoginWithoutEmail && (_response$payload = response.payload) !== null && _response$payload !== void 0 && _response$payload.control_code) {
        handleLoginWithoutEmail(response.payload.control_code, user === null || user === void 0 ? void 0 : user.email);
      } else if (response.code === response_codes/* ResponseCode.Required2FA */.Q.Required2FA && response.payload) {
        (0,utils_window/* navigateToPage */.ru)((0,routes/* CODE_LOGIN */.Le)({
          refUrl: successUrl,
          authProps: response.payload
        }));
      } else {
        setError(response.message);
        setIsLoading(false);
      }

      return;
    }

    const getCurrentUserResp = await (0,api/* getCurrentUser */.tse)();
    const userId = 'errors' in getCurrentUserResp ? undefined : getCurrentUserResp.user.id;
    googleTagManagerTrack(google/* GoogleTagManagerEvent.Login */.Nx.Login, {
      auth_type: 'apple',
      user_email: user === null || user === void 0 ? void 0 : user.email
    });
    track((0,events/* authenticateSuccessEvent */.Xi)({
      type: 'apple',
      userId
    }));
    (0,utils_window/* navigateToPage */.ru)(successUrl);
  }

  function handleFailure() {
    trackError('User closed screen or did not provide permissions');
  }

  return /*#__PURE__*/(0,jsx_runtime.jsx)(AppleButton_AppleButton, {
    text: translate('auth.select_type.actions.apple'),
    isLoading: isLoading,
    onClick: handleClick,
    onSuccess: handleSuccess,
    onFailure: handleFailure
  });
};

/* harmony default export */ var Apple_Apple = (Apple);
// EXTERNAL MODULE: ../node_modules/.pnpm/@vinted+web-ui@34.8.0_29a9e79dfb0433562b4e854f8f07c904/node_modules/@vinted/web-ui/dist/esm/lib/Divider/Divider.js
var Divider = __webpack_require__(44456);
;// CONCATENATED MODULE: ../app/components/Auth/SelectType/BusinessRegistrationsLink/BusinessRegistrationLink.tsx








const BusinessRegistrationLink = () => {
  const isLoginView = (0,es/* useSelector */.v9)(selectors/* getIsSelectTypeLogin */.Hi);
  const isBusinessRegistrationLinkVisible = (0,es/* useSelector */.v9)(selectors/* getIsBusinessRegistrationLinkVisible */._z);
  const translate = (0,useTranslate/* default */.Z)();
  if (!isBusinessRegistrationLinkVisible || isLoginView) return null;
  return /*#__PURE__*/(0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
    children: [/*#__PURE__*/(0,jsx_runtime.jsx)(Divider/* default */.Z, {}), /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
      className: "u-ui-padding-horizontal-large u-ui-padding-vertical-x-large",
      children: /*#__PURE__*/(0,jsx_runtime.jsx)(Text/* default */.Z, {
        type: Text/* default.Type.Caption */.Z.Type.Caption,
        alignment: Text/* default.Alignment.Center */.Z.Alignment.Center,
        text: translate('auth.select_type.register.are_you_a_business'),
        width: Text/* default.Width.Parent */.Z.Width.Parent,
        html: true
      })
    })]
  });
};

/* harmony default export */ var BusinessRegistrationsLink_BusinessRegistrationLink = (BusinessRegistrationLink);
// EXTERNAL MODULE: ../app/data/utils/a11y.ts
var a11y = __webpack_require__(83797);
;// CONCATENATED MODULE: ../app/components/Auth/SelectType/SelectTypeFooter/SelectTypeFooter.tsx














const SelectTypeFooter = () => {
  const isLoginView = (0,es/* useSelector */.v9)(selectors/* getIsSelectTypeLogin */.Hi);
  const dispatch = (0,es/* useDispatch */.I0)();
  const selectType = isLoginView ? 'login' : 'register';
  const translate = (0,useTranslate/* default */.Z)("auth.select_type.".concat(selectType));

  function handleSwitchContext() {
    dispatch(slice/* actions.setAuthView */.Nw.setAuthView({
      authView: isLoginView ? constants/* AuthView.SelectTypeRegister */.GT.SelectTypeRegister : constants/* AuthView.SelectTypeLogin */.GT.SelectTypeLogin
    }));
  }

  function proceedToEmailLogin() {
    dispatch(slice/* actions.setAuthView */.Nw.setAuthView({
      authView: constants/* AuthView.EmailLogin */.GT.EmailLogin
    }));
  }

  function proceedToEmailRegister() {
    const hostRedirectUrl = (0,url/* getOldHostRedirectUrl */.E_)();

    if (hostRedirectUrl) {
      (0,utils_window/* navigateToPage */.ru)("".concat(hostRedirectUrl).concat(routes/* REGISTER_URL */.jg));
      return;
    }

    dispatch(slice/* actions.setAuthView */.Nw.setAuthView({
      authView: constants/* AuthView.EmailRegister */.GT.EmailRegister
    }));
  }

  function handleProceedLinkClick() {
    if (isLoginView) {
      proceedToEmailLogin();
    } else {
      proceedToEmailRegister();
    }
  }

  return /*#__PURE__*/(0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
    children: [/*#__PURE__*/(0,jsx_runtime.jsxs)(Text/* default */.Z, {
      width: Text/* default.Width.Parent */.Z.Width.Parent,
      alignment: Text/* default.Alignment.Center */.Z.Alignment.Center,
      children: [translate('actions.proceed.title'), /*#__PURE__*/(0,jsx_runtime.jsx)(Spacer/* default */.Z, {
        orientation: Spacer/* default.Orientation.Vertical */.Z.Orientation.Vertical,
        size: Spacer/* default.Size.Small */.Z.Size.Small
      }), /*#__PURE__*/(0,jsx_runtime.jsx)("span", {
        role: "button",
        onKeyDown: a11y/* onA11yKeyDown */.D,
        className: "u-cursor-pointer",
        tabIndex: 0,
        onClick: handleProceedLinkClick,
        "data-testid": "auth-select-type--".concat(selectType, "-email"),
        children: /*#__PURE__*/(0,jsx_runtime.jsx)(Text/* default */.Z, {
          text: translate('actions.proceed.link'),
          theme: "primary"
        })
      })]
    }), /*#__PURE__*/(0,jsx_runtime.jsx)(Spacer/* default */.Z, {}), /*#__PURE__*/(0,jsx_runtime.jsxs)(Text/* default */.Z, {
      width: Text/* default.Width.Parent */.Z.Width.Parent,
      alignment: Text/* default.Alignment.Center */.Z.Alignment.Center,
      children: [translate('actions.switch.title'), /*#__PURE__*/(0,jsx_runtime.jsx)(Spacer/* default */.Z, {
        orientation: Spacer/* default.Orientation.Vertical */.Z.Orientation.Vertical,
        size: Spacer/* default.Size.Small */.Z.Size.Small
      }), /*#__PURE__*/(0,jsx_runtime.jsx)("span", {
        role: "button",
        onClick: handleSwitchContext,
        onKeyDown: a11y/* onA11yKeyDown */.D,
        className: "u-cursor-pointer",
        tabIndex: 0,
        "data-testid": "auth-select-type--".concat(selectType, "-switch"),
        children: /*#__PURE__*/(0,jsx_runtime.jsx)(Text/* default */.Z, {
          text: translate('actions.switch.link'),
          theme: "primary"
        })
      })]
    })]
  });
};

/* harmony default export */ var SelectTypeFooter_SelectTypeFooter = (SelectTypeFooter);
// EXTERNAL MODULE: ../node_modules/.pnpm/@vinted+web-ui@34.8.0_29a9e79dfb0433562b4e854f8f07c904/node_modules/@vinted/web-ui/dist/esm/lib/Image/Image.js
var Image = __webpack_require__(10852);
// EXTERNAL MODULE: ../node_modules/.pnpm/@vinted+web-ui@34.8.0_29a9e79dfb0433562b4e854f8f07c904/node_modules/@vinted/web-ui/dist/esm/lib/Rating/Rating.js
var Rating = __webpack_require__(10556);
// EXTERNAL MODULE: ../app/components/UserImage/UserImage.tsx
var UserImage = __webpack_require__(77152);
// EXTERNAL MODULE: ../app/components/UserTitle/UserTitle.tsx
var UserTitle = __webpack_require__(46927);
// EXTERNAL MODULE: ../app/data/utils/user.ts
var user = __webpack_require__(70300);
;// CONCATENATED MODULE: ../app/components/Auth/SelectType/SelectTypeHeader/SelectTypeHeader.tsx












const SelectTypeHeader = _ref => {
  var _referrer$photo, _referrer$business_ac;

  let {
    referrer
  } = _ref;
  const isLoginView = (0,es/* useSelector */.v9)(selectors/* getIsSelectTypeLogin */.Hi);
  const isBusinessAuth = (0,es/* useSelector */.v9)(selectors/* getIsBusinessAuth */.Uc);
  const authTranslate = (0,useTranslate/* default */.Z)("auth.select_type.".concat(isLoginView ? 'login' : 'register'));
  const businessTranslate = (0,useTranslate/* default */.Z)('business.account');
  const userFeedbackTranslate = (0,useTranslate/* default */.Z)('user.feedback');

  const renderSubtitle = () => {
    if (!isBusinessAuth) return null;
    return /*#__PURE__*/(0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
      children: [/*#__PURE__*/(0,jsx_runtime.jsx)(Spacer/* default */.Z, {
        size: Spacer/* default.Size.Large */.Z.Size.Large
      }), /*#__PURE__*/(0,jsx_runtime.jsx)(Text/* default */.Z, {
        width: Text/* default.Width.Parent */.Z.Width.Parent,
        alignment: Text/* default.Alignment.Center */.Z.Alignment.Center,
        children: businessTranslate('subtitle')
      })]
    });
  };

  const renderTitle = () => {
    return /*#__PURE__*/(0,jsx_runtime.jsx)(Text/* default */.Z, {
      id: "auth_modal_title",
      text: isBusinessAuth ? businessTranslate('title') : authTranslate('title'),
      type: Text/* default.Type.Heading */.Z.Type.Heading,
      alignment: Text/* default.Alignment.Center */.Z.Alignment.Center,
      width: Text/* default.Width.Parent */.Z.Width.Parent
    });
  };

  if (!referrer || isLoginView) {
    return /*#__PURE__*/(0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
      children: [renderTitle(), renderSubtitle()]
    });
  }

  const rating = (0,user/* calculateRating */.pJ)(referrer.feedback_reputation);
  return /*#__PURE__*/(0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
    children: [/*#__PURE__*/(0,jsx_runtime.jsx)("div", {
      className: "u-flexbox u-justify-content-center",
      children: /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
        children: /*#__PURE__*/(0,jsx_runtime.jsx)(Cell/* default */.Z, {
          clickable: true,
          styling: Cell/* default.Styling.Tight */.Z.Styling.Tight,
          prefix: /*#__PURE__*/(0,jsx_runtime.jsx)(UserImage/* default */.Z, {
            src: (_referrer$photo = referrer.photo) === null || _referrer$photo === void 0 ? void 0 : _referrer$photo.url,
            styling: Image/* ImageWithForwardedRef.Styling.Circle */.U.Styling.Circle,
            size: Image/* ImageWithForwardedRef.Size.Large */.U.Size.Large
          }),
          title: /*#__PURE__*/(0,jsx_runtime.jsx)(UserTitle/* default */.Z, {
            businessAccountName: (_referrer$business_ac = referrer.business_account) === null || _referrer$business_ac === void 0 ? void 0 : _referrer$business_ac.name,
            login: referrer.login,
            isBusiness: referrer.business,
            isBody: true,
            isBottomLoginHidden: true,
            isBadgeHidden: true
          }),
          url: (0,routes/* MEMBER_PROFILE_URL */.G0)(referrer.id),
          children: /*#__PURE__*/(0,jsx_runtime.jsx)(Rating/* default */.Z, {
            value: rating,
            text: userFeedbackTranslate('reviews', {
              count: referrer.feedback_count
            }, {
              count: referrer.feedback_count
            }),
            size: Rating/* default.Size.Regular */.Z.Size.Regular,
            emptyStateText: userFeedbackTranslate('no_reviews')
          })
        })
      })
    }), /*#__PURE__*/(0,jsx_runtime.jsx)(Spacer/* default */.Z, {
      size: Spacer/* default.Size.Large */.Z.Size.Large
    }), /*#__PURE__*/(0,jsx_runtime.jsx)(Text/* default */.Z, {
      text: authTranslate('referrer_title', {
        username: referrer.login
      }),
      type: Text/* default.Type.Heading */.Z.Type.Heading,
      alignment: Text/* default.Alignment.Center */.Z.Alignment.Center,
      width: Text/* default.Width.Parent */.Z.Width.Parent
    })]
  });
};

/* harmony default export */ var SelectTypeHeader_SelectTypeHeader = (SelectTypeHeader);
;// CONCATENATED MODULE: ../app/components/Auth/SelectType/SelectType.tsx




















const SelectType = () => {
  const referrerId = (0,es/* useSelector */.v9)(selectors/* getReferrerId */.VG);
  const isRandomUserSignupEnabled = (0,es/* useSelector */.v9)(selectors/* getIsRandomUserSignupEnabled */.LP);
  const isRegisterView = !(0,es/* useSelector */.v9)(selectors/* getIsSelectTypeLogin */.Hi);
  const {
    googleAnalyticsTrack
  } = (0,useGoogleTagManagerTrack/* default */.Z)();
  const {
    0: error,
    1: setError
  } = (0,react.useState)();
  const {
    0: hasReferralError,
    1: setHasReferralError
  } = (0,react.useState)(false);
  const {
    0: referrer,
    1: setReferrer
  } = (0,react.useState)(null);
  const loadReferrer = isRegisterView && referrerId && (referrer === null || referrer === void 0 ? void 0 : referrer.id) !== referrerId;
  (0,react.useEffect)(() => {
    function pushGoogleAnalyticsEvent() {
      if (isRegisterView) {
        googleAnalyticsTrack({
          event: google/* GoogleTagManagerEvent.modalView */.Nx.modalView,
          customTagObject: {
            formName: google/* FormName.Register */.GY.Register,
            pageType: google/* PageType.Registration */.GV.Registration
          }
        });
      } else {
        googleAnalyticsTrack({
          event: google/* GoogleTagManagerEvent.modalView */.Nx.modalView,
          customTagObject: {
            formName: google/* FormName.Login */.GY.Login,
            pageType: google/* PageType.Login */.GV.Login
          }
        });
      }
    }

    pushGoogleAnalyticsEvent();
  }, [isRegisterView, googleAnalyticsTrack]);
  (0,react.useEffect)(() => {
    if (!loadReferrer) return;

    async function fetchUser() {
      if (!referrerId) return;
      const response = await (0,api/* getUserById */.GAF)({
        id: referrerId
      });

      if ('errors' in response) {
        setHasReferralError(true);
        return;
      }

      setReferrer(response.user);
    }

    fetchUser();
  }, [loadReferrer, referrerId]);

  if (!hasReferralError && loadReferrer) {
    return /*#__PURE__*/(0,jsx_runtime.jsx)(ContentLoader/* default */.Z, {
      styling: ContentLoader/* default.Styling.Wide */.Z.Styling.Wide,
      size: ContentLoader/* default.Size.Large */.Z.Size.Large,
      testId: "select-type-loader"
    });
  }

  return /*#__PURE__*/(0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
    children: [/*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
      className: "u-ui-padding-horizontal-large u-ui-padding-bottom-x-large",
      children: [/*#__PURE__*/(0,jsx_runtime.jsx)(SelectTypeHeader_SelectTypeHeader, {
        referrer: referrer
      }), /*#__PURE__*/(0,jsx_runtime.jsx)(Spacer/* default */.Z, {}), error && /*#__PURE__*/(0,jsx_runtime.jsx)(Text/* default */.Z, {
        text: error,
        theme: "warning",
        width: Text/* default.Width.Parent */.Z.Width.Parent,
        alignment: Text/* default.Alignment.Center */.Z.Alignment.Center
      }), /*#__PURE__*/(0,jsx_runtime.jsx)(Spacer/* default */.Z, {
        size: Spacer/* default.Size.Large */.Z.Size.Large
      }), /*#__PURE__*/(0,jsx_runtime.jsxs)(SeparatedList/* default */.Z, {
        separator: /*#__PURE__*/(0,jsx_runtime.jsx)(Spacer/* default */.Z, {}),
        children: [/*#__PURE__*/(0,jsx_runtime.jsx)(Facebook_Facebook, {
          setError: setError
        }), /*#__PURE__*/(0,jsx_runtime.jsx)(Google_Google, {
          setError: setError
        }), /*#__PURE__*/(0,jsx_runtime.jsx)(Apple_Apple, {
          setError: setError
        }), isRandomUserSignupEnabled && isRegisterView && /*#__PURE__*/(0,jsx_runtime.jsx)(RandomUserSignup_RandomUserSignup, {})]
      }), /*#__PURE__*/(0,jsx_runtime.jsx)(Spacer/* default */.Z, {
        size: Spacer/* default.Size.XLarge */.Z.Size.XLarge
      }), /*#__PURE__*/(0,jsx_runtime.jsx)(SelectTypeFooter_SelectTypeFooter, {})]
    }), isRegisterView && /*#__PURE__*/(0,jsx_runtime.jsx)(BusinessRegistrationsLink_BusinessRegistrationLink, {})]
  });
};

/* harmony default export */ var SelectType_SelectType = (SelectType);
// EXTERNAL MODULE: ../node_modules/.pnpm/react-hook-form@7.33.0_react@17.0.2/node_modules/react-hook-form/dist/index.esm.mjs
var index_esm = __webpack_require__(57898);
// EXTERNAL MODULE: ../app/hooks/useDatadomeCaptcha.ts
var useDatadomeCaptcha = __webpack_require__(54403);
// EXTERNAL MODULE: ../app/components/Captcha/Captcha.tsx
var Captcha = __webpack_require__(15585);
// EXTERNAL MODULE: ../app/components/Auth/PasswordField/PasswordField.tsx
var PasswordField = __webpack_require__(47722);
;// CONCATENATED MODULE: ../app/components/Auth/EmailLogin/EmailLogin.tsx


function ownKeys(object, enumerableOnly) {
  var keys = Object.keys(object);

  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object);
    enumerableOnly && (symbols = symbols.filter(function (sym) {
      return Object.getOwnPropertyDescriptor(object, sym).enumerable;
    })), keys.push.apply(keys, symbols);
  }

  return keys;
}

function _objectSpread(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = null != arguments[i] ? arguments[i] : {};
    i % 2 ? ownKeys(Object(source), !0).forEach(function (key) {
      (0,defineProperty/* default */.Z)(target, key, source[key]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) {
      Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
    });
  }

  return target;
}




























const EmailLogin = () => {
  const {
    login
  } = (0,url/* toParams */.oZ)((0,utils_window/* getUrlQuery */.pf)());
  const username = typeof login === 'string' ? login : undefined;
  const isUuidValidationEnabled = (0,es/* useSelector */.v9)((0,feature_switches_selectors/* getIsFeatureSwitchEnabled */.z)('user_captcha_uuid_validate'));
  const {
    0: isLoading,
    1: setIsLoading
  } = (0,react.useState)(false);
  const dispatch = (0,es/* useDispatch */.I0)();
  const translate = (0,useTranslate/* default */.Z)('auth.email.login');
  const {
    register,
    handleSubmit
  } = (0,index_esm/* useForm */.cI)({
    defaultValues: {
      username
    }
  });
  const {
    googleTagManagerTrack
  } = (0,useGoogleTagManagerTrack/* default */.Z)();
  const {
    0: error,
    1: setError
  } = (0,react.useState)('');
  const {
    0: isCaptchaVisible,
    1: setIsCaptchaVisible
  } = (0,react.useState)(false);
  const {
    0: isCaptchaResolved,
    1: setIsCaptchaResolved
  } = (0,react.useState)(false);
  const {
    0: uuid,
    1: setUuid
  } = (0,react.useState)('');
  const {
    0: formData,
    1: setFormData
  } = (0,react.useState)();
  const successUrl = (0,useSuccessUrl/* default */.Z)();

  function handleForgotPasswordClick(event) {
    event.preventDefault();
    dispatch(slice/* actions.setAuthView */.Nw.setAuthView({
      authView: constants/* AuthView.ResetPassword */.GT.ResetPassword
    }));
  }

  async function performLogin(data, captchaUuid) {
    const fingerprint = await (0,utils_fingerprint/* getFingerprint */.f)();

    const authenticateUserArgs = _objectSpread({
      grantType: auth/* AuthenticateGrantType.Password */.Gg.Password,
      fingerprint
    }, data);

    if (isUuidValidationEnabled) {
      authenticateUserArgs.uuid = captchaUuid;
    }

    const response = await (0,account/* authenticateUser */.So)(authenticateUserArgs);

    if (response.code === response_codes/* ResponseCode.Required2FA */.Q.Required2FA && 'payload' in response && response.payload) {
      (0,utils_window/* navigateToPage */.ru)((0,routes/* CODE_LOGIN */.Le)({
        refUrl: successUrl,
        authProps: response.payload
      }));
      return;
    }

    if ('errors' in response) {
      // TODO: handle ResponseCode.SessionFromTokenError
      setError(response.message);
      setIsCaptchaVisible(false);
      setIsCaptchaResolved(false);
      setIsLoading(false);
      return;
    }

    const userResp = await (0,api/* getCurrentUser */.tse)();
    const user = 'errors' in userResp ? null : userResp.user;
    googleTagManagerTrack(google/* GoogleTagManagerEvent.Login */.Nx.Login, {
      auth_type: 'email',
      user_email: user === null || user === void 0 ? void 0 : user.email
    });
    (0,utils_window/* navigateToPage */.ru)(successUrl);
  }

  async function handleFormSubmit(data) {
    setIsLoading(true);
    setError('');
    setFormData(data);
    const captchaResponse = await (0,api/* getCaptchaVerification */.Xkj)({
      entityType: 'login',
      payload: {
        username: data.username
      }
    });
    if ('errors' in captchaResponse) return;

    if (!captchaResponse.verified) {
      setUuid(captchaResponse.uuid);
      setIsCaptchaVisible(true);
      return;
    }

    performLogin(data, captchaResponse.uuid);
  }

  (0,useDatadomeCaptcha/* default */.Z)(() => {
    if (!formData) return;
    handleFormSubmit(formData);
  });

  async function handleCaptchaComplete(key) {
    if (!formData) return;
    setIsCaptchaResolved(true);
    const verifyResponse = await (0,api/* verifyCaptcha */.SwO)({
      uuid,
      captchaToken: key
    });

    if ('errors' in verifyResponse || !verifyResponse.verified) {
      (0,utils_window/* reloadPage */.sl)();
      return;
    }

    performLogin(formData, verifyResponse.uuid);
  }

  function renderDescription() {
    return /*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
      className: "u-ui-margin-horizontal-large",
      children: [/*#__PURE__*/(0,jsx_runtime.jsx)(Text/* default */.Z, {
        id: "auth_modal_title",
        text: translate('title'),
        type: Text/* default.Type.Heading */.Z.Type.Heading,
        width: Text/* default.Width.Parent */.Z.Width.Parent,
        alignment: Text/* default.Alignment.Center */.Z.Alignment.Center
      }), /*#__PURE__*/(0,jsx_runtime.jsx)(Spacer/* default */.Z, {
        size: Spacer/* default.Size.Large */.Z.Size.Large
      }), !!error && /*#__PURE__*/(0,jsx_runtime.jsx)(Text/* default */.Z, {
        text: error,
        theme: "warning",
        width: Text/* default.Width.Parent */.Z.Width.Parent,
        alignment: Text/* default.Alignment.Center */.Z.Alignment.Center
      })]
    });
  }

  function renderFields() {
    return /*#__PURE__*/(0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
      children: [/*#__PURE__*/(0,jsx_runtime.jsx)(InputText/* InputTextWithForwardedRef */.M, _objectSpread(_objectSpread({}, register('username', {
        required: true
      })), {}, {
        placeholder: translate('fields.login'),
        uncontrolled: true,
        disabled: !!username
      })), !!username && /*#__PURE__*/(0,jsx_runtime.jsx)("input", _objectSpread(_objectSpread({
        type: "hidden"
      }, register('username')), {}, {
        value: username
      })), /*#__PURE__*/(0,jsx_runtime.jsx)(PasswordField/* default */.Z, _objectSpread(_objectSpread({}, register('password', {
        required: true
      })), {}, {
        placeholder: translate('fields.password'),
        uncontrolled: true
      }))]
    });
  }

  function renderActions() {
    return /*#__PURE__*/(0,jsx_runtime.jsxs)(Cell/* default */.Z, {
      children: [/*#__PURE__*/(0,jsx_runtime.jsx)(Button/* ButtonWithForwardedRef */.I, {
        text: translate('actions.submit'),
        type: Button/* ButtonWithForwardedRef.Type.Submit */.I.Type.Submit,
        styling: Button/* ButtonWithForwardedRef.Styling.Filled */.I.Styling.Filled,
        disabled: isLoading,
        isLoading: isLoading
      }), /*#__PURE__*/(0,jsx_runtime.jsx)(Spacer/* default */.Z, {
        size: Spacer/* default.Size.XLarge */.Z.Size.XLarge
      }), /*#__PURE__*/(0,jsx_runtime.jsx)(Text/* default */.Z, {
        width: Text/* default.Width.Parent */.Z.Width.Parent,
        alignment: Text/* default.Alignment.Center */.Z.Alignment.Center,
        children: /*#__PURE__*/(0,jsx_runtime.jsx)("a", {
          href: routes/* FORGOT_PASSWORD_URL */.If,
          onClick: handleForgotPasswordClick,
          children: translate('actions.forgot_password')
        })
      }), /*#__PURE__*/(0,jsx_runtime.jsx)(Spacer/* default */.Z, {
        size: Spacer/* default.Size.Medium */.Z.Size.Medium
      }), /*#__PURE__*/(0,jsx_runtime.jsx)(Text/* default */.Z, {
        width: Text/* default.Width.Parent */.Z.Width.Parent,
        alignment: Text/* default.Alignment.Center */.Z.Alignment.Center,
        children: /*#__PURE__*/(0,jsx_runtime.jsx)("a", {
          href: routes/* SIGNUP_HELP_ENTRIES_URL */.XQ,
          children: translate('actions.help')
        })
      }), /*#__PURE__*/(0,jsx_runtime.jsx)(Spacer/* default */.Z, {})]
    });
  }

  if (isCaptchaVisible) {
    return /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
      className: "u-ui-padding-large",
      children: isCaptchaResolved ? /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
        className: "u-ui-padding-bottom-x2-large",
        children: /*#__PURE__*/(0,jsx_runtime.jsx)(ContentLoader/* default */.Z, {
          styling: ContentLoader/* default.Styling.Wide */.Z.Styling.Wide
        })
      }) : /*#__PURE__*/(0,jsx_runtime.jsx)(Captcha/* default */.Z, {
        onComplete: handleCaptchaComplete
      })
    });
  }

  return /*#__PURE__*/(0,jsx_runtime.jsxs)("form", {
    onSubmit: handleSubmit(handleFormSubmit),
    children: [renderDescription(), renderFields(), /*#__PURE__*/(0,jsx_runtime.jsx)(Spacer/* default */.Z, {}), renderActions()]
  });
};

/* harmony default export */ var EmailLogin_EmailLogin = (EmailLogin);
// EXTERNAL MODULE: ../app/components/Auth/EmailRegister/EmailRegister.tsx
var EmailRegister = __webpack_require__(37980);
// EXTERNAL MODULE: ../app/components/Input/renderValidation.tsx
var renderValidation = __webpack_require__(43968);
// EXTERNAL MODULE: ../app/hooks/useFormValidationMessage.ts
var useFormValidationMessage = __webpack_require__(55298);
;// CONCATENATED MODULE: ../app/components/Auth/ResetPassword/ResetPassword.tsx


function ResetPassword_ownKeys(object, enumerableOnly) {
  var keys = Object.keys(object);

  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object);
    enumerableOnly && (symbols = symbols.filter(function (sym) {
      return Object.getOwnPropertyDescriptor(object, sym).enumerable;
    })), keys.push.apply(keys, symbols);
  }

  return keys;
}

function ResetPassword_objectSpread(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = null != arguments[i] ? arguments[i] : {};
    i % 2 ? ResetPassword_ownKeys(Object(source), !0).forEach(function (key) {
      (0,defineProperty/* default */.Z)(target, key, source[key]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ResetPassword_ownKeys(Object(source)).forEach(function (key) {
      Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
    });
  }

  return target;
}











const TRANSLATION_PREFIX = 'auth.forgot_password';

const ResetPassword = () => {
  const {
    register,
    handleSubmit,
    getValues,
    formState: {
      isSubmitting,
      errors
    }
  } = (0,index_esm/* useForm */.cI)();
  const translate = (0,useTranslate/* default */.Z)(TRANSLATION_PREFIX);
  const getErrorMessage = (0,useFormValidationMessage/* default */.Z)(errors, "".concat(TRANSLATION_PREFIX, ".fields"));
  const {
    0: showSuccess,
    1: setShowSuccess
  } = (0,react.useState)(false);

  async function handleFormSubmit(_ref) {
    let {
      email
    } = _ref;
    await (0,account/* resetPassword */.c0)({
      email
    });
    setShowSuccess(true);
  }

  (0,useDatadomeCaptcha/* default */.Z)(() => {
    handleFormSubmit(getValues());
  });
  return /*#__PURE__*/(0,jsx_runtime.jsxs)("form", {
    onSubmit: handleSubmit(handleFormSubmit),
    children: [/*#__PURE__*/(0,jsx_runtime.jsx)("div", {
      className: "u-ui-padding-horizontal-large",
      children: /*#__PURE__*/(0,jsx_runtime.jsx)(Text/* default */.Z, {
        id: "auth_modal_title",
        text: translate('title'),
        type: Text/* default.Type.Heading */.Z.Type.Heading,
        width: Text/* default.Width.Parent */.Z.Width.Parent,
        alignment: Text/* default.Alignment.Center */.Z.Alignment.Center
      })
    }), /*#__PURE__*/(0,jsx_runtime.jsx)(Spacer/* default */.Z, {
      size: Spacer/* default.Size.Large */.Z.Size.Large
    }), showSuccess && /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
      className: "u-ui-padding-horizontal-large",
      children: /*#__PURE__*/(0,jsx_runtime.jsx)(Card/* default */.Z, {
        children: /*#__PURE__*/(0,jsx_runtime.jsx)(Cell/* default */.Z, {
          prefix: /*#__PURE__*/(0,jsx_runtime.jsx)(Icon/* default */.Z, {
            name: "check-circle-filled",
            color: Icon/* default.Color.Green */.Z.Color.Green
          }),
          body: translate('success_note')
        })
      })
    }), /*#__PURE__*/(0,jsx_runtime.jsx)(Spacer/* default */.Z, {}), /*#__PURE__*/(0,jsx_runtime.jsx)(InputText/* InputTextWithForwardedRef */.M, ResetPassword_objectSpread(ResetPassword_objectSpread({}, register('email', {
      required: true
    })), {}, {
      placeholder: translate('fields.email.title'),
      validation: (0,renderValidation/* default */.Z)(getErrorMessage('email')),
      uncontrolled: true
    })), /*#__PURE__*/(0,jsx_runtime.jsx)(Cell/* default */.Z, {
      children: /*#__PURE__*/(0,jsx_runtime.jsx)(Button/* ButtonWithForwardedRef */.I, {
        text: translate('actions.submit'),
        type: Button/* ButtonWithForwardedRef.Type.Submit */.I.Type.Submit,
        styling: Button/* ButtonWithForwardedRef.Styling.Filled */.I.Styling.Filled,
        disabled: isSubmitting,
        isLoading: isSubmitting
      })
    })]
  });
};

/* harmony default export */ var ResetPassword_ResetPassword = (ResetPassword);
// EXTERNAL MODULE: ../app/components/Auth/RegisterForm/RegisterForm.tsx + 3 modules
var RegisterForm = __webpack_require__(42500);
// EXTERNAL MODULE: ../app/components/Auth/hooks/useRegistrationTracking.ts
var useRegistrationTracking = __webpack_require__(29908);
;// CONCATENATED MODULE: ../app/components/Auth/FacebookRegister/FacebookRegister.tsx


function FacebookRegister_ownKeys(object, enumerableOnly) {
  var keys = Object.keys(object);

  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object);
    enumerableOnly && (symbols = symbols.filter(function (sym) {
      return Object.getOwnPropertyDescriptor(object, sym).enumerable;
    })), keys.push.apply(keys, symbols);
  }

  return keys;
}

function FacebookRegister_objectSpread(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = null != arguments[i] ? arguments[i] : {};
    i % 2 ? FacebookRegister_ownKeys(Object(source), !0).forEach(function (key) {
      (0,defineProperty/* default */.Z)(target, key, source[key]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : FacebookRegister_ownKeys(Object(source)).forEach(function (key) {
      Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
    });
  }

  return target;
}













const FacebookRegister = _ref => {
  let {
    idToken,
    realName,
    email
  } = _ref;
  const translate = (0,useTranslate/* default */.Z)();
  const referrerId = (0,es/* useSelector */.v9)(selectors/* getReferrerId */.VG);
  const trackRegistrationEvents = (0,useRegistrationTracking/* useRegistrationTracking */.C)();

  async function handleFormSubmit(data) {
    const fingerprint = await (0,utils_fingerprint/* getFingerprint */.f)();
    const response = await (0,account/* registerFacebookUser */.GR)(FacebookRegister_objectSpread(FacebookRegister_objectSpread({
      agreeRules: true
    }, data), {}, {
      referrerId,
      token: idToken,
      fingerprint
    }));
    await trackRegistrationEvents({
      response,
      authType: 'facebook',
      email: data.email
    });
    return response;
  }

  return /*#__PURE__*/(0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
    children: [/*#__PURE__*/(0,jsx_runtime.jsx)("div", {
      className: "u-ui-padding-horizontal-large",
      children: /*#__PURE__*/(0,jsx_runtime.jsx)(Text/* default */.Z, {
        id: "auth_modal_title",
        text: translate('auth.external_register.title'),
        type: Text/* default.Type.Heading */.Z.Type.Heading,
        alignment: Text/* default.Alignment.Center */.Z.Alignment.Center,
        width: Text/* default.Width.Parent */.Z.Width.Parent
      })
    }), /*#__PURE__*/(0,jsx_runtime.jsx)(RegisterForm/* default */.Z, {
      email: email,
      realName: realName,
      onSubmit: handleFormSubmit
    })]
  });
};

/* harmony default export */ var FacebookRegister_FacebookRegister = (FacebookRegister);
;// CONCATENATED MODULE: ../app/components/Auth/GoogleRegister/GoogleRegister.tsx


function GoogleRegister_ownKeys(object, enumerableOnly) {
  var keys = Object.keys(object);

  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object);
    enumerableOnly && (symbols = symbols.filter(function (sym) {
      return Object.getOwnPropertyDescriptor(object, sym).enumerable;
    })), keys.push.apply(keys, symbols);
  }

  return keys;
}

function GoogleRegister_objectSpread(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = null != arguments[i] ? arguments[i] : {};
    i % 2 ? GoogleRegister_ownKeys(Object(source), !0).forEach(function (key) {
      (0,defineProperty/* default */.Z)(target, key, source[key]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : GoogleRegister_ownKeys(Object(source)).forEach(function (key) {
      Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
    });
  }

  return target;
}













const GoogleRegister = _ref => {
  let {
    idToken,
    realName,
    email
  } = _ref;
  const translate = (0,useTranslate/* default */.Z)();
  const referrerId = (0,es/* useSelector */.v9)(selectors/* getReferrerId */.VG);
  const trackRegistrationEvents = (0,useRegistrationTracking/* useRegistrationTracking */.C)();

  async function handleFormSubmit(data) {
    const fingerprint = await (0,utils_fingerprint/* getFingerprint */.f)();
    const response = await (0,account/* registerGoogleUser */.eC)(GoogleRegister_objectSpread(GoogleRegister_objectSpread({
      agreeRules: true
    }, data), {}, {
      referrerId,
      token: idToken,
      fingerprint
    }));
    await trackRegistrationEvents({
      response,
      authType: 'google',
      email: data.email
    });
    return response;
  }

  return /*#__PURE__*/(0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
    children: [/*#__PURE__*/(0,jsx_runtime.jsx)("div", {
      className: "u-ui-padding-horizontal-large",
      children: /*#__PURE__*/(0,jsx_runtime.jsx)(Text/* default */.Z, {
        id: "auth_modal_title",
        text: translate('auth.external_register.title'),
        type: Text/* default.Type.Heading */.Z.Type.Heading,
        alignment: Text/* default.Alignment.Center */.Z.Alignment.Center,
        width: Text/* default.Width.Parent */.Z.Width.Parent
      })
    }), /*#__PURE__*/(0,jsx_runtime.jsx)(RegisterForm/* default */.Z, {
      email: email,
      realName: realName,
      onSubmit: handleFormSubmit
    })]
  });
};

/* harmony default export */ var GoogleRegister_GoogleRegister = (GoogleRegister);
;// CONCATENATED MODULE: ../app/components/Auth/AppleRegister/AppleRegister.tsx


function AppleRegister_ownKeys(object, enumerableOnly) {
  var keys = Object.keys(object);

  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object);
    enumerableOnly && (symbols = symbols.filter(function (sym) {
      return Object.getOwnPropertyDescriptor(object, sym).enumerable;
    })), keys.push.apply(keys, symbols);
  }

  return keys;
}

function AppleRegister_objectSpread(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = null != arguments[i] ? arguments[i] : {};
    i % 2 ? AppleRegister_ownKeys(Object(source), !0).forEach(function (key) {
      (0,defineProperty/* default */.Z)(target, key, source[key]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : AppleRegister_ownKeys(Object(source)).forEach(function (key) {
      Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
    });
  }

  return target;
}













const AppleRegister = _ref => {
  let {
    idToken,
    realName,
    email
  } = _ref;
  const translate = (0,useTranslate/* default */.Z)();
  const referrerId = (0,es/* useSelector */.v9)(selectors/* getReferrerId */.VG);
  const trackRegistrationEvents = (0,useRegistrationTracking/* useRegistrationTracking */.C)();

  async function handleFormSubmit(data) {
    const fingerprint = await (0,utils_fingerprint/* getFingerprint */.f)();
    const response = await (0,account/* registerAppleUser */.Jc)(AppleRegister_objectSpread(AppleRegister_objectSpread({
      agreeRules: true
    }, data), {}, {
      referrerId,
      token: idToken,
      fingerprint
    }));
    await trackRegistrationEvents({
      response,
      authType: 'apple',
      email: data.email
    });
    return response;
  }

  return /*#__PURE__*/(0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
    children: [/*#__PURE__*/(0,jsx_runtime.jsx)("div", {
      className: "u-ui-padding-horizontal-large",
      children: /*#__PURE__*/(0,jsx_runtime.jsx)(Text/* default */.Z, {
        id: "auth_modal_title",
        text: translate('auth.external_register.title'),
        type: Text/* default.Type.Heading */.Z.Type.Heading,
        alignment: Text/* default.Alignment.Center */.Z.Alignment.Center,
        width: Text/* default.Width.Parent */.Z.Width.Parent
      })
    }), /*#__PURE__*/(0,jsx_runtime.jsx)(RegisterForm/* default */.Z, {
      email: email,
      realName: realName,
      onSubmit: handleFormSubmit
    })]
  });
};

/* harmony default export */ var AppleRegister_AppleRegister = (AppleRegister);
;// CONCATENATED MODULE: ../app/components/Auth/Auth/Auth.tsx


function Auth_ownKeys(object, enumerableOnly) {
  var keys = Object.keys(object);

  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object);
    enumerableOnly && (symbols = symbols.filter(function (sym) {
      return Object.getOwnPropertyDescriptor(object, sym).enumerable;
    })), keys.push.apply(keys, symbols);
  }

  return keys;
}

function Auth_objectSpread(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = null != arguments[i] ? arguments[i] : {};
    i % 2 ? Auth_ownKeys(Object(source), !0).forEach(function (key) {
      (0,defineProperty/* default */.Z)(target, key, source[key]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : Auth_ownKeys(Object(source)).forEach(function (key) {
      Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
    });
  }

  return target;
}















const componentByAuthView = {
  [constants/* AuthView.SelectTypeRegister */.GT.SelectTypeRegister]: SelectType_SelectType,
  [constants/* AuthView.SelectTypeLogin */.GT.SelectTypeLogin]: SelectType_SelectType,
  [constants/* AuthView.EmailLogin */.GT.EmailLogin]: EmailLogin_EmailLogin,
  [constants/* AuthView.EmailRegister */.GT.EmailRegister]: EmailRegister/* default */.Z,
  [constants/* AuthView.ResetPassword */.GT.ResetPassword]: ResetPassword_ResetPassword
};
const componentByAuthExternalRegisterView = {
  [constants/* AuthExternalRegisterView.FacebookRegister */.S4.FacebookRegister]: FacebookRegister_FacebookRegister,
  [constants/* AuthExternalRegisterView.GoogleRegister */.S4.GoogleRegister]: GoogleRegister_GoogleRegister,
  [constants/* AuthExternalRegisterView.AppleRegister */.S4.AppleRegister]: AppleRegister_AppleRegister,
  [constants/* AuthExternalRegisterView.PasswordVerification */.S4.PasswordVerification]: PasswordVerificationLogin_PasswordVerificationLogin
};

const Auth = () => {
  const view = (0,es/* useSelector */.v9)(selectors/* getAuthView */.Cm);
  const externalRegisterData = (0,es/* useSelector */.v9)(selectors/* getExternalRegisterData */.rU);

  if ((0,object/* isValueInObject */.IF)(view, constants/* AuthView */.GT)) {
    const Component = componentByAuthView[view];
    return /*#__PURE__*/(0,jsx_runtime.jsx)(Component, {});
  }

  if (!externalRegisterData) return /*#__PURE__*/(0,jsx_runtime.jsx)(ErrorState/* default */.Z, {});
  const Component = componentByAuthExternalRegisterView[view];
  return /*#__PURE__*/(0,jsx_runtime.jsx)(Component, Auth_objectSpread({}, externalRegisterData));
};

/* harmony default export */ var Auth_Auth = (Auth);
;// CONCATENATED MODULE: ../app/components/Auth/AuthModal/AuthModal.tsx










const AuthModal = () => {
  const translate = (0,useTranslate/* default */.Z)('auth');
  const isOpen = (0,es/* useSelector */.v9)(selectors/* getIsAuthModalOpen */.y1);
  const dispatch = (0,es/* useDispatch */.I0)();
  const breakpoints = (0,useBreakpoint/* default */.Z)();

  function handleClose() {
    dispatch(slice/* actions.closeAuthModal */.Nw.closeAuthModal());
  }

  if (breakpoints.phones) {
    return /*#__PURE__*/(0,jsx_runtime.jsx)(BottomSheet/* default */.Z, {
      isVisible: isOpen,
      onClose: handleClose,
      closeButtonEnabled: true,
      children: /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
        className: "u-ui-padding-top-x-large",
        children: /*#__PURE__*/(0,jsx_runtime.jsx)(Auth_Auth, {})
      })
    });
  }

  return /*#__PURE__*/(0,jsx_runtime.jsx)(Modal/* default */.Z, {
    testId: "auth-modal",
    show: isOpen,
    defaultCallback: handleClose,
    closeOnOverlay: true,
    hasScrollableContent: true,
    className: "auth__container",
    aria: {
      labelledby: 'auth_modal_title'
    },
    children: /*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
      className: "u-fill-width",
      children: [/*#__PURE__*/(0,jsx_runtime.jsx)(Navigation/* default */.Z, {
        right: /*#__PURE__*/(0,jsx_runtime.jsx)(Button/* ButtonWithForwardedRef */.I, {
          icon: /*#__PURE__*/(0,jsx_runtime.jsx)(Icon/* default */.Z, {
            name: "x"
          }),
          inverse: true,
          inline: true,
          onClick: handleClose,
          aria: {
            'aria-label': translate('a11y.close')
          }
        })
      }), /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
        className: "u-overflow-auto",
        "aria-live": "polite",
        "aria-relevant": "additions",
        children: /*#__PURE__*/(0,jsx_runtime.jsx)(Auth_Auth, {})
      })]
    })
  });
};

/* harmony default export */ var AuthModal_AuthModal = (AuthModal);

/***/ }),

/***/ 37980:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony import */ var _app_node_modules_pnpm_next_12_3_3_4afada721a4a39e35a1a66028f2134fd_node_modules_next_dist_compiled_babel_runtime_helpers_esm_defineProperty_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(24057);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(49231);
/* harmony import */ var react_redux__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(55304);
/* harmony import */ var _vinted_web_ui__WEBPACK_IMPORTED_MODULE_14__ = __webpack_require__(73080);
/* harmony import */ var _vinted_web_ui__WEBPACK_IMPORTED_MODULE_15__ = __webpack_require__(12637);
/* harmony import */ var hooks_useTranslate__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(63820);
/* harmony import */ var constants_routes__WEBPACK_IMPORTED_MODULE_19__ = __webpack_require__(85263);
/* harmony import */ var data_api_account__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__(33713);
/* harmony import */ var data_api__WEBPACK_IMPORTED_MODULE_12__ = __webpack_require__(69170);
/* harmony import */ var state_auth_selectors__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(87728);
/* harmony import */ var state_feature_switches_selectors__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(48615);
/* harmony import */ var libs_utils_fingerprint__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(64076);
/* harmony import */ var libs_utils_window__WEBPACK_IMPORTED_MODULE_13__ = __webpack_require__(27329);
/* harmony import */ var components_ContentLoader__WEBPACK_IMPORTED_MODULE_16__ = __webpack_require__(72193);
/* harmony import */ var components_Captcha__WEBPACK_IMPORTED_MODULE_17__ = __webpack_require__(15585);
/* harmony import */ var _RegisterForm__WEBPACK_IMPORTED_MODULE_18__ = __webpack_require__(42500);
/* harmony import */ var _hooks_useRegistrationTracking__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(29908);
/* harmony import */ var _hooks_useEmailCodeTest__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(47151);
/* harmony import */ var _hooks_useSuccessUrl__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(75000);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(20264);


function ownKeys(object, enumerableOnly) {
  var keys = Object.keys(object);

  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object);
    enumerableOnly && (symbols = symbols.filter(function (sym) {
      return Object.getOwnPropertyDescriptor(object, sym).enumerable;
    })), keys.push.apply(keys, symbols);
  }

  return keys;
}

function _objectSpread(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = null != arguments[i] ? arguments[i] : {};
    i % 2 ? ownKeys(Object(source), !0).forEach(function (key) {
      (0,_app_node_modules_pnpm_next_12_3_3_4afada721a4a39e35a1a66028f2134fd_node_modules_next_dist_compiled_babel_runtime_helpers_esm_defineProperty_js__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)(target, key, source[key]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) {
      Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
    });
  }

  return target;
}





















const TRANSLATION_PREFIX = 'auth.email.register';

const EmailRegister = () => {
  const {
    0: isCaptchaVisible,
    1: setIsCaptchaVisible
  } = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)(false);
  const {
    0: isCaptchaResolved,
    1: setIsCaptchaResolved
  } = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)(false);
  const {
    0: uuid,
    1: setUuid
  } = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)('');
  const {
    0: error,
    1: setError
  } = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)('');
  const {
    0: formData,
    1: setFormData
  } = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)();
  const translate = (0,hooks_useTranslate__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)(TRANSLATION_PREFIX);
  const referrerId = (0,react_redux__WEBPACK_IMPORTED_MODULE_2__/* .useSelector */ .v9)(state_auth_selectors__WEBPACK_IMPORTED_MODULE_5__/* .getReferrerId */ .VG);
  const trackRegistrationEvents = (0,_hooks_useRegistrationTracking__WEBPACK_IMPORTED_MODULE_6__/* .useRegistrationTracking */ .C)();
  const isRegistrationCaptchaEnabled = (0,react_redux__WEBPACK_IMPORTED_MODULE_2__/* .useSelector */ .v9)((0,state_feature_switches_selectors__WEBPACK_IMPORTED_MODULE_7__/* .getIsFeatureSwitchEnabled */ .z)('registration_captcha_enabled'));
  const {
    handleEmailCodeTest
  } = (0,_hooks_useEmailCodeTest__WEBPACK_IMPORTED_MODULE_8__/* .useEmailCodeTest */ .S)();
  const successUrl = (0,_hooks_useSuccessUrl__WEBPACK_IMPORTED_MODULE_9__/* ["default"] */ .Z)();

  async function performRegistration(data, _uuid) {
    const fingerprint = await (0,libs_utils_fingerprint__WEBPACK_IMPORTED_MODULE_10__/* .getFingerprint */ .f)();
    const response = await (0,data_api_account__WEBPACK_IMPORTED_MODULE_11__/* .registerUser */ .a$)(_objectSpread(_objectSpread({
      agreeRules: true,
      password: ''
    }, data), {}, {
      referrerId,
      fingerprint,
      uuid: _uuid
    }));
    await trackRegistrationEvents({
      response,
      authType: 'internal',
      email: data.email
    });
    return response;
  }

  async function handleCaptchaComplete(key) {
    if (!formData) return;
    setIsCaptchaResolved(true);
    const verifyResponse = await (0,data_api__WEBPACK_IMPORTED_MODULE_12__/* .verifyCaptcha */ .SwO)({
      uuid,
      captchaToken: key
    });

    if ('errors' in verifyResponse || !verifyResponse.verified) {
      (0,libs_utils_window__WEBPACK_IMPORTED_MODULE_13__/* .reloadPage */ .sl)();
      return;
    }

    const registrationResponse = await performRegistration(formData, verifyResponse.uuid);

    if ('errors' in registrationResponse) {
      setError(registrationResponse.message);
      setIsCaptchaVisible(false);
      setIsCaptchaResolved(false);
      return;
    }

    const emailCodeTestUrl = await handleEmailCodeTest(registrationResponse.user.id);
    (0,libs_utils_window__WEBPACK_IMPORTED_MODULE_13__/* .navigateToPage */ .ru)(emailCodeTestUrl || successUrl);
  }

  async function handleFormSubmit(data) {
    setFormData(data);
    if (!isRegistrationCaptchaEnabled) return performRegistration(data);
    const captchaResponse = await (0,data_api__WEBPACK_IMPORTED_MODULE_12__/* .getCaptchaVerification */ .Xkj)({
      entityType: 'registration',
      payload: {
        username: data.login,
        email: data.email
      }
    });
    if ('errors' in captchaResponse) return null;

    if (!captchaResponse.verified) {
      setUuid(captchaResponse.uuid);
      setIsCaptchaVisible(true);
      return null;
    }

    return performRegistration(data, captchaResponse.uuid);
  }

  function renderDescription() {
    return /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__.jsxs)("div", {
      className: "u-ui-margin-horizontal-large",
      children: [/*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__.jsx)(_vinted_web_ui__WEBPACK_IMPORTED_MODULE_14__/* ["default"] */ .Z, {
        id: "auth_modal_title",
        text: translate('title'),
        type: _vinted_web_ui__WEBPACK_IMPORTED_MODULE_14__/* ["default"].Type.Heading */ .Z.Type.Heading,
        width: _vinted_web_ui__WEBPACK_IMPORTED_MODULE_14__/* ["default"].Width.Parent */ .Z.Width.Parent,
        alignment: _vinted_web_ui__WEBPACK_IMPORTED_MODULE_14__/* ["default"].Alignment.Center */ .Z.Alignment.Center
      }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__.jsx)(_vinted_web_ui__WEBPACK_IMPORTED_MODULE_15__/* ["default"] */ .Z, {
        size: _vinted_web_ui__WEBPACK_IMPORTED_MODULE_15__/* ["default"].Size.Large */ .Z.Size.Large
      }), error ? /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__.jsx)(_vinted_web_ui__WEBPACK_IMPORTED_MODULE_14__/* ["default"] */ .Z, {
        text: error,
        theme: "warning",
        width: _vinted_web_ui__WEBPACK_IMPORTED_MODULE_14__/* ["default"].Width.Parent */ .Z.Width.Parent,
        alignment: _vinted_web_ui__WEBPACK_IMPORTED_MODULE_14__/* ["default"].Alignment.Center */ .Z.Alignment.Center
      }) : null]
    });
  }

  if (isCaptchaVisible) {
    return /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__.jsx)("div", {
      className: "u-ui-padding-large",
      children: isCaptchaResolved ? /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__.jsx)("div", {
        className: "u-ui-padding-bottom-x2-large",
        children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__.jsx)(components_ContentLoader__WEBPACK_IMPORTED_MODULE_16__/* ["default"] */ .Z, {
          styling: components_ContentLoader__WEBPACK_IMPORTED_MODULE_16__/* ["default"].Styling.Wide */ .Z.Styling.Wide
        })
      }) : /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__.jsx)(components_Captcha__WEBPACK_IMPORTED_MODULE_17__/* ["default"] */ .Z, {
        onComplete: handleCaptchaComplete
      })
    });
  }

  return /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__.jsxs)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__.Fragment, {
    children: [renderDescription(), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__.jsx)(_RegisterForm__WEBPACK_IMPORTED_MODULE_18__/* ["default"] */ .Z, {
      isPasswordRequired: true,
      onSubmit: handleFormSubmit
    }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__.jsxs)("div", {
      className: "u-ui-margin-horizontal-large",
      children: [/*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__.jsx)(_vinted_web_ui__WEBPACK_IMPORTED_MODULE_14__/* ["default"] */ .Z, {
        width: _vinted_web_ui__WEBPACK_IMPORTED_MODULE_14__/* ["default"].Width.Parent */ .Z.Width.Parent,
        alignment: _vinted_web_ui__WEBPACK_IMPORTED_MODULE_14__/* ["default"].Alignment.Center */ .Z.Alignment.Center,
        children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__.jsx)("a", {
          href: constants_routes__WEBPACK_IMPORTED_MODULE_19__/* .SIGNUP_HELP_ENTRIES_URL */ .XQ,
          children: translate('actions.help')
        })
      }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__.jsx)(_vinted_web_ui__WEBPACK_IMPORTED_MODULE_15__/* ["default"] */ .Z, {
        size: _vinted_web_ui__WEBPACK_IMPORTED_MODULE_15__/* ["default"].Size.XLarge */ .Z.Size.XLarge
      })]
    })]
  });
};

/* harmony default export */ __webpack_exports__["Z"] = (EmailRegister);

/***/ }),

/***/ 2463:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(49231);
/* harmony import */ var react_redux__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(55304);
/* harmony import */ var libs_utils_script__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(68046);
/* harmony import */ var state_next_env_selectors__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(53084);
/* harmony import */ var state_auth_slice__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(69472);
/* harmony import */ var state_auth_selectors__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(87728);






const FACEBOOK_SDK_LINK = 'https://connect.facebook.net/en_US/sdk.js';

const useInitFacebook = () => {
  const appId = (0,react_redux__WEBPACK_IMPORTED_MODULE_1__/* .useSelector */ .v9)(state_next_env_selectors__WEBPACK_IMPORTED_MODULE_2__/* .getFacebookAppId */ .iJ);
  const isInitialized = (0,react_redux__WEBPACK_IMPORTED_MODULE_1__/* .useSelector */ .v9)(state_auth_selectors__WEBPACK_IMPORTED_MODULE_3__/* .getIsFacebookIsInitialized */ .so);
  const dispatch = (0,react_redux__WEBPACK_IMPORTED_MODULE_1__/* .useDispatch */ .I0)();
  (0,react__WEBPACK_IMPORTED_MODULE_0__.useEffect)(() => {
    if (!appId) return;
    if (isInitialized) return;

    async function initialize() {
      await (0,libs_utils_script__WEBPACK_IMPORTED_MODULE_4__/* .loadScript */ .v)({
        id: 'facebook-sdk',
        isAsync: true,
        isDefer: true,
        crossOrigin: 'anonymous',
        src: FACEBOOK_SDK_LINK
      });

      window.fbAsyncInit = () => {
        FB.init({
          appId,
          cookie: true,
          xfbml: true,
          version: 'v13.0'
        });
        dispatch(state_auth_slice__WEBPACK_IMPORTED_MODULE_5__/* .actions.setIsFacebookIsInitialized */ .Nw.setIsFacebookIsInitialized());
      };
    }

    initialize();
  }, [appId, dispatch, isInitialized]);
  return {
    isInitialized,
    isEnabled: !!appId
  };
};

/* harmony default export */ __webpack_exports__["Z"] = (useInitFacebook);

/***/ }),

/***/ 47722:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony import */ var _app_node_modules_pnpm_next_12_3_3_4afada721a4a39e35a1a66028f2134fd_node_modules_next_dist_compiled_babel_runtime_helpers_esm_defineProperty_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(24057);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(49231);
/* harmony import */ var _vinted_web_ui__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(45604);
/* harmony import */ var _vinted_web_ui__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(57645);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(20264);


function ownKeys(object, enumerableOnly) {
  var keys = Object.keys(object);

  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object);
    enumerableOnly && (symbols = symbols.filter(function (sym) {
      return Object.getOwnPropertyDescriptor(object, sym).enumerable;
    })), keys.push.apply(keys, symbols);
  }

  return keys;
}

function _objectSpread(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = null != arguments[i] ? arguments[i] : {};
    i % 2 ? ownKeys(Object(source), !0).forEach(function (key) {
      (0,_app_node_modules_pnpm_next_12_3_3_4afada721a4a39e35a1a66028f2134fd_node_modules_next_dist_compiled_babel_runtime_helpers_esm_defineProperty_js__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)(target, key, source[key]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) {
      Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
    });
  }

  return target;
}




const PasswordField = /*#__PURE__*/(0,react__WEBPACK_IMPORTED_MODULE_1__.forwardRef)((props, ref) => {
  const {
    0: showPassword,
    1: setShowPassword
  } = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)(false);

  function handleToggleShowPassword(event) {
    event.preventDefault();
    setShowPassword(prevState => !prevState);
  }

  return /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsx)(_vinted_web_ui__WEBPACK_IMPORTED_MODULE_3__/* .InputTextWithForwardedRef */ .M, _objectSpread(_objectSpread({}, props), {}, {
    ref: ref,
    type: showPassword ? _vinted_web_ui__WEBPACK_IMPORTED_MODULE_3__/* .InputTextWithForwardedRef.Type.Text */ .M.Type.Text : _vinted_web_ui__WEBPACK_IMPORTED_MODULE_3__/* .InputTextWithForwardedRef.Type.Password */ .M.Type.Password,
    suffix: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsx)("span", {
      onClick: handleToggleShowPassword,
      className: "u-cursor-pointer",
      "data-testid": "auth-password-eye-icon",
      children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsx)(_vinted_web_ui__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z, {
        name: showPassword ? 'eye' : 'eye-denied',
        size: _vinted_web_ui__WEBPACK_IMPORTED_MODULE_4__/* ["default"].Size.Small */ .Z.Size.Small
      })
    })
  }));
});
/* harmony default export */ __webpack_exports__["Z"] = (PasswordField);

/***/ }),

/***/ 42500:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ RegisterForm_RegisterForm; }
});

// EXTERNAL MODULE: ../node_modules/.pnpm/next@12.3.3_4afada721a4a39e35a1a66028f2134fd/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/defineProperty.js
var defineProperty = __webpack_require__(24057);
// EXTERNAL MODULE: ../node_modules/.pnpm/react@17.0.2/node_modules/react/index.js
var react = __webpack_require__(49231);
// EXTERNAL MODULE: ../node_modules/.pnpm/react-redux@7.2.8_react-dom@17.0.2+react@17.0.2/node_modules/react-redux/es/index.js + 22 modules
var es = __webpack_require__(55304);
// EXTERNAL MODULE: ../node_modules/.pnpm/react-hook-form@7.33.0_react@17.0.2/node_modules/react-hook-form/dist/index.esm.mjs
var index_esm = __webpack_require__(57898);
// EXTERNAL MODULE: ../node_modules/.pnpm/lodash@4.17.21/node_modules/lodash/lodash.js
var lodash = __webpack_require__(61888);
// EXTERNAL MODULE: ../node_modules/.pnpm/@vinted+web-ui@34.8.0_29a9e79dfb0433562b4e854f8f07c904/node_modules/@vinted/web-ui/dist/esm/lib/Text/Text.js
var Text = __webpack_require__(73080);
// EXTERNAL MODULE: ../node_modules/.pnpm/@vinted+web-ui@34.8.0_29a9e79dfb0433562b4e854f8f07c904/node_modules/@vinted/web-ui/dist/esm/lib/Input/InputText/InputText.js
var InputText = __webpack_require__(45604);
// EXTERNAL MODULE: ../node_modules/.pnpm/@vinted+web-ui@34.8.0_29a9e79dfb0433562b4e854f8f07c904/node_modules/@vinted/web-ui/dist/esm/lib/Checkbox/Checkbox.js
var Checkbox = __webpack_require__(37929);
// EXTERNAL MODULE: ../node_modules/.pnpm/@vinted+web-ui@34.8.0_29a9e79dfb0433562b4e854f8f07c904/node_modules/@vinted/web-ui/dist/esm/lib/Spacer/Spacer.js
var Spacer = __webpack_require__(12637);
// EXTERNAL MODULE: ../node_modules/.pnpm/@vinted+web-ui@34.8.0_29a9e79dfb0433562b4e854f8f07c904/node_modules/@vinted/web-ui/dist/esm/lib/Cell/Cell.js
var Cell = __webpack_require__(36403);
// EXTERNAL MODULE: ../node_modules/.pnpm/@vinted+web-ui@34.8.0_29a9e79dfb0433562b4e854f8f07c904/node_modules/@vinted/web-ui/dist/esm/lib/Button/Button.js
var Button = __webpack_require__(10914);
// EXTERNAL MODULE: ../app/hooks/useAbTest/useAbTest.ts
var useAbTest = __webpack_require__(56779);
// EXTERNAL MODULE: ../app/hooks/useFormValidationMessage.ts
var useFormValidationMessage = __webpack_require__(55298);
// EXTERNAL MODULE: ../app/hooks/useTranslate.ts
var useTranslate = __webpack_require__(63820);
// EXTERNAL MODULE: ../app/components/Input/renderValidation.tsx
var renderValidation = __webpack_require__(43968);
// EXTERNAL MODULE: ../app/components/SeparatedList/SeparatedList.tsx
var SeparatedList = __webpack_require__(42792);
// EXTERNAL MODULE: ../app/components/ContentLoader/ContentLoader.tsx
var ContentLoader = __webpack_require__(72193);
// EXTERNAL MODULE: ../app/constants/routes/index.ts
var routes = __webpack_require__(85263);
// EXTERNAL MODULE: ../app/libs/utils/window.ts
var utils_window = __webpack_require__(27329);
// EXTERNAL MODULE: ../app/libs/utils/object.ts
var object = __webpack_require__(55118);
// EXTERNAL MODULE: ../app/state/auth/selectors.ts
var selectors = __webpack_require__(87728);
// EXTERNAL MODULE: ../app/state/auth/constants.ts
var constants = __webpack_require__(29702);
// EXTERNAL MODULE: ../app/data/api/index.ts + 1 modules
var api = __webpack_require__(69170);
// EXTERNAL MODULE: ../app/libs/utils/url.ts
var url = __webpack_require__(11985);
// EXTERNAL MODULE: ../app/libs/utils/google.ts
var google = __webpack_require__(89523);
// EXTERNAL MODULE: ../app/hooks/useDatadomeCaptcha.ts
var useDatadomeCaptcha = __webpack_require__(54403);
// EXTERNAL MODULE: ../app/libs/validators/fullName.ts
var fullName = __webpack_require__(63208);
// EXTERNAL MODULE: ../app/libs/validators/email.ts
var email = __webpack_require__(71462);
;// CONCATENATED MODULE: ../app/libs/validators/login.ts
const loginRegex = /^[a-z0-9][a-z0-9_.-]*[a-z0-9]$/i;
const isLoginValid = email => loginRegex.test(email);
;// CONCATENATED MODULE: ../app/components/Auth/RegisterForm/utils.ts



const validateAsync = async (field, value) => {
  const response = await (0,api/* validateUser */.h3H)({
    user: {
      [field]: value
    }
  });

  if ('errors' in response) {
    var _response$errors$find, _response$errors$find2;

    return (_response$errors$find = (_response$errors$find2 = response.errors.find(error => error.field === field)) === null || _response$errors$find2 === void 0 ? void 0 : _response$errors$find2.value) !== null && _response$errors$find !== void 0 ? _response$errors$find : true;
  }

  return true;
};

const validateRealName = value => (0,fullName/* isFullNameValid */.v)(value) && validateAsync('real_name', value);
const validateEmail = value => (0,email/* isEmailValid */.J)(value) && validateAsync('email', value);
const validateLogin = value => isLoginValid(value) && validateAsync('login', value);
const validatePassword = value => validateAsync('password', value);
;// CONCATENATED MODULE: ../app/components/Auth/RegisterForm/constants.ts
let Field;

(function (Field) {
  Field["RealName"] = "realName";
  Field["Login"] = "login";
  Field["Email"] = "email";
  Field["Password"] = "password";
  Field["SubscribeToNewsletter"] = "subscribeToNewsletter";
  Field["AgreeRules"] = "agreeRules";
})(Field || (Field = {}));
// EXTERNAL MODULE: ../app/components/Auth/PasswordField/PasswordField.tsx
var PasswordField = __webpack_require__(47722);
// EXTERNAL MODULE: ../app/components/Auth/hooks/useEmailCodeTest.ts
var useEmailCodeTest = __webpack_require__(47151);
// EXTERNAL MODULE: ../app/components/Auth/hooks/useSuccessUrl.ts
var useSuccessUrl = __webpack_require__(75000);
// EXTERNAL MODULE: ../node_modules/.pnpm/react@17.0.2/node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(20264);
;// CONCATENATED MODULE: ../app/components/Auth/RegisterForm/RegisterForm.tsx


function ownKeys(object, enumerableOnly) {
  var keys = Object.keys(object);

  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object);
    enumerableOnly && (symbols = symbols.filter(function (sym) {
      return Object.getOwnPropertyDescriptor(object, sym).enumerable;
    })), keys.push.apply(keys, symbols);
  }

  return keys;
}

function _objectSpread(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = null != arguments[i] ? arguments[i] : {};
    i % 2 ? ownKeys(Object(source), !0).forEach(function (key) {
      (0,defineProperty/* default */.Z)(target, key, source[key]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) {
      Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
    });
  }

  return target;
}





























const TRANSLATION_PREFIX = 'auth.register';
const BUSINESS_TRANSLATION_PREFIX = 'business';

const RegisterForm = _ref => {
  let {
    realName,
    email,
    isPasswordRequired,
    onSubmit
  } = _ref;
  const isRealNameRequired = (0,es/* useSelector */.v9)(selectors/* getIsRealNameRequired */.J$);
  const newsletterSubscription = (0,es/* useSelector */.v9)(selectors/* getNewsletterSubscription */.ab);
  const isBusinessAuth = (0,es/* useSelector */.v9)(selectors/* getIsBusinessAuth */.Uc);
  const termsCheckboxABTest = (0,useAbTest/* default */.Z)({
    abTestName: 'terms_checkbox',
    shouldTrackExpose: true
  });
  const {
    handleEmailCodeTest
  } = (0,useEmailCodeTest/* useEmailCodeTest */.S)();
  const showTermsAsCheckbox = (termsCheckboxABTest === null || termsCheckboxABTest === void 0 ? void 0 : termsCheckboxABTest.variant) === 'on';
  const isAutoSubscribed = newsletterSubscription === constants/* NewsletterSubscription.WithTerms */.ir.WithTerms;
  const {
    0: baseError,
    1: setBaseError
  } = (0,react.useState)('');
  const {
    0: showRealNameField,
    1: setShowRealNameField
  } = (0,react.useState)(false);
  const {
    0: isLoading,
    1: setIsLoading
  } = (0,react.useState)(false);
  const state = (0,url/* getNormalizedQueryParam */.ZB)('state');
  const stateUrl = (0,google/* getGoogleRedirectUrl */.sR)(state);
  const successUrl = (0,useSuccessUrl/* default */.Z)(stateUrl);
  const {
    setError,
    control,
    register,
    handleSubmit,
    getValues,
    formState: {
      isSubmitting,
      errors
    }
  } = (0,index_esm/* useForm */.cI)({
    mode: 'onTouched',
    defaultValues: {
      realName
    }
  });
  const getErrorMessage = (0,useFormValidationMessage/* default */.Z)(errors, "".concat(TRANSLATION_PREFIX, ".fields"));
  const translate = (0,useTranslate/* default */.Z)(TRANSLATION_PREFIX);
  const businessTranslate = (0,useTranslate/* default */.Z)(BUSINESS_TRANSLATION_PREFIX);
  const setErrors = (0,react.useCallback)(newErrors => {
    let newBaseError = '';
    let hasFieldError = false;
    newErrors.forEach(_ref2 => {
      let {
        field,
        value
      } = _ref2;
      const fieldName = (0,lodash.camelCase)(field);
      if (fieldName === Field.RealName) setShowRealNameField(true);
      if (fieldName === 'base') newBaseError || (newBaseError = value);
      if (!(0,object/* isValueInObject */.IF)(fieldName, Field)) return;
      hasFieldError = true;
      setError(fieldName, {
        type: 'manual',
        message: value
      });
    });
    setBaseError(hasFieldError ? '' : newBaseError);
  }, [setError]);

  async function handleFormSubmit(data) {
    const response = await onSubmit(data);
    if (!response) return;

    if ('errors' in response) {
      setErrors(response.errors);
      return;
    }

    const emailCodeTestUrl = await handleEmailCodeTest(response.user.id);
    (0,utils_window/* navigateToPage */.ru)(emailCodeTestUrl || successUrl);
  }

  (0,useDatadomeCaptcha/* default */.Z)(() => {
    const formData = getValues();
    if (!formData) return;
    handleFormSubmit(formData);
  });

  function handleCheckboxClick(onChange) {
    return event => onChange(event.target.checked);
  }

  function renderBaseError() {
    if (!baseError) return null;
    return /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
      className: "u-ui-padding-horizontal-large u-ui-padding-top-large u-ui-padding-bottom-small",
      children: /*#__PURE__*/(0,jsx_runtime.jsx)(Text/* default */.Z, {
        text: baseError,
        theme: "warning",
        width: Text/* default.Width.Parent */.Z.Width.Parent,
        alignment: Text/* default.Alignment.Center */.Z.Alignment.Center
      })
    });
  }

  function renderRealNameField() {
    if (!isRealNameRequired && !showRealNameField) return null;

    if (realName && !showRealNameField) {
      return /*#__PURE__*/(0,jsx_runtime.jsx)("input", _objectSpread(_objectSpread({}, register(Field.RealName)), {}, {
        type: "hidden",
        value: realName
      }));
    }

    return /*#__PURE__*/(0,jsx_runtime.jsx)(InputText/* InputTextWithForwardedRef */.M, _objectSpread(_objectSpread({}, register(Field.RealName, {
      required: true,
      validate: value => value ? validateRealName(value) : undefined
    })), {}, {
      uncontrolled: true,
      placeholder: translate('fields.real_name.title'),
      validation: (0,renderValidation/* default */.Z)(getErrorMessage(Field.RealName)) || translate('fields.real_name.hint')
    }));
  }

  function renderEmailField() {
    if (email) return /*#__PURE__*/(0,jsx_runtime.jsx)("input", _objectSpread(_objectSpread({}, register(Field.Email)), {}, {
      type: "hidden",
      value: email
    }));
    return /*#__PURE__*/(0,jsx_runtime.jsx)(InputText/* InputTextWithForwardedRef */.M, _objectSpread(_objectSpread({}, register(Field.Email, {
      required: true,
      validate: validateEmail
    })), {}, {
      uncontrolled: true,
      placeholder: translate('fields.email.title'),
      validation: (0,renderValidation/* default */.Z)(getErrorMessage(Field.Email))
    }));
  }

  function interpolateLink(url) {
    return part => /*#__PURE__*/(0,jsx_runtime.jsx)("a", {
      href: url,
      target: "_blank",
      rel: "noopener noreferrer",
      children: part
    });
  }

  function translateTermsAndCondition(key) {
    return translate(key, {
      'terms-and-conditions': interpolateLink(routes/* TERMS_URL */.qy),
      'pro-terms-of-sale': interpolateLink(routes/* BUSINESS_TERMS_OF_SALE_URL */.$r),
      'privacy-policy': interpolateLink(routes/* PRIVACY_POLICY_URL */.hO),
      impressum: interpolateLink(routes/* IMPRESSUM_URL */.v2)
    });
  }

  function renderTermsAndConditionsCheckbox() {
    const error = getErrorMessage(Field.AgreeRules);
    return /*#__PURE__*/(0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
      children: [/*#__PURE__*/(0,jsx_runtime.jsx)(index_esm/* Controller */.Qr, {
        defaultValue: false,
        render: _ref3 => {
          let {
            field: {
              name,
              value,
              onChange
            }
          } = _ref3;
          return /*#__PURE__*/(0,jsx_runtime.jsx)(Checkbox/* CheckboxWithForwardedRef */.F, {
            name: name,
            text: translateTermsAndCondition('fields.agree_rules.title'),
            checked: value,
            onChange: handleCheckboxClick(onChange)
          });
        },
        rules: {
          required: true
        },
        name: Field.AgreeRules,
        control: control
      }), error && /*#__PURE__*/(0,jsx_runtime.jsx)(Spacer/* default */.Z, {
        size: Spacer/* default.Size.Small */.Z.Size.Small
      }), (0,renderValidation/* default */.Z)(error)]
    });
  }

  function renderFields() {
    return /*#__PURE__*/(0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
      children: [renderRealNameField(), /*#__PURE__*/(0,jsx_runtime.jsx)(InputText/* InputTextWithForwardedRef */.M, _objectSpread(_objectSpread({}, register(Field.Login, {
        required: true,
        minLength: 3,
        maxLength: 20,
        validate: validateLogin
      })), {}, {
        uncontrolled: true,
        placeholder: translate('fields.login.title'),
        validation: (0,renderValidation/* default */.Z)(getErrorMessage(Field.Login)) || translate('fields.login.hint')
      })), renderEmailField(), isPasswordRequired && /*#__PURE__*/(0,jsx_runtime.jsx)(PasswordField/* default */.Z, _objectSpread(_objectSpread({}, register(Field.Password, {
        required: true,
        validate: value => value ? validatePassword(value) : undefined
      })), {}, {
        uncontrolled: true,
        validation: (0,renderValidation/* default */.Z)(getErrorMessage(Field.Password)) || translate('fields.password.hint'),
        placeholder: translate('fields.password.title')
      })), (!isAutoSubscribed || showTermsAsCheckbox) && /*#__PURE__*/(0,jsx_runtime.jsx)(Cell/* default */.Z, {
        children: /*#__PURE__*/(0,jsx_runtime.jsxs)(SeparatedList/* default */.Z, {
          separator: /*#__PURE__*/(0,jsx_runtime.jsx)(Spacer/* default */.Z, {
            size: Spacer/* default.Size.Large */.Z.Size.Large
          }),
          children: [/*#__PURE__*/(0,jsx_runtime.jsx)(index_esm/* Controller */.Qr, {
            defaultValue: newsletterSubscription === constants/* NewsletterSubscription.OptOut */.ir.OptOut,
            render: _ref4 => {
              let {
                field: {
                  value,
                  name,
                  onChange
                }
              } = _ref4;
              return /*#__PURE__*/(0,jsx_runtime.jsx)(Checkbox/* CheckboxWithForwardedRef */.F, {
                name: name,
                text: translate('fields.subscribe.title', {
                  // Only used for markets with a custom applied copy (e.g. Hungary)
                  'privacy-policy': interpolateLink(routes/* PRIVACY_POLICY_URL */.hO)
                }),
                checked: value,
                onChange: handleCheckboxClick(onChange)
              });
            },
            name: Field.SubscribeToNewsletter,
            control: control
          }), showTermsAsCheckbox && renderTermsAndConditionsCheckbox()]
        })
      })]
    });
  }

  const renderTermsAndConditions = () => {
    if (isBusinessAuth) {
      return /*#__PURE__*/(0,jsx_runtime.jsx)(Text/* default */.Z, {
        type: Text/* default.Type.Caption */.Z.Type.Caption,
        text: businessTranslate('account.signup.commercial_seller_terms', {
          'business-terms': interpolateLink(routes/* BUSINESS_TERMS_URL */.vK),
          'privacy-policy': interpolateLink(routes/* PRIVACY_POLICY_URL */.hO)
        })
      });
    }

    return /*#__PURE__*/(0,jsx_runtime.jsx)(Text/* default */.Z, {
      type: Text/* default.Type.Caption */.Z.Type.Caption,
      text: translateTermsAndCondition(isAutoSubscribed ? 'agree_terms_with_subscription' : 'agree_terms')
    });
  };

  function renderFooter() {
    return /*#__PURE__*/(0,jsx_runtime.jsxs)(Cell/* default */.Z, {
      children: [/*#__PURE__*/(0,jsx_runtime.jsx)(Button/* ButtonWithForwardedRef */.I, {
        text: translate('actions.submit'),
        type: Button/* ButtonWithForwardedRef.Type.Submit */.I.Type.Submit,
        styling: Button/* ButtonWithForwardedRef.Styling.Filled */.I.Styling.Filled,
        disabled: isSubmitting,
        isLoading: isSubmitting
      }), /*#__PURE__*/(0,jsx_runtime.jsx)(Spacer/* default */.Z, {}), !showTermsAsCheckbox && /*#__PURE__*/(0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [renderTermsAndConditions(), /*#__PURE__*/(0,jsx_runtime.jsx)(Spacer/* default */.Z, {})]
      })]
    });
  }

  (0,react.useEffect)(() => {
    if (!isRealNameRequired) return;

    async function handleValidateInitialUserData() {
      setIsLoading(true);
      const response = await (0,api/* validateUser */.h3H)({
        user: {
          real_name: realName
        }
      });

      if ('errors' in response) {
        setErrors(response.errors);
      }

      setIsLoading(false);
    }

    handleValidateInitialUserData();
  }, [realName, setErrors, isRealNameRequired]);

  if (isLoading) {
    return /*#__PURE__*/(0,jsx_runtime.jsx)(ContentLoader/* default */.Z, {});
  }

  return /*#__PURE__*/(0,jsx_runtime.jsxs)("form", {
    onSubmit: handleSubmit(handleFormSubmit),
    children: [renderBaseError(), renderFields(), renderFooter()]
  });
};

/* harmony default export */ var RegisterForm_RegisterForm = (RegisterForm);

/***/ }),

/***/ 47151:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "S": function() { return /* binding */ useEmailCodeTest; }
/* harmony export */ });
/* harmony import */ var _app_node_modules_pnpm_next_12_3_3_4afada721a4a39e35a1a66028f2134fd_node_modules_next_dist_compiled_babel_runtime_helpers_esm_defineProperty_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(24057);
/* harmony import */ var react_redux__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(55304);
/* harmony import */ var hooks_useTracking__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(56068);
/* harmony import */ var data_api__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(69170);
/* harmony import */ var constants_routes__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(85263);
/* harmony import */ var constants_verification__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(31300);
/* harmony import */ var libs_utils_url__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__(11985);
/* harmony import */ var libs_common_event_tracker_events__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(8351);
/* harmony import */ var state_ab_tests_selectors__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(47497);
/* harmony import */ var state_session_selectors__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(77165);
/* harmony import */ var state_feature_switches_selectors__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(48615);
/* harmony import */ var _useSuccessUrl__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(75000);


function ownKeys(object, enumerableOnly) {
  var keys = Object.keys(object);

  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object);
    enumerableOnly && (symbols = symbols.filter(function (sym) {
      return Object.getOwnPropertyDescriptor(object, sym).enumerable;
    })), keys.push.apply(keys, symbols);
  }

  return keys;
}

function _objectSpread(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = null != arguments[i] ? arguments[i] : {};
    i % 2 ? ownKeys(Object(source), !0).forEach(function (key) {
      (0,_app_node_modules_pnpm_next_12_3_3_4afada721a4a39e35a1a66028f2134fd_node_modules_next_dist_compiled_babel_runtime_helpers_esm_defineProperty_js__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)(target, key, source[key]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) {
      Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
    });
  }

  return target;
}












const useEmailCodeTest = () => {
  const isEmailCodeTestEnabled = (0,react_redux__WEBPACK_IMPORTED_MODULE_1__/* .useSelector */ .v9)((0,state_feature_switches_selectors__WEBPACK_IMPORTED_MODULE_2__/* .getIsFeatureSwitchEnabled */ .z)('email_verification_new_users_test'));
  const abTest = (0,react_redux__WEBPACK_IMPORTED_MODULE_1__/* .useSelector */ .v9)((0,state_ab_tests_selectors__WEBPACK_IMPORTED_MODULE_3__/* .getAbTestByName */ .uw)('non_skippable_email_verification_new_users'));
  const exposee = (0,react_redux__WEBPACK_IMPORTED_MODULE_1__/* .useSelector */ .v9)(state_session_selectors__WEBPACK_IMPORTED_MODULE_4__/* .getExposee */ .WR);
  const successUrl = (0,_useSuccessUrl__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)(constants_routes__WEBPACK_IMPORTED_MODULE_6__/* .ROOT_URL */ .mY);
  const {
    track
  } = (0,hooks_useTracking__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z)();

  const handleEmailCodeTest = async userId => {
    if (!isEmailCodeTestEnabled) return undefined;
    const response = await (0,data_api__WEBPACK_IMPORTED_MODULE_8__/* .getVerificationPrompt */ .YAs)(userId);
    if ('errors' in response) return undefined;
    if (abTest) track((0,libs_common_event_tracker_events__WEBPACK_IMPORTED_MODULE_9__/* .abTestExposeEvent */ .Nr)(_objectSpread(_objectSpread({}, exposee), abTest)));
    if (!response.prompt.methods.includes(constants_verification__WEBPACK_IMPORTED_MODULE_10__/* .VerificationMethods.EmailCode */ .Rq.EmailCode)) return undefined;
    return (0,libs_utils_url__WEBPACK_IMPORTED_MODULE_11__/* .urlWithParams */ .Iq)(constants_routes__WEBPACK_IMPORTED_MODULE_6__/* .USERS_VERIFICATION_URL */ .O8, {
      ref_url: successUrl
    });
  };

  return {
    handleEmailCodeTest
  };
};

/***/ }),

/***/ 29908:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "C": function() { return /* binding */ useRegistrationTracking; }
/* harmony export */ });
/* harmony import */ var constants_braze__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(94302);
/* harmony import */ var hooks_useTracking__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(56068);
/* harmony import */ var hooks_useGoogleTagManagerTrack__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(76819);
/* harmony import */ var libs_common_event_tracker_events__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(8351);
/* harmony import */ var constants_google__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(31967);
/* harmony import */ var libs_common_braze_logCustomEvent__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(39782);






const gtmTypeByAuthType = {
  apple: 'apple',
  facebook: 'facebook',
  google: 'google',
  internal: 'email'
};
const useRegistrationTracking = () => {
  const {
    track
  } = (0,hooks_useTracking__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)();
  const {
    googleTagManagerTrack
  } = (0,hooks_useGoogleTagManagerTrack__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)();
  return _ref => {
    let {
      response,
      authType,
      email
    } = _ref;
    const gtmAuthType = gtmTypeByAuthType[authType];

    if ('errors' in response) {
      track((0,libs_common_event_tracker_events__WEBPACK_IMPORTED_MODULE_2__/* .userRegisterFailEvent */ .tE)({
        type: authType,
        errors: response.errors
      }));
      return;
    }

    googleTagManagerTrack(constants_google__WEBPACK_IMPORTED_MODULE_3__/* .GoogleTagManagerEvent.Register */ .Nx.Register, {
      auth_type: gtmAuthType,
      user_email: email
    });
    track((0,libs_common_event_tracker_events__WEBPACK_IMPORTED_MODULE_2__/* .userRegisterSuccessEvent */ .CR)({
      type: authType,
      userId: response.user.id
    }));
    track((0,libs_common_event_tracker_events__WEBPACK_IMPORTED_MODULE_2__/* .authenticateSuccessEvent */ .Xi)({
      type: authType,
      userId: response.user.id
    }));
    const {
      external_id
    } = response.user;

    if (external_id) {
      (0,libs_common_braze_logCustomEvent__WEBPACK_IMPORTED_MODULE_4__/* .brazeLogCustomEvent */ .O)({
        event: constants_braze__WEBPACK_IMPORTED_MODULE_5__/* .BrazeCustomEvent.RegistrationCompleted */ .xy.RegistrationCompleted,
        userExternalId: external_id
      }, {
        forceCache: true
      });
    }
  };
};

/***/ }),

/***/ 75000:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony import */ var react_redux__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(55304);
/* harmony import */ var constants_routes__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(85263);
/* harmony import */ var libs_utils_url__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(11985);
/* harmony import */ var state_auth_selectors__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(87728);





const useSuccessUrl = defaultUrl => {
  const isBusinessAuth = (0,react_redux__WEBPACK_IMPORTED_MODULE_0__/* .useSelector */ .v9)(state_auth_selectors__WEBPACK_IMPORTED_MODULE_1__/* .getIsBusinessAuth */ .Uc);
  if (isBusinessAuth) return constants_routes__WEBPACK_IMPORTED_MODULE_2__/* .BUSINESS_ACCOUNT_REGISTER_URL */ .su;
  return (0,libs_utils_url__WEBPACK_IMPORTED_MODULE_3__/* .getRefUrl */ .y4)(defaultUrl);
};

/* harmony default export */ __webpack_exports__["Z"] = (useSuccessUrl);

/***/ }),

/***/ 15585:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(49231);
/* harmony import */ var _vinted_web_ui__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(73080);
/* harmony import */ var _vinted_web_ui__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(12637);
/* harmony import */ var hooks_useTranslate__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(63820);
/* harmony import */ var hooks_useTracking__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(56068);
/* harmony import */ var libs_common_event_tracker_events__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(8351);
/* harmony import */ var constants_tracking_screens__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(79196);
/* harmony import */ var _ReCaptcha__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(93708);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(20264);











const Captcha = _ref => {
  let {
    onComplete
  } = _ref;
  const translate = (0,hooks_useTranslate__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)('captcha');
  const {
    track
  } = (0,hooks_useTracking__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)();
  (0,react__WEBPACK_IMPORTED_MODULE_0__.useEffect)(() => {
    track((0,libs_common_event_tracker_events__WEBPACK_IMPORTED_MODULE_4__/* .viewScreenEvent */ .qv)({
      screen: constants_tracking_screens__WEBPACK_IMPORTED_MODULE_5__/* .Screen.CaptchaPage */ .l.CaptchaPage
    }));
  }, [track]);
  return /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.Fragment, {
    children: [/*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(_vinted_web_ui__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z, {
      text: translate('title'),
      type: _vinted_web_ui__WEBPACK_IMPORTED_MODULE_6__/* ["default"].Type.Heading */ .Z.Type.Heading,
      alignment: _vinted_web_ui__WEBPACK_IMPORTED_MODULE_6__/* ["default"].Alignment.Center */ .Z.Alignment.Center,
      width: _vinted_web_ui__WEBPACK_IMPORTED_MODULE_6__/* ["default"].Width.Parent */ .Z.Width.Parent
    }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(_vinted_web_ui__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z, {
      size: _vinted_web_ui__WEBPACK_IMPORTED_MODULE_7__/* ["default"].Size.XLarge */ .Z.Size.XLarge
    }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(_vinted_web_ui__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z, {
      text: translate('text'),
      alignment: _vinted_web_ui__WEBPACK_IMPORTED_MODULE_6__/* ["default"].Alignment.Center */ .Z.Alignment.Center
    }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(_vinted_web_ui__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z, {
      size: _vinted_web_ui__WEBPACK_IMPORTED_MODULE_7__/* ["default"].Size.X2Large */ .Z.Size.X2Large
    }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(_ReCaptcha__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .Z, {
      onComplete: onComplete
    })]
  });
};

/* harmony default export */ __webpack_exports__["Z"] = (Captcha);

/***/ }),

/***/ 93708:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ Captcha_ReCaptcha; }
});

// EXTERNAL MODULE: ../node_modules/.pnpm/react@17.0.2/node_modules/react/index.js
var react = __webpack_require__(49231);
// EXTERNAL MODULE: ../node_modules/.pnpm/react-redux@7.2.8_react-dom@17.0.2+react@17.0.2/node_modules/react-redux/es/index.js + 22 modules
var es = __webpack_require__(55304);
// EXTERNAL MODULE: ../app/state/session/selectors.ts
var selectors = __webpack_require__(77165);
// EXTERNAL MODULE: ../app/libs/utils/script.ts
var script = __webpack_require__(68046);
// EXTERNAL MODULE: ../app/libs/utils/url.ts
var url = __webpack_require__(11985);
// EXTERNAL MODULE: ../app/constants/language.ts
var language = __webpack_require__(57059);
;// CONCATENATED MODULE: ../app/libs/utils/language.ts

const languageCodeToISO = languageCode => {
  return language/* VINTED_LOCALE_TO_ISO_MAP */._[languageCode] || 'en';
};
// EXTERNAL MODULE: ../app/constants/captcha.ts
var captcha = __webpack_require__(48267);
// EXTERNAL MODULE: ../node_modules/.pnpm/react@17.0.2/node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(20264);
;// CONCATENATED MODULE: ../app/components/Captcha/ReCaptcha.tsx








const LOADED_CHECK_INTERVAL = 1000;
const CAPTCHA_SCRIPT_URL = 'https://www.google.com/recaptcha/api.js';
const CAPTCHA_SCRIPT_ID = 'captcha-script';

const ReCaptcha = _ref => {
  let {
    onComplete,
    siteKey = captcha/* RE_CAPTCHA_SITE_KEY */.o4
  } = _ref;
  const captchaContainer = (0,react.useRef)(null);
  const {
    0: isRendered,
    1: setIsRendered
  } = (0,react.useState)(false);
  const languageCode = (0,es/* useSelector */.v9)(selectors/* getLanguageCode */.ht);
  (0,react.useEffect)(() => {
    async function loadCaptcha() {
      await (0,script/* loadScript */.v)({
        id: CAPTCHA_SCRIPT_ID,
        isAsync: true,
        src: (0,url/* urlWithParams */.Iq)(CAPTCHA_SCRIPT_URL, {
          render: 'explicit',
          hl: languageCodeToISO(languageCode)
        })
      });
    }

    loadCaptcha();
    return () => (0,script/* removeScript */.l)(CAPTCHA_SCRIPT_ID);
  }, [languageCode]);
  (0,react.useEffect)(() => {
    let interval;

    function callback(key) {
      onComplete(key);
      grecaptcha.reset();
    }

    function renderReCaptcha() {
      var _captchaContainer$cur;

      if (isRendered) return;
      const wrapper = document.createElement('div');
      window.grecaptcha.render(wrapper, {
        sitekey: siteKey,
        callback
      });
      (_captchaContainer$cur = captchaContainer.current) === null || _captchaContainer$cur === void 0 ? void 0 : _captchaContainer$cur.appendChild(wrapper);
      setIsRendered(true);
    }

    function isCaptchaLoaded() {
      return window.grecaptcha && typeof window.grecaptcha.render === 'function';
    }

    function checkIsLoaded() {
      if (!isCaptchaLoaded()) return;
      clearInterval(interval);
      renderReCaptcha();
    }

    if (isCaptchaLoaded()) {
      renderReCaptcha();
    } else {
      interval = setInterval(checkIsLoaded, LOADED_CHECK_INTERVAL);
    }

    return () => clearInterval(interval);
  }, [onComplete, isRendered, setIsRendered, siteKey]);
  return /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
    className: "u-flexbox u-flex-direction-column u-align-items-center",
    ref: captchaContainer
  });
};

/* harmony default export */ var Captcha_ReCaptcha = (ReCaptcha);

/***/ }),

/***/ 80811:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony import */ var _app_node_modules_pnpm_next_12_3_3_4afada721a4a39e35a1a66028f2134fd_node_modules_next_dist_compiled_babel_runtime_helpers_esm_defineProperty_js__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(24057);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(49231);
/* harmony import */ var react_intl__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(10855);
/* harmony import */ var _vinted_web_ui__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(10914);
/* harmony import */ var _vinted_web_ui__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(75107);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(20264);






class ErrorState extends react__WEBPACK_IMPORTED_MODULE_0__.Component {
  constructor() {
    super(...arguments);

    (0,_app_node_modules_pnpm_next_12_3_3_4afada721a4a39e35a1a66028f2134fd_node_modules_next_dist_compiled_babel_runtime_helpers_esm_defineProperty_js__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)(this, "translate", id => this.props.intl.formatMessage({
      id: "error_state.".concat(id)
    }));
  }

  renderCta() {
    const {
      ctaText,
      onCtaClick: onCta,
      ctaLoading
    } = this.props;
    if (!onCta) return undefined;
    return /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(_vinted_web_ui__WEBPACK_IMPORTED_MODULE_3__/* .ButtonWithForwardedRef */ .I, {
      isLoading: ctaLoading,
      text: ctaText || this.translate('cta'),
      styling: _vinted_web_ui__WEBPACK_IMPORTED_MODULE_3__/* .ButtonWithForwardedRef.Styling.Filled */ .I.Styling.Filled,
      onClick: onCta
    });
  }

  render() {
    const {
      title,
      body
    } = this.props;
    return /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(_vinted_web_ui__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z, {
      title: title || this.translate('title'),
      body: body || this.translate('body'),
      action: this.renderCta()
    });
  }

}

/* harmony default export */ __webpack_exports__["Z"] = ((0,react_intl__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .ZP)(ErrorState));

/***/ }),

/***/ 85642:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ LanguageSelector_LanguageSelector; }
});

// EXTERNAL MODULE: ../node_modules/.pnpm/react@17.0.2/node_modules/react/index.js
var react = __webpack_require__(49231);
// EXTERNAL MODULE: ../node_modules/.pnpm/react-redux@7.2.8_react-dom@17.0.2+react@17.0.2/node_modules/react-redux/es/index.js + 22 modules
var es = __webpack_require__(55304);
// EXTERNAL MODULE: ../app/libs/utils/window.ts
var utils_window = __webpack_require__(27329);
// EXTERNAL MODULE: ../app/hooks/useBreakpoint.ts
var useBreakpoint = __webpack_require__(7250);
// EXTERNAL MODULE: ../app/data/api/index.ts + 1 modules
var api = __webpack_require__(69170);
// EXTERNAL MODULE: ../app/state/intl/selectors.ts
var selectors = __webpack_require__(68894);
// EXTERNAL MODULE: ../node_modules/.pnpm/next@12.3.3_4afada721a4a39e35a1a66028f2134fd/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/defineProperty.js
var defineProperty = __webpack_require__(24057);
// EXTERNAL MODULE: ../node_modules/.pnpm/@vinted+web-ui@34.8.0_29a9e79dfb0433562b4e854f8f07c904/node_modules/@vinted/web-ui/dist/esm/lib/Text/Text.js
var Text = __webpack_require__(73080);
// EXTERNAL MODULE: ../node_modules/.pnpm/@vinted+web-ui@34.8.0_29a9e79dfb0433562b4e854f8f07c904/node_modules/@vinted/web-ui/dist/esm/lib/Spacer/Spacer.js
var Spacer = __webpack_require__(12637);
// EXTERNAL MODULE: ../node_modules/.pnpm/@vinted+web-ui@34.8.0_29a9e79dfb0433562b4e854f8f07c904/node_modules/@vinted/web-ui/dist/esm/lib/Button/Button.js
var Button = __webpack_require__(10914);
// EXTERNAL MODULE: ../node_modules/.pnpm/@vinted+web-ui@34.8.0_29a9e79dfb0433562b4e854f8f07c904/node_modules/@vinted/web-ui/dist/esm/lib/Icon/Icon.js + 1 modules
var Icon = __webpack_require__(57645);
// EXTERNAL MODULE: ../node_modules/.pnpm/@vinted+web-ui@34.8.0_29a9e79dfb0433562b4e854f8f07c904/node_modules/@vinted/web-ui/dist/esm/lib/Card/Card.js
var Card = __webpack_require__(86021);
// EXTERNAL MODULE: ../node_modules/.pnpm/@vinted+web-ui@34.8.0_29a9e79dfb0433562b4e854f8f07c904/node_modules/@vinted/web-ui/dist/esm/lib/Divider/Divider.js
var Divider = __webpack_require__(44456);
// EXTERNAL MODULE: ../node_modules/.pnpm/@vinted+web-ui@34.8.0_29a9e79dfb0433562b4e854f8f07c904/node_modules/@vinted/web-ui/dist/esm/lib/Cell/Cell.js
var Cell = __webpack_require__(36403);
// EXTERNAL MODULE: ../app/components/OutsideClick/OutsideClick.tsx
var OutsideClick = __webpack_require__(27089);
// EXTERNAL MODULE: ../app/components/SeparatedList/SeparatedList.tsx
var SeparatedList = __webpack_require__(42792);
// EXTERNAL MODULE: ../node_modules/.pnpm/react@17.0.2/node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(20264);
;// CONCATENATED MODULE: ../app/components/LanguageSelector/LanguageSelectorDropdown/LanguageSelectorDropdown.tsx


function ownKeys(object, enumerableOnly) {
  var keys = Object.keys(object);

  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object);
    enumerableOnly && (symbols = symbols.filter(function (sym) {
      return Object.getOwnPropertyDescriptor(object, sym).enumerable;
    })), keys.push.apply(keys, symbols);
  }

  return keys;
}

function _objectSpread(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = null != arguments[i] ? arguments[i] : {};
    i % 2 ? ownKeys(Object(source), !0).forEach(function (key) {
      (0,defineProperty/* default */.Z)(target, key, source[key]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) {
      Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
    });
  }

  return target;
}








const LanguageSelectorDropdown = _ref => {
  let {
    languages,
    activeLanguage,
    isMenuOpen,
    hideLanguageMenu,
    onLanguageMenuToggle,
    saveLanguageSelection
  } = _ref;
  const {
    title_short: titleShort
  } = activeLanguage;

  const renderLanguageText = language => {
    const {
      id: activeLanguageId
    } = activeLanguage;
    const activeLanguageProps = {
      theme: 'amplified',
      bold: true
    };
    const props = language.id === activeLanguageId ? activeLanguageProps : {};
    return /*#__PURE__*/(0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
      children: [/*#__PURE__*/(0,jsx_runtime.jsx)(Text/* default */.Z, _objectSpread({
        text: language.title_local
      }, props)), /*#__PURE__*/(0,jsx_runtime.jsx)(Spacer/* default */.Z, {
        orientation: Spacer/* default.Orientation.Vertical */.Z.Orientation.Vertical,
        size: Spacer/* default.Size.Small */.Z.Size.Small
      }), /*#__PURE__*/(0,jsx_runtime.jsx)(Text/* default */.Z, _objectSpread({
        text: "(".concat(language.title, ")")
      }, props))]
    });
  };

  const handleOutsideClick = () => {
    hideLanguageMenu();
  };

  const handleLanguageSelection = language => () => {
    saveLanguageSelection(language);
  };

  return /*#__PURE__*/(0,jsx_runtime.jsx)(OutsideClick/* default */.Z, {
    onOutsideClick: handleOutsideClick,
    children: /*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
      className: "u-ui-padding-left-small",
      children: [/*#__PURE__*/(0,jsx_runtime.jsx)(Button/* ButtonWithForwardedRef */.I, {
        text: titleShort.toUpperCase(),
        styling: Button/* ButtonWithForwardedRef.Styling.Flat */.I.Styling.Flat,
        size: Button/* ButtonWithForwardedRef.Size.Medium */.I.Size.Medium,
        theme: "muted",
        inline: true,
        truncated: false,
        icon: /*#__PURE__*/(0,jsx_runtime.jsx)(Icon/* default */.Z, {
          name: "dropdown",
          size: Icon/* default.Size.Small */.Z.Size.Small,
          color: Icon/* default.Color.Gray3_v2 */.Z.Color.Gray3_v2
        }),
        iconPosition: Button/* ButtonWithForwardedRef.IconPosition.Right */.I.IconPosition.Right,
        onClick: onLanguageMenuToggle,
        aria: {
          'aria-expanded': isMenuOpen
        }
      }), isMenuOpen && /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
        className: "language-selector__dropdown",
        children: /*#__PURE__*/(0,jsx_runtime.jsx)(Card/* default */.Z, {
          styling: Card/* default.Styling.Elevated */.Z.Styling.Elevated,
          children: /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
            className: "u-overflow-hidden",
            children: /*#__PURE__*/(0,jsx_runtime.jsx)(SeparatedList/* default */.Z, {
              separator: /*#__PURE__*/(0,jsx_runtime.jsx)(Divider/* default */.Z, {}),
              children: languages.map(language => /*#__PURE__*/(0,jsx_runtime.jsx)(Cell/* default */.Z, {
                type: Cell/* default.Type.Navigating */.Z.Type.Navigating,
                onClick: handleLanguageSelection(language),
                children: renderLanguageText(language)
              }, language.id))
            })
          })
        })
      })]
    })
  });
};

/* harmony default export */ var LanguageSelectorDropdown_LanguageSelectorDropdown = (LanguageSelectorDropdown);
// EXTERNAL MODULE: ../node_modules/.pnpm/@vinted+web-ui@34.8.0_29a9e79dfb0433562b4e854f8f07c904/node_modules/@vinted/web-ui/dist/esm/lib/Label/Label.js
var Label = __webpack_require__(23200);
// EXTERNAL MODULE: ../node_modules/.pnpm/@vinted+web-ui@34.8.0_29a9e79dfb0433562b4e854f8f07c904/node_modules/@vinted/web-ui/dist/esm/lib/Modal/Modal.js
var Modal = __webpack_require__(73325);
// EXTERNAL MODULE: ../node_modules/.pnpm/@vinted+web-ui@34.8.0_29a9e79dfb0433562b4e854f8f07c904/node_modules/@vinted/web-ui/dist/esm/lib/Radio/Radio.js
var Radio = __webpack_require__(91747);
// EXTERNAL MODULE: ../app/components/@support/FormattedMessage/FormattedMessage.tsx
var FormattedMessage = __webpack_require__(718);
;// CONCATENATED MODULE: ../app/components/LanguageSelector/LanguageSelectorModal/LanguageSelectorModal.tsx







const LanguageSelectorModal = _ref => {
  let {
    languages,
    activeLanguage,
    selectedLanguage,
    isMenuOpen,
    isStandalone,
    onLanguageMenuToggle,
    onLanguageSelect,
    saveLanguageSelection
  } = _ref;

  const handleLanguageSelect = language => () => onLanguageSelect(language);

  const handleLanguageSubmit = language => () => saveLanguageSelection(language);

  const renderNavigationToggle = () => /*#__PURE__*/(0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
    children: [/*#__PURE__*/(0,jsx_runtime.jsx)(Label/* default */.Z, {
      type: Label/* default.Type.Stacked */.Z.Type.Stacked,
      styling: Label/* default.Styling.Default */.Z.Styling.Default,
      text: /*#__PURE__*/(0,jsx_runtime.jsx)(FormattedMessage/* default */.Z, {
        id: "language_selector.menu_title"
      })
    }), /*#__PURE__*/(0,jsx_runtime.jsxs)(Cell/* default */.Z, {
      prefix: /*#__PURE__*/(0,jsx_runtime.jsx)(Icon/* default */.Z, {
        name: "globe",
        color: Icon/* default.Color.Gray3_v2 */.Z.Color.Gray3_v2
      }),
      type: Cell/* default.Type.Navigating */.Z.Type.Navigating,
      onClick: onLanguageMenuToggle,
      children: [/*#__PURE__*/(0,jsx_runtime.jsx)(Text/* default */.Z, {
        text: activeLanguage.title_local,
        type: Text/* default.Type.Subtitle */.Z.Type.Subtitle,
        theme: "amplified"
      }), /*#__PURE__*/(0,jsx_runtime.jsx)(Spacer/* default */.Z, {
        orientation: Spacer/* default.Orientation.Vertical */.Z.Orientation.Vertical,
        size: Spacer/* default.Size.Small */.Z.Size.Small
      }), /*#__PURE__*/(0,jsx_runtime.jsx)(Text/* default */.Z, {
        text: "(".concat(activeLanguage.title, ")"),
        type: Text/* default.Type.Subtitle */.Z.Type.Subtitle,
        theme: "muted"
      })]
    })]
  });

  const renderStandaloneToggle = () => /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
    className: "u-ui-padding-left-small",
    children: /*#__PURE__*/(0,jsx_runtime.jsx)(Button/* ButtonWithForwardedRef */.I, {
      text: activeLanguage.title_short.toUpperCase(),
      styling: Button/* ButtonWithForwardedRef.Styling.Flat */.I.Styling.Flat,
      size: Button/* ButtonWithForwardedRef.Size.Medium */.I.Size.Medium,
      theme: "muted",
      inline: true,
      truncated: false,
      icon: /*#__PURE__*/(0,jsx_runtime.jsx)(Icon/* default */.Z, {
        name: "dropdown",
        size: Icon/* default.Size.Small */.Z.Size.Small,
        color: Icon/* default.Color.Gray3_v2 */.Z.Color.Gray3_v2
      }),
      iconPosition: Button/* ButtonWithForwardedRef.IconPosition.Right */.I.IconPosition.Right,
      onClick: onLanguageMenuToggle
    })
  });

  return /*#__PURE__*/(0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
    children: [isStandalone ? renderStandaloneToggle() : renderNavigationToggle(), /*#__PURE__*/(0,jsx_runtime.jsx)(Modal/* default */.Z, {
      show: isMenuOpen,
      children: /*#__PURE__*/(0,jsx_runtime.jsxs)(Card/* default */.Z, {
        styling: Card/* default.Styling.Elevated */.Z.Styling.Elevated,
        children: [/*#__PURE__*/(0,jsx_runtime.jsx)(Cell/* default */.Z, {
          children: /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
            className: "u-text-center",
            children: /*#__PURE__*/(0,jsx_runtime.jsx)(Text/* default */.Z, {
              text: /*#__PURE__*/(0,jsx_runtime.jsx)(FormattedMessage/* default */.Z, {
                id: "language_selector.menu_title"
              }),
              type: Text/* default.Type.Heading */.Z.Type.Heading
            })
          })
        }), languages.map(language => {
          const isChecked = language.id === selectedLanguage.id;
          return /*#__PURE__*/(0,jsx_runtime.jsxs)(react.Fragment, {
            children: [/*#__PURE__*/(0,jsx_runtime.jsxs)(Cell/* default */.Z, {
              type: Cell/* default.Type.Navigating */.Z.Type.Navigating,
              onClick: handleLanguageSelect(language),
              suffix: /*#__PURE__*/(0,jsx_runtime.jsx)(Radio/* RadioWithForwardedRef */.J, {
                name: "language_selector_".concat(language.id),
                checked: isChecked
              }),
              children: [/*#__PURE__*/(0,jsx_runtime.jsx)(Text/* default */.Z, {
                text: language.title_local,
                theme: "amplified",
                bold: true
              }), /*#__PURE__*/(0,jsx_runtime.jsx)(Spacer/* default */.Z, {
                orientation: Spacer/* default.Orientation.Vertical */.Z.Orientation.Vertical,
                size: Spacer/* default.Size.Small */.Z.Size.Small
              }), /*#__PURE__*/(0,jsx_runtime.jsx)(Text/* default */.Z, {
                text: "(".concat(language.title, ")"),
                bold: true
              })]
            }), /*#__PURE__*/(0,jsx_runtime.jsx)(Divider/* default */.Z, {})]
          }, language.id);
        }), /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
          className: "u-ui-padding-large",
          children: /*#__PURE__*/(0,jsx_runtime.jsx)(Button/* ButtonWithForwardedRef */.I, {
            text: /*#__PURE__*/(0,jsx_runtime.jsx)(FormattedMessage/* default */.Z, {
              id: "language_selector.menu_options.save"
            }),
            styling: Button/* ButtonWithForwardedRef.Styling.Filled */.I.Styling.Filled,
            onClick: handleLanguageSubmit(selectedLanguage),
            testId: "language-selector-modal-save"
          })
        }), /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
          className: "u-ui-padding-large u-padding-top-none",
          children: /*#__PURE__*/(0,jsx_runtime.jsx)(Button/* ButtonWithForwardedRef */.I, {
            text: /*#__PURE__*/(0,jsx_runtime.jsx)(FormattedMessage/* default */.Z, {
              id: "language_selector.menu_options.cancel"
            }),
            styling: Button/* ButtonWithForwardedRef.Styling.Flat */.I.Styling.Flat,
            onClick: onLanguageMenuToggle,
            testId: "language-selector-modal-cancel"
          })
        })]
      })
    })]
  });
};

/* harmony default export */ var LanguageSelectorModal_LanguageSelectorModal = (LanguageSelectorModal);
;// CONCATENATED MODULE: ../app/components/LanguageSelector/LanguageSelector.tsx










const getActiveLanguage = (languages, locale) => {
  const currentLanguage = languages.find(language => language.current);
  const defaultLanguage = languages.find(language => language.code === locale);
  return currentLanguage || defaultLanguage;
};

const LanguageSelector = _ref => {
  let {
    isStandalone = false,
    initialLanguages = []
  } = _ref;
  const breakpoints = (0,useBreakpoint/* default */.Z)();
  const locale = (0,es/* useSelector */.v9)(selectors/* getLocale */.K);
  const activeLang = getActiveLanguage(initialLanguages, locale);
  const {
    0: languages,
    1: setLanguages
  } = (0,react.useState)(initialLanguages);
  const {
    0: selectedLanguage,
    1: setSelectedLanguage
  } = (0,react.useState)(activeLang || null);
  const {
    0: activeLanguage,
    1: setActiveLanguage
  } = (0,react.useState)(activeLang || null);
  const {
    0: isMenuOpen,
    1: setIsMenuOpen
  } = (0,react.useState)(false);
  (0,react.useEffect)(() => {
    const loadLanguages = async () => {
      if (languages.length) return;
      const response = await (0,api/* getLanguages */.Vbs)();
      if ('errors' in response) return;
      const remoteActiveLanguage = getActiveLanguage(response.languages, locale);

      if (remoteActiveLanguage) {
        setActiveLanguage(remoteActiveLanguage);
        setSelectedLanguage(remoteActiveLanguage);
      }

      setLanguages(response.languages);
    };

    loadLanguages();
  }, [locale, languages]);

  const hideMenu = () => {
    setIsMenuOpen(false);
  };

  const handleLanguageSelect = language => {
    setSelectedLanguage(language);
  };

  const handleMenuToggle = () => {
    setIsMenuOpen(prevState => !prevState);
  };

  const handleMenuHide = () => {
    hideMenu();
  };

  const saveLanguageSelection = async language => {
    hideMenu();
    const response = await (0,api/* updateLocale */.jk0)(language.code);
    if (!response) return;
    setActiveLanguage(language);
    (0,utils_window/* reloadPage */.sl)();
  };

  if (languages.length <= 1 || !activeLanguage || !selectedLanguage) return null;

  if (breakpoints.portables) {
    return /*#__PURE__*/(0,jsx_runtime.jsx)(LanguageSelectorModal_LanguageSelectorModal, {
      languages: languages,
      activeLanguage: activeLanguage,
      isMenuOpen: isMenuOpen,
      isStandalone: isStandalone,
      onLanguageMenuToggle: handleMenuToggle,
      selectedLanguage: selectedLanguage,
      onLanguageSelect: handleLanguageSelect,
      saveLanguageSelection: saveLanguageSelection
    });
  }

  return /*#__PURE__*/(0,jsx_runtime.jsx)(LanguageSelectorDropdown_LanguageSelectorDropdown, {
    languages: languages,
    activeLanguage: activeLanguage,
    isMenuOpen: isMenuOpen,
    onLanguageMenuToggle: handleMenuToggle,
    hideLanguageMenu: handleMenuHide,
    saveLanguageSelection: saveLanguageSelection
  });
};

/* harmony default export */ var LanguageSelector_LanguageSelector = (LanguageSelector);

/***/ }),

/***/ 8614:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ MainFooter_MainFooter; }
});

// EXTERNAL MODULE: ../node_modules/.pnpm/@vinted+web-ui@34.8.0_29a9e79dfb0433562b4e854f8f07c904/node_modules/@vinted/web-ui/dist/esm/lib/Divider/Divider.js
var Divider = __webpack_require__(44456);
// EXTERNAL MODULE: ../app/components/SeparatedList/SeparatedList.tsx
var SeparatedList = __webpack_require__(42792);
// EXTERNAL MODULE: ../node_modules/.pnpm/react-redux@7.2.8_react-dom@17.0.2+react@17.0.2/node_modules/react-redux/es/index.js + 22 modules
var es = __webpack_require__(55304);
// EXTERNAL MODULE: ../node_modules/.pnpm/@vinted+web-ui@34.8.0_29a9e79dfb0433562b4e854f8f07c904/node_modules/@vinted/web-ui/dist/esm/lib/Spacer/Spacer.js
var Spacer = __webpack_require__(12637);
// EXTERNAL MODULE: ../app/constants/routes/index.ts
var routes = __webpack_require__(85263);
// EXTERNAL MODULE: ../app/constants/tracking/clickable-elements.ts
var clickable_elements = __webpack_require__(98495);
// EXTERNAL MODULE: ../app/hooks/useTracking/useTracking.ts
var useTracking = __webpack_require__(56068);
// EXTERNAL MODULE: ../app/hooks/useTranslate.ts
var useTranslate = __webpack_require__(63820);
// EXTERNAL MODULE: ../app/libs/common/event-tracker/events.ts
var events = __webpack_require__(8351);
// EXTERNAL MODULE: ../app/libs/utils/press-center.ts
var press_center = __webpack_require__(14386);
// EXTERNAL MODULE: ../app/libs/utils/window.ts
var utils_window = __webpack_require__(27329);
// EXTERNAL MODULE: ../app/state/feature-switches/selectors.ts
var selectors = __webpack_require__(48615);
// EXTERNAL MODULE: ../app/state/session/selectors.ts
var session_selectors = __webpack_require__(77165);
// EXTERNAL MODULE: ../node_modules/.pnpm/react@17.0.2/node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(20264);
;// CONCATENATED MODULE: ../app/components/MainFooter/LinksSection/LinkSectionGroup/LinkSectionGroup.tsx



const LinkSectionGroup = _ref => {
  let {
    title,
    children
  } = _ref;
  return /*#__PURE__*/(0,jsx_runtime.jsxs)("li", {
    className: "main-footer__links-section-item",
    children: [/*#__PURE__*/(0,jsx_runtime.jsx)("div", {
      className: "main-footer__links-section-label",
      children: title
    }), /*#__PURE__*/(0,jsx_runtime.jsx)("ul", {
      className: "main-footer__links-section-group",
      children: children
    })]
  });
};

/* harmony default export */ var LinkSectionGroup_LinkSectionGroup = (LinkSectionGroup);
;// CONCATENATED MODULE: ../app/components/MainFooter/LinksSection/LinkSectionItem/LinkSectionItem.tsx


const LinkSectionItem = _ref => {
  let {
    text,
    url,
    onClick
  } = _ref;
  return /*#__PURE__*/(0,jsx_runtime.jsx)("li", {
    className: "main-footer__links-section-row",
    children: /*#__PURE__*/(0,jsx_runtime.jsx)("a", {
      className: "main-footer__links-section-link",
      href: url,
      onClick: onClick,
      children: text
    })
  });
};

/* harmony default export */ var LinkSectionItem_LinkSectionItem = (LinkSectionItem);
;// CONCATENATED MODULE: ../app/components/MainFooter/LinksSection/LinksSection.tsx

















const LinksSection = _ref => {
  let {
    isBusinessInfoLinksEnabled
  } = _ref;
  const isJobsPageEnabled = (0,es/* useSelector */.v9)((0,selectors/* getIsFeatureSwitchEnabled */.z)('jobs_page'));
  const isForumDisabled = (0,es/* useSelector */.v9)((0,selectors/* getIsFeatureSwitchEnabled */.z)('disable_forum_web'));
  const isSustainabilityPageEnabled = (0,es/* useSelector */.v9)((0,selectors/* getIsFeatureSwitchEnabled */.z)('sustainability_page_press_center_link'));
  const isPressMenuEnabled = (0,es/* useSelector */.v9)((0,selectors/* getIsFeatureSwitchEnabled */.z)('press_menu'));
  const user = (0,es/* useSelector */.v9)(session_selectors/* getUser */.PR);
  const locale = (0,es/* useSelector */.v9)(utils_window/* getLocale */.Kd);
  const isPressCenterLinkEnabled = (0,es/* useSelector */.v9)((0,selectors/* getIsFeatureSwitchEnabled */.z)('web_press_center_link'));
  const isNewJobsUrlEnabled = (0,es/* useSelector */.v9)((0,selectors/* getIsFeatureSwitchEnabled */.z)('new_jobs_career_portal'));
  const shortLocale = locale.substring(0, 2);
  const pressUrl = isPressCenterLinkEnabled ? (0,press_center/* getPressCenterUrl */.J)(shortLocale) : routes/* PRESS_URL */.YF;
  const jobsUrl = isNewJobsUrlEnabled ? routes/* JOBS_URL_NEW */.VH : routes/* JOBS_URL */.Ch;
  const translate = (0,useTranslate/* default */.Z)('footer');
  const {
    track
  } = (0,useTracking/* default */.Z)();

  function handleSustainabilityClick() {
    track((0,events/* clickEvent */.Q5)({
      target: clickable_elements/* ClickableElement.SustainabilityPageLink */.U.SustainabilityPageLink,
      targetDetails: 'navigation_web'
    }));
  }

  return /*#__PURE__*/(0,jsx_runtime.jsxs)("ul", {
    className: "main-footer__links-section",
    children: [/*#__PURE__*/(0,jsx_runtime.jsxs)(LinkSectionGroup_LinkSectionGroup, {
      title: translate('company.title'),
      children: [/*#__PURE__*/(0,jsx_runtime.jsx)(LinkSectionItem_LinkSectionItem, {
        text: translate('company.items.about'),
        url: routes/* MAIN_NAVIGATION_ABOUT_TAB_URL */.ou
      }), isJobsPageEnabled && /*#__PURE__*/(0,jsx_runtime.jsx)(LinkSectionItem_LinkSectionItem, {
        text: translate('company.items.jobs'),
        url: jobsUrl
      }), isSustainabilityPageEnabled && /*#__PURE__*/(0,jsx_runtime.jsx)(LinkSectionItem_LinkSectionItem, {
        text: translate('company.items.sustainability'),
        url: (0,press_center/* getSustainabilityUrl */.E)(shortLocale),
        onClick: handleSustainabilityClick
      }), isPressMenuEnabled && /*#__PURE__*/(0,jsx_runtime.jsx)(LinkSectionItem_LinkSectionItem, {
        text: translate('company.items.press'),
        url: pressUrl
      }), /*#__PURE__*/(0,jsx_runtime.jsx)(LinkSectionItem_LinkSectionItem, {
        text: translate('company.items.advertising'),
        url: routes/* ADVERTISING_URL */.E2
      })]
    }), /*#__PURE__*/(0,jsx_runtime.jsxs)(LinkSectionGroup_LinkSectionGroup, {
      title: translate('discover.title'),
      children: [/*#__PURE__*/(0,jsx_runtime.jsx)(LinkSectionItem_LinkSectionItem, {
        text: translate('discover.items.how_it_works'),
        url: routes/* HOW_IT_WORKS_URL */.Ok
      }), /*#__PURE__*/(0,jsx_runtime.jsx)(LinkSectionItem_LinkSectionItem, {
        text: translate('discover.items.app'),
        url: routes/* APP_LANDING_URL */.Qw
      }), /*#__PURE__*/(0,jsx_runtime.jsx)(LinkSectionItem_LinkSectionItem, {
        text: translate('discover.items.help'),
        url: routes/* HELP_CENTER_URL */.lw
      }), /*#__PURE__*/(0,jsx_runtime.jsx)(LinkSectionItem_LinkSectionItem, {
        text: translate('discover.items.infoboard'),
        url: routes/* INFOBOARD_URL */.G
      }), isBusinessInfoLinksEnabled && /*#__PURE__*/(0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [/*#__PURE__*/(0,jsx_runtime.jsx)(LinkSectionItem_LinkSectionItem, {
          text: translate('discover.items.pro'),
          url: routes/* BUSINESS_ACCOUNTS_HOMEPAGE */.Jo
        }), /*#__PURE__*/(0,jsx_runtime.jsx)(LinkSectionItem_LinkSectionItem, {
          text: translate('discover.items.pro_guide'),
          url: routes/* BUSINESS_ACCOUNTS_GUIDE_URL */._q
        })]
      })]
    }), /*#__PURE__*/(0,jsx_runtime.jsxs)(LinkSectionGroup_LinkSectionGroup, {
      title: translate('help.title'),
      children: [/*#__PURE__*/(0,jsx_runtime.jsx)(LinkSectionItem_LinkSectionItem, {
        text: translate('help.items.centre'),
        url: routes/* HELP_CENTER_URL */.lw
      }), /*#__PURE__*/(0,jsx_runtime.jsx)(LinkSectionItem_LinkSectionItem, {
        text: translate('help.items.selling'),
        url: routes/* HELP_SELLING_URL */.vX
      }), /*#__PURE__*/(0,jsx_runtime.jsx)(LinkSectionItem_LinkSectionItem, {
        text: translate('help.items.buying'),
        url: routes/* HELP_BUYING_URL */.dM
      }), /*#__PURE__*/(0,jsx_runtime.jsx)(LinkSectionItem_LinkSectionItem, {
        text: translate('help.items.safety'),
        url: routes/* HELP_SAFETY_URL */.c1
      })]
    }), isForumDisabled ? /*#__PURE__*/(0,jsx_runtime.jsx)(Spacer/* default */.Z, {
      orientation: Spacer/* default.Orientation.Vertical */.Z.Orientation.Vertical
    }) : /*#__PURE__*/(0,jsx_runtime.jsxs)(LinkSectionGroup_LinkSectionGroup, {
      title: translate('community.title'),
      children: [/*#__PURE__*/(0,jsx_runtime.jsx)(LinkSectionItem_LinkSectionItem, {
        text: translate('community.items.forum'),
        url: routes/* FORUM_HOME_URL */.R1
      }), !!(user !== null && user !== void 0 && user.favourite_topic_count) && /*#__PURE__*/(0,jsx_runtime.jsx)(LinkSectionItem_LinkSectionItem, {
        text: translate('community.items.forum_favourite_topics'),
        url: routes/* FORUM_FAVOURITE_TOPICS_URL */.Ne
      }), !!user && /*#__PURE__*/(0,jsx_runtime.jsx)(LinkSectionItem_LinkSectionItem, {
        text: translate('community.items.forum_own_topics'),
        url: routes/* FORUM_OWN_TOPICS_URL */.An
      })]
    })]
  });
};

/* harmony default export */ var LinksSection_LinksSection = (LinksSection);
// EXTERNAL MODULE: ../app/constants/consent.ts
var consent = __webpack_require__(3557);
// EXTERNAL MODULE: ../app/libs/utils/url.ts
var url = __webpack_require__(11985);
// EXTERNAL MODULE: ../app/state/consent/selectors.ts
var consent_selectors = __webpack_require__(67295);
;// CONCATENATED MODULE: ../app/components/MainFooter/PrivacySection/SectionLink/SectionLink.tsx


const SectionLink = _ref => {
  let {
    text,
    url,
    testId
  } = _ref;
  return /*#__PURE__*/(0,jsx_runtime.jsx)("li", {
    className: "main-footer__privacy-section-item",
    children: /*#__PURE__*/(0,jsx_runtime.jsx)("a", {
      className: "main-footer__privacy-section-link",
      href: url,
      "data-testid": testId,
      children: text
    })
  });
};

/* harmony default export */ var SectionLink_SectionLink = (SectionLink);
;// CONCATENATED MODULE: ../app/components/MainFooter/PrivacySection/PrivacySection.tsx












const PrivacySection = _ref => {
  let {
    isDigitalLawEnabled,
    isBusinessInfoLinksEnabled,
    onlineComplaintUrl
  } = _ref;
  const translate = (0,useTranslate/* default */.Z)('footer.policy.items');
  const isCookieConsentVersion = (0,es/* useSelector */.v9)(consent_selectors/* getIsCookieConsentVersion */.C);
  const cookieConsentVersion = (0,es/* useSelector */.v9)(consent_selectors/* getCookieConsentVersion */.K);

  const handleCookieSettingsClick = () => {
    (0,utils_window/* toggleOneTrustInfoDisplay */.ap)();
  };

  const cookieSettingsText = cookieConsentVersion === consent/* CookieConsentVersion.California */.I1.California ? translate('cookie_settings_us') : translate('cookie_settings');
  return /*#__PURE__*/(0,jsx_runtime.jsxs)("ul", {
    className: "main-footer__privacy-section",
    children: [/*#__PURE__*/(0,jsx_runtime.jsx)(SectionLink_SectionLink, {
      text: translate('privacy_policy'),
      url: (0,url/* getOldHostRedirectUrl */.E_)() + routes/* PRIVACY_POLICY_URL */.hO
    }), /*#__PURE__*/(0,jsx_runtime.jsx)(SectionLink_SectionLink, {
      text: translate('cookie_policy'),
      url: routes/* COOKIE_POLICY_URL */.lj
    }), isCookieConsentVersion && /*#__PURE__*/(0,jsx_runtime.jsx)("li", {
      className: "main-footer__privacy-section-item",
      children: /*#__PURE__*/(0,jsx_runtime.jsx)("button", {
        className: "main-footer__privacy-section-link",
        type: "button",
        onClick: handleCookieSettingsClick,
        children: cookieSettingsText
      })
    }), /*#__PURE__*/(0,jsx_runtime.jsx)(SectionLink_SectionLink, {
      text: translate('terms_and_conditions'),
      url: routes/* TERMS_URL */.qy
    }), isDigitalLawEnabled && /*#__PURE__*/(0,jsx_runtime.jsx)(SectionLink_SectionLink, {
      text: translate('our_platform'),
      url: routes/* OUR_PLATFORM_URL */.Nc
    }), isBusinessInfoLinksEnabled && /*#__PURE__*/(0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
      children: [/*#__PURE__*/(0,jsx_runtime.jsx)(SectionLink_SectionLink, {
        text: translate('pro_terms_of_sale'),
        url: routes/* BUSINESS_TERMS_OF_SALE_URL */.$r,
        testId: "privacy-footer-pro-sale-term-link"
      }), /*#__PURE__*/(0,jsx_runtime.jsx)(SectionLink_SectionLink, {
        text: translate('pro_terms_of_use'),
        url: routes/* BUSINESS_TERMS_URL */.vK,
        testId: "privacy-footer-pro-use-term-link"
      })]
    }), onlineComplaintUrl && /*#__PURE__*/(0,jsx_runtime.jsx)(SectionLink_SectionLink, {
      text: translate('online_complaints'),
      url: onlineComplaintUrl
    })]
  });
};

/* harmony default export */ var PrivacySection_PrivacySection = (PrivacySection);
// EXTERNAL MODULE: ../node_modules/.pnpm/@vinted+web-ui@34.8.0_29a9e79dfb0433562b4e854f8f07c904/node_modules/@vinted/web-ui/dist/esm/lib/Image/Image.js
var Image = __webpack_require__(10852);
// EXTERNAL MODULE: ../app/constants/hostnames.ts
var hostnames = __webpack_require__(38716);
// EXTERNAL MODULE: ../app/constants/index.ts
var constants = __webpack_require__(24203);
// EXTERNAL MODULE: ../app/state/intl/selectors.ts
var intl_selectors = __webpack_require__(68894);
;// CONCATENATED MODULE: ../app/components/AppStoreButtons/AppButton/AppButton.tsx










var Platform;

(function (Platform) {
  Platform["Android"] = "android";
  Platform["Ios"] = "ios";
})(Platform || (Platform = {}));

const AppButton_url = {
  [Platform.Android]: "https://".concat(hostnames/* Hostname.Fr */.L.Fr, "/l/app-android-landing"),
  [Platform.Ios]: "https://".concat(hostnames/* Hostname.Fr */.L.Fr, "/l/app-ios-landing")
};
const clickTarget = {
  [Platform.Android]: clickable_elements/* ClickableElement.DownloadAndroidApp */.U.DownloadAndroidApp,
  [Platform.Ios]: clickable_elements/* ClickableElement.DownloadIosApp */.U.DownloadIosApp
};

const AppButton = _ref => {
  let {
    platform
  } = _ref;
  const {
    track
  } = (0,useTracking/* default */.Z)();
  const translate = (0,useTranslate/* default */.Z)('app_store_buttons');
  const locale = (0,es/* useSelector */.v9)(intl_selectors/* getLocale */.K);
  const imageDir = "".concat(constants/* STATIC_ASSETS_URL */.Fv, "/assets/app-badges/").concat(platform);
  const language = locale.split('-')[0];

  function handleClick() {
    track((0,events/* clickEvent */.Q5)({
      target: clickTarget[platform]
    }));
  }

  return /*#__PURE__*/(0,jsx_runtime.jsx)("a", {
    href: AppButton_url[platform],
    target: "_blank",
    rel: "noopener noreferrer",
    onClick: handleClick,
    children: /*#__PURE__*/(0,jsx_runtime.jsx)(Image/* ImageWithForwardedRef */.U, {
      src: "".concat(imageDir, "/").concat(language, ".svg"),
      fallbackSrc: "".concat(imageDir, "/default.svg"),
      alt: translate("a11y.".concat(platform))
    })
  });
};

AppButton.Platform = Platform;
/* harmony default export */ var AppButton_AppButton = (AppButton);
;// CONCATENATED MODULE: ../app/components/MainFooter/SocialSection/SocialSection.tsx





const FACEBOOK_LOGO = '/assets/icons/social-media/facebook.svg';
const LINKEDIN_LOGO = '/assets/icons/social-media/linkedin.svg';
const INSTAGRAM_LOGO = '/assets/icons/social-media/instagram.svg';

const SocialSection = () => {
  const renderSocialItem = (url, logo) => /*#__PURE__*/(0,jsx_runtime.jsx)("li", {
    className: "main-footer__social-media-item",
    children: /*#__PURE__*/(0,jsx_runtime.jsx)("a", {
      className: "main-footer__social-media-link",
      href: url,
      target: "_blank",
      rel: "noopener noreferrer",
      children: /*#__PURE__*/(0,jsx_runtime.jsx)(Image/* ImageWithForwardedRef */.U, {
        src: logo
      })
    })
  });

  return /*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
    className: "main-footer__social-section",
    children: [/*#__PURE__*/(0,jsx_runtime.jsxs)("ul", {
      className: "main-footer__social-section-media",
      children: [renderSocialItem(routes/* SOCIAL_FACEBOOK_URL */.tk, FACEBOOK_LOGO), renderSocialItem(routes/* SOCIAL_LINKEDIN_URL */.q0, LINKEDIN_LOGO), renderSocialItem(routes/* SOCIAL_INSTAGRAM_URL */.fd, INSTAGRAM_LOGO)]
    }), /*#__PURE__*/(0,jsx_runtime.jsxs)("ul", {
      className: "main-footer__social-section-app-store",
      children: [/*#__PURE__*/(0,jsx_runtime.jsx)("li", {
        className: "main-footer__social-app-store-item",
        children: /*#__PURE__*/(0,jsx_runtime.jsx)(AppButton_AppButton, {
          platform: AppButton_AppButton.Platform.Ios
        })
      }), /*#__PURE__*/(0,jsx_runtime.jsx)("li", {
        className: "main-footer__social-app-store-item",
        children: /*#__PURE__*/(0,jsx_runtime.jsx)(AppButton_AppButton, {
          platform: AppButton_AppButton.Platform.Android
        })
      })]
    })]
  });
};

/* harmony default export */ var SocialSection_SocialSection = (SocialSection);
;// CONCATENATED MODULE: ../app/components/MainFooter/MainFooter.tsx








const MainFooter = _ref => {
  let {
    isDigitalLawEnabled,
    isBusinessInfoLinksEnabled,
    onlineComplaintUrl
  } = _ref;
  return /*#__PURE__*/(0,jsx_runtime.jsx)("footer", {
    className: "main-footer",
    children: /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
      className: "main-footer__content tear tear--top",
      children: /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
        className: "container",
        children: /*#__PURE__*/(0,jsx_runtime.jsxs)(SeparatedList/* default */.Z, {
          separator: /*#__PURE__*/(0,jsx_runtime.jsx)(Divider/* default */.Z, {}),
          children: [/*#__PURE__*/(0,jsx_runtime.jsx)(LinksSection_LinksSection, {
            isBusinessInfoLinksEnabled: isBusinessInfoLinksEnabled
          }), /*#__PURE__*/(0,jsx_runtime.jsx)(SocialSection_SocialSection, {}), /*#__PURE__*/(0,jsx_runtime.jsx)(PrivacySection_PrivacySection, {
            isDigitalLawEnabled: isDigitalLawEnabled,
            isBusinessInfoLinksEnabled: isBusinessInfoLinksEnabled,
            onlineComplaintUrl: onlineComplaintUrl
          })]
        })
      })
    })
  });
};

/* harmony default export */ var MainFooter_MainFooter = (MainFooter);

/***/ }),

/***/ 40066:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony import */ var react_redux__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(55304);
/* harmony import */ var _vinted_web_ui__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(44456);
/* harmony import */ var classnames__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(3997);
/* harmony import */ var classnames__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(classnames__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var constants_consent__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(3557);
/* harmony import */ var constants_routes__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(85263);
/* harmony import */ var hooks_useTranslate__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(63820);
/* harmony import */ var libs_utils_url__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(11985);
/* harmony import */ var libs_utils_window__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(27329);
/* harmony import */ var state_consent_selectors__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(67295);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(20264);













const PolicyFooter = _ref => {
  let {
    isDigitalLawEnabled,
    isBusinessInfoLinksEnabled,
    onlineComplaintUrl,
    isStatic,
    noDivider
  } = _ref;
  const translate = (0,hooks_useTranslate__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)('footer.policy.items');
  const isCookieConsentVersion = (0,react_redux__WEBPACK_IMPORTED_MODULE_0__/* .useSelector */ .v9)(state_consent_selectors__WEBPACK_IMPORTED_MODULE_4__/* .getIsCookieConsentVersion */ .C);
  const cookieConsentVersion = (0,react_redux__WEBPACK_IMPORTED_MODULE_0__/* .useSelector */ .v9)(state_consent_selectors__WEBPACK_IMPORTED_MODULE_4__/* .getCookieConsentVersion */ .K);
  const className = classnames__WEBPACK_IMPORTED_MODULE_1___default()('privacy-footer', isStatic && 'privacy-footer--static');
  const cookieSettingsText = cookieConsentVersion === constants_consent__WEBPACK_IMPORTED_MODULE_5__/* .CookieConsentVersion.California */ .I1.California ? translate('cookie_settings_us') : translate('cookie_settings');

  function handleCookieSettingsClick() {
    (0,libs_utils_window__WEBPACK_IMPORTED_MODULE_6__/* .toggleOneTrustInfoDisplay */ .ap)();
  }

  return /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsx)("footer", {
    className: className,
    children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsx)("div", {
      className: "privacy-footer__content",
      children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsxs)("div", {
        className: "container",
        children: [!noDivider && /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsx)(_vinted_web_ui__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z, {}), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsxs)("div", {
          className: "privacy-footer__content__links",
          children: [/*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsx)("a", {
            href: (0,libs_utils_url__WEBPACK_IMPORTED_MODULE_8__/* .getOldHostRedirectUrl */ .E_)() + constants_routes__WEBPACK_IMPORTED_MODULE_9__/* .PRIVACY_POLICY_URL */ .hO,
            children: translate('privacy_policy')
          }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsx)("a", {
            href: constants_routes__WEBPACK_IMPORTED_MODULE_9__/* .COOKIE_POLICY_URL */ .lj,
            children: translate('cookie_policy')
          }), isCookieConsentVersion && /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsx)("button", {
            type: "button",
            onClick: handleCookieSettingsClick,
            children: cookieSettingsText
          }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsx)("a", {
            href: constants_routes__WEBPACK_IMPORTED_MODULE_9__/* .TERMS_URL */ .qy,
            children: translate('terms_and_conditions')
          }), isDigitalLawEnabled && /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsx)("a", {
            href: constants_routes__WEBPACK_IMPORTED_MODULE_9__/* .OUR_PLATFORM_URL */ .Nc,
            children: translate('our_platform')
          }), isBusinessInfoLinksEnabled && /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsxs)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.Fragment, {
            children: [/*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsx)("a", {
              href: constants_routes__WEBPACK_IMPORTED_MODULE_9__/* .BUSINESS_TERMS_OF_SALE_URL */ .$r,
              "data-testid": "privacy-footer-pro-sale-term-link",
              children: translate('pro_terms_of_sale')
            }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsx)("a", {
              href: constants_routes__WEBPACK_IMPORTED_MODULE_9__/* .BUSINESS_TERMS_URL */ .vK,
              "data-testid": "privacy-footer-pro-use-term-link",
              children: translate('pro_terms_of_use')
            })]
          }), onlineComplaintUrl && /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsx)("a", {
            href: onlineComplaintUrl,
            children: translate('online_complaints')
          })]
        })]
      })
    })
  });
};

/* harmony default export */ __webpack_exports__["Z"] = (PolicyFooter);

/***/ }),

/***/ 77152:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* unused harmony export UserImage */
/* harmony import */ var _app_node_modules_pnpm_next_12_3_3_4afada721a4a39e35a1a66028f2134fd_node_modules_next_dist_compiled_babel_runtime_helpers_esm_defineProperty_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(24057);
/* harmony import */ var lodash__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(61888);
/* harmony import */ var lodash__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(lodash__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var react_redux__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(55304);
/* harmony import */ var _vinted_web_ui__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(10852);
/* harmony import */ var data_utils_user__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(70300);
/* harmony import */ var state_rails_context_selectors__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(65465);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(20264);


function ownKeys(object, enumerableOnly) {
  var keys = Object.keys(object);

  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object);
    enumerableOnly && (symbols = symbols.filter(function (sym) {
      return Object.getOwnPropertyDescriptor(object, sym).enumerable;
    })), keys.push.apply(keys, symbols);
  }

  return keys;
}

function _objectSpread(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = null != arguments[i] ? arguments[i] : {};
    i % 2 ? ownKeys(Object(source), !0).forEach(function (key) {
      (0,_app_node_modules_pnpm_next_12_3_3_4afada721a4a39e35a1a66028f2134fd_node_modules_next_dist_compiled_babel_runtime_helpers_esm_defineProperty_js__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)(target, key, source[key]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) {
      Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
    });
  }

  return target;
}








const mapStateToProps = state => ({
  portal: (0,state_rails_context_selectors__WEBPACK_IMPORTED_MODULE_4__/* .getPortal */ ._0)(state),
  flavour: (0,state_rails_context_selectors__WEBPACK_IMPORTED_MODULE_4__/* .getFlavour */ .sl)(state)
});

const connector = (0,react_redux__WEBPACK_IMPORTED_MODULE_2__/* .connect */ .$j)(mapStateToProps);

const UserImage = props => {
  const {
    src,
    isSystem,
    portal,
    flavour
  } = props;
  const srcPath = (0,lodash__WEBPACK_IMPORTED_MODULE_1__.isEmpty)(src) ? (0,data_utils_user__WEBPACK_IMPORTED_MODULE_5__/* .getEmptyUserImage */ .mV)() : src;
  const imgSrc = isSystem ? (0,data_utils_user__WEBPACK_IMPORTED_MODULE_5__/* .getSystemUserImage */ .bF)(portal, flavour) : srcPath;
  return /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__.jsx)(_vinted_web_ui__WEBPACK_IMPORTED_MODULE_6__/* .ImageWithForwardedRef */ .U, _objectSpread(_objectSpread({}, props), {}, {
    src: imgSrc,
    alt: props.alt || ''
  }));
};


/* harmony default export */ __webpack_exports__["Z"] = (connector(UserImage));

/***/ }),

/***/ 46927:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony import */ var _vinted_web_ui__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(12637);
/* harmony import */ var _vinted_web_ui__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(55353);
/* harmony import */ var _vinted_web_ui__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(73080);
/* harmony import */ var hooks_useTranslate__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(63820);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(20264);






const UserTitle = _ref => {
  let {
    login,
    businessAccountName,
    isBusiness,
    isBody,
    isLoginForced,
    isBottomLoginHidden,
    isBadgeHidden,
    truncate
  } = _ref;
  const businessDisplayName = isBusiness && !isLoginForced && businessAccountName;
  const title = businessDisplayName || login;
  const translate = (0,hooks_useTranslate__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)('business');

  function renderBusinessAccountBadge() {
    if (!businessDisplayName || isBadgeHidden) return null;
    return /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.Fragment, {
      children: [/*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_vinted_web_ui__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z, {
        orientation: _vinted_web_ui__WEBPACK_IMPORTED_MODULE_2__/* ["default"].Orientation.Vertical */ .Z.Orientation.Vertical,
        size: _vinted_web_ui__WEBPACK_IMPORTED_MODULE_2__/* ["default"].Size.Regular */ .Z.Size.Regular
      }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_vinted_web_ui__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z, {
        content: translate('title'),
        testId: "profile-pro-badge"
      })]
    });
  }

  function renderBottomLogin() {
    if (!businessDisplayName || isBottomLoginHidden || isLoginForced) return null;
    return /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_vinted_web_ui__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z, {
      width: _vinted_web_ui__WEBPACK_IMPORTED_MODULE_4__/* ["default"].Width.Parent */ .Z.Width.Parent,
      text: "@".concat(login),
      type: _vinted_web_ui__WEBPACK_IMPORTED_MODULE_4__/* ["default"].Type.Subtitle */ .Z.Type.Subtitle,
      testId: "profile-business-name"
    });
  }

  return /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.Fragment, {
    children: [/*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
      className: "u-flexbox u-align-items-center",
      children: [/*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_vinted_web_ui__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z, {
        text: title,
        type: isBody ? _vinted_web_ui__WEBPACK_IMPORTED_MODULE_4__/* ["default"].Type.Body */ .Z.Type.Body : _vinted_web_ui__WEBPACK_IMPORTED_MODULE_4__/* ["default"].Type.Heading */ .Z.Type.Heading,
        theme: "amplified",
        truncate: truncate,
        bold: true,
        testId: "profile-username"
      }), renderBusinessAccountBadge()]
    }), renderBottomLogin()]
  });
};

/* harmony default export */ __webpack_exports__["Z"] = (UserTitle);

/***/ }),

/***/ 2414:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Gg": function() { return /* binding */ AuthenticateGrantType; },
/* harmony export */   "Jt": function() { return /* binding */ FacebookLoginStatus; },
/* harmony export */   "WU": function() { return /* binding */ AuthenticateProvider; },
/* harmony export */   "gH": function() { return /* binding */ FACEBOOK_PERMISSIONS; },
/* harmony export */   "m2": function() { return /* binding */ AppleIDLoginStatus; }
/* harmony export */ });
/* unused harmony exports AuthenticationScope, AuthenticationTokenType */
let AuthenticateGrantType;

(function (AuthenticateGrantType) {
  AuthenticateGrantType["Password"] = "password";
  AuthenticateGrantType["Assertion"] = "assertion";
})(AuthenticateGrantType || (AuthenticateGrantType = {}));

let AuthenticationScope;

(function (AuthenticationScope) {
  AuthenticationScope["PublicUser"] = "public user";
  AuthenticationScope["PublicUserAdmin"] = "public user admin";
})(AuthenticationScope || (AuthenticationScope = {}));

let AuthenticationTokenType;

(function (AuthenticationTokenType) {
  AuthenticationTokenType["Bearer"] = "bearer";
})(AuthenticationTokenType || (AuthenticationTokenType = {}));

let AuthenticateProvider;

(function (AuthenticateProvider) {
  AuthenticateProvider["Facebook"] = "facebook";
  AuthenticateProvider["Google"] = "google";
  AuthenticateProvider["Apple"] = "apple";
  AuthenticateProvider["CrossPortal"] = "cross_portal";
})(AuthenticateProvider || (AuthenticateProvider = {}));

let FacebookLoginStatus;

(function (FacebookLoginStatus) {
  FacebookLoginStatus["Connected"] = "connected";
})(FacebookLoginStatus || (FacebookLoginStatus = {}));

let AppleIDLoginStatus;

(function (AppleIDLoginStatus) {
  AppleIDLoginStatus["Success"] = "AppleIDSignInOnSuccess";
  AppleIDLoginStatus["Failure"] = "AppleIDSignInOnFailure";
})(AppleIDLoginStatus || (AppleIDLoginStatus = {}));

const FACEBOOK_PERMISSIONS = 'email';

/***/ }),

/***/ 48267:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "ZN": function() { return /* binding */ RE_CAPTCHA_SITE_KEY_INTELLECTUAL_PROPERTY_INFRINGEMENT; },
/* harmony export */   "Zm": function() { return /* binding */ RE_CAPTCHA_SITE_KEY_TEST; },
/* harmony export */   "o4": function() { return /* binding */ RE_CAPTCHA_SITE_KEY; }
/* harmony export */ });
const RE_CAPTCHA_SITE_KEY = '6Lfr9LwZAAAAALlS5CqkzKrEfqKgfEwjz9E7asvq'; // https://developers.google.com/recaptcha/docs/faq#id-like-to-run-automated-tests-with-recaptcha.-what-should-i-do

const RE_CAPTCHA_SITE_KEY_TEST = '6LeIxAcTAAAAAJcZVRqyHh71UMIEGNQ_MXjiZKhI';
const RE_CAPTCHA_SITE_KEY_INTELLECTUAL_PROPERTY_INFRINGEMENT = '6LdNO70fAAAAAAOLkW-h-SnNCB1RWfpG-sqeidL4';

/***/ }),

/***/ 31300:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Rq": function() { return /* binding */ VerificationMethods; }
/* harmony export */ });
/* unused harmony exports VerificationPromptCategory, VerificationActions */
let VerificationPromptCategory;

(function (VerificationPromptCategory) {
  VerificationPromptCategory["GoodActor"] = "good_actor";
  VerificationPromptCategory["BadActor"] = "bad_actor";
})(VerificationPromptCategory || (VerificationPromptCategory = {}));

let VerificationMethods;

(function (VerificationMethods) {
  VerificationMethods["Email"] = "email";
  VerificationMethods["Phone"] = "phone";
  VerificationMethods["EmailCode"] = "email_code";
  VerificationMethods["Google"] = "google";
})(VerificationMethods || (VerificationMethods = {}));

let VerificationActions;

(function (VerificationActions) {
  VerificationActions["BalanceWithdrawal"] = "balance_withdrawal";
  VerificationActions["AccountDeletion"] = "account_deletion";
  VerificationActions["DataExport"] = "data_export";
})(VerificationActions || (VerificationActions = {}));

/***/ }),

/***/ 33713:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "GR": function() { return /* binding */ registerFacebookUser; },
/* harmony export */   "Jc": function() { return /* binding */ registerAppleUser; },
/* harmony export */   "So": function() { return /* binding */ authenticateUser; },
/* harmony export */   "TX": function() { return /* binding */ logoutUser; },
/* harmony export */   "a$": function() { return /* binding */ registerUser; },
/* harmony export */   "c0": function() { return /* binding */ resetPassword; },
/* harmony export */   "eC": function() { return /* binding */ registerGoogleUser; },
/* harmony export */   "mI": function() { return /* binding */ generateRandomUser; }
/* harmony export */ });
/* harmony import */ var _app_node_modules_pnpm_next_12_3_3_4afada721a4a39e35a1a66028f2134fd_node_modules_next_dist_compiled_babel_runtime_helpers_esm_defineProperty_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(24057);
/* harmony import */ var axios__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(91431);
/* harmony import */ var axios__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(axios__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var lodash__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(61888);
/* harmony import */ var lodash__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(lodash__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var libs_common_api_client__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(52914);
/* harmony import */ var libs_common_api_client__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(7694);
/* harmony import */ var libs_utils_window__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(27329);
/* harmony import */ var data_api_response_codes__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(25146);
/* harmony import */ var constants_paths__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(21301);
/* harmony import */ var data_api_transformers_args__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(88616);


function ownKeys(object, enumerableOnly) {
  var keys = Object.keys(object);

  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object);
    enumerableOnly && (symbols = symbols.filter(function (sym) {
      return Object.getOwnPropertyDescriptor(object, sym).enumerable;
    })), keys.push.apply(keys, symbols);
  }

  return keys;
}

function _objectSpread(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = null != arguments[i] ? arguments[i] : {};
    i % 2 ? ownKeys(Object(source), !0).forEach(function (key) {
      (0,_app_node_modules_pnpm_next_12_3_3_4afada721a4a39e35a1a66028f2134fd_node_modules_next_dist_compiled_babel_runtime_helpers_esm_defineProperty_js__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)(target, key, source[key]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) {
      Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
    });
  }

  return target;
}









const initSessionInterceptor = instance => instance.interceptors.response.use(async response => {
  var _response$data$auth_t;

  const token = response.data.access_token || ((_response$data$auth_t = response.data.auth_token) === null || _response$data$auth_t === void 0 ? void 0 : _response$data$auth_t.access_token);

  if (!token) {
    return Promise.reject(new Error('Token was not provided'));
  }

  try {
    const sessionResponse = await axios__WEBPACK_IMPORTED_MODULE_1___default().get('/member/general/session_from_token', {
      headers: {
        Authorization: "Bearer ".concat(token)
      }
    }); // TODO: remove after PL merge

    if (sessionResponse.data && 'redirect_to' in sessionResponse.data && sessionResponse.data.redirect_to) {
      (0,libs_utils_window__WEBPACK_IMPORTED_MODULE_3__/* .navigateToPage */ .ru)(sessionResponse.data.redirect_to); // Stopping further code execution

      return await new Promise(lodash__WEBPACK_IMPORTED_MODULE_2__.noop);
    }

    return response;
  } catch (exception) {
    exception.code = data_api_response_codes__WEBPACK_IMPORTED_MODULE_4__/* .ResponseCode.SessionFromTokenError */ .Q.SessionFromTokenError;
    return Promise.reject(exception);
  }
}, exception => {
  return Promise.reject(exception);
});

const api = new libs_common_api_client__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z({}, [libs_common_api_client__WEBPACK_IMPORTED_MODULE_6__/* .csrfTokenInterceptor */ .jN, libs_common_api_client__WEBPACK_IMPORTED_MODULE_6__/* .errorInterceptor */ .ud, libs_common_api_client__WEBPACK_IMPORTED_MODULE_6__/* .localeInterceptor */ .Ch, initSessionInterceptor]);
const ajaxApi = axios__WEBPACK_IMPORTED_MODULE_1___default().create();
libs_common_api_client__WEBPACK_IMPORTED_MODULE_6__/* .csrfTokenInterceptor */ .jN(ajaxApi);
async function logoutUser() {
  try {
    const response = await ajaxApi.post('/member/general/logout');
    const isResponse2xx = "".concat(response.status).startsWith('2');
    return isResponse2xx;
  } catch (_unused) {
    return false;
  }
}
function registerUser(args) {
  const {
    realName,
    login,
    email,
    password,
    agreeRules,
    referrerId,
    subscribeToNewsletter = false,
    fingerprint,
    uuid
  } = args;
  const user = {
    real_name: realName,
    login,
    email,
    password,
    agree_rules: agreeRules,
    user_settings: {
      is_newsletter_subscriber: subscribeToNewsletter
    }
  };
  return api.post("".concat(constants_paths__WEBPACK_IMPORTED_MODULE_7__/* .API_BASE_PATH */ .Lt, "/users"), {
    user,
    referrer_id: referrerId,
    fingerprint,
    uuid
  });
}
function registerFacebookUser(args) {
  const {
    token,
    login,
    email,
    referrerId,
    subscribeToNewsletter = false,
    realName,
    fingerprint
  } = args;
  const user = {
    login,
    real_name: realName,
    email,
    user_setting: {
      is_newsletter_subscriber: subscribeToNewsletter
    }
  };
  return api.post("".concat(constants_paths__WEBPACK_IMPORTED_MODULE_7__/* .API_BASE_PATH */ .Lt, "/facebook_users"), {
    fb_access_token: token,
    user,
    referrer_id: referrerId,
    fingerprint
  });
}
function registerGoogleUser(args) {
  const {
    token,
    login,
    email,
    referrerId,
    subscribeToNewsletter = false,
    realName,
    fingerprint
  } = args;
  const user = {
    login,
    real_name: realName,
    email,
    user_setting: {
      is_newsletter_subscriber: subscribeToNewsletter
    },
    referrer_id: referrerId
  };
  return api.post("".concat(constants_paths__WEBPACK_IMPORTED_MODULE_7__/* .API_BASE_PATH */ .Lt, "/google_user"), {
    id_token: token,
    user,
    fingerprint
  });
}
function registerAppleUser(args) {
  const {
    token,
    login,
    email,
    referrerId,
    subscribeToNewsletter = false,
    realName,
    fingerprint
  } = args;
  const user = {
    login,
    real_name: realName,
    email,
    user_setting: {
      is_newsletter_subscriber: subscribeToNewsletter
    },
    referrer_id: referrerId
  };
  return api.post("".concat(constants_paths__WEBPACK_IMPORTED_MODULE_7__/* .API_BASE_PATH */ .Lt, "/apple_user"), {
    id_token: token,
    user,
    fingerprint
  });
}
function authenticateUser(args) {
  return api.post('/oauth/token', _objectSpread({
    client_id: 'web',
    scope: 'user'
  }, (0,data_api_transformers_args__WEBPACK_IMPORTED_MODULE_8__/* .authenticateUserArgsToParams */ .tP)(args)));
}
function resetPassword(_ref) {
  let {
    email
  } = _ref;
  return api.post("".concat(constants_paths__WEBPACK_IMPORTED_MODULE_7__/* .API_BASE_PATH */ .Lt, "/users/reset_password"), {
    email
  });
}
function generateRandomUser(args) {
  const {
    isGod
  } = args;
  return api.post("".concat(constants_paths__WEBPACK_IMPORTED_MODULE_7__/* .API_BASE_PATH */ .Lt, "/generate_random_user"), {
    is_god: isGod
  });
}

/***/ }),

/***/ 54403:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(49231);

const CAPTCHA_PASSED_EVENT_NAME = 'dd_captcha_passed';

const useDataDomeCaptcha = callback => {
  (0,react__WEBPACK_IMPORTED_MODULE_0__.useEffect)(() => {
    window.addEventListener(CAPTCHA_PASSED_EVENT_NAME, callback);
    return () => {
      window.removeEventListener(CAPTCHA_PASSED_EVENT_NAME, callback);
    };
  }, [callback]);
};

/* harmony default export */ __webpack_exports__["Z"] = (useDataDomeCaptcha);

/***/ }),

/***/ 76819:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ hooks_useGoogleTagManagerTrack; }
});

// EXTERNAL MODULE: ../node_modules/.pnpm/next@12.3.3_4afada721a4a39e35a1a66028f2134fd/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/defineProperty.js
var defineProperty = __webpack_require__(24057);
// EXTERNAL MODULE: ../node_modules/.pnpm/react@17.0.2/node_modules/react/index.js
var react = __webpack_require__(49231);
// EXTERNAL MODULE: ../node_modules/.pnpm/react-redux@7.2.8_react-dom@17.0.2+react@17.0.2/node_modules/react-redux/es/index.js + 22 modules
var es = __webpack_require__(55304);
// EXTERNAL MODULE: ../app/constants/google.ts
var google = __webpack_require__(31967);
// EXTERNAL MODULE: ../app/data/utils/google.ts
var utils_google = __webpack_require__(39397);
// EXTERNAL MODULE: ../app/libs/utils/object.ts
var object = __webpack_require__(55118);
// EXTERNAL MODULE: ../app/libs/utils/window.ts
var utils_window = __webpack_require__(27329);
// EXTERNAL MODULE: ../app/state/feature-switches/selectors.ts
var selectors = __webpack_require__(48615);
// EXTERNAL MODULE: ../app/state/selectors.ts + 1 modules
var state_selectors = __webpack_require__(53316);
// EXTERNAL MODULE: ../app/constants/tracking/screens.ts
var screens = __webpack_require__(79196);
// EXTERNAL MODULE: ../app/libs/utils/url.ts
var url = __webpack_require__(11985);
;// CONCATENATED MODULE: ../app/hooks/google/utils.ts




function isProductPage(screenName) {
  return screenName === screens/* Screen.Item */.l.Item;
}
/**
 * NOTE:
 * This method returns the current catalog url (top two level) in english
 * on catalog page
 * */

function getCurrentCatalogUrl(url) {
  return (url === null || url === void 0 ? void 0 : url.split('/').splice(1, 2).join('/')) || '';
}
const pageTypeFormNameMap = {
  [google/* PageType.Checkout */.GV.Checkout]: google/* FormName.Checkout */.GY.Checkout,
  [google/* PageType.AddListing */.GV.AddListing]: google/* FormName.AddListing */.GY.AddListing
};
function getFormName(pageType) {
  return pageTypeFormNameMap[pageType] || '';
}
function getSiteSearchStrings() {
  const {
    search_text
  } = (0,url/* toParams */.oZ)((0,utils_window/* getUrlQuery */.pf)());
  if (typeof search_text !== 'string') return '';
  return search_text;
}
function getPageType(searchString, pageCategory, screenName) {
  if (searchString) return google/* PageType.SearchResult */.GV.SearchResult;
  if (isProductPage(screenName)) return google/* PageType.ProductDisplay */.GV.ProductDisplay;
  if (pageCategory) return google/* PageType.ProductListings */.GV.ProductListings;
  const url = (0,utils_window/* getRelativeUrl */.qC)();
  if (url.endsWith('/checkout')) return google/* PageType.Checkout */.GV.Checkout;
  if (url.endsWith('/member/items/favourite_list')) return google/* PageType.Favourites */.GV.Favourites;
  if (url.endsWith('/items/new')) return google/* PageType.AddListing */.GV.AddListing;
  return google/* PageType.Others */.GV.Others;
}
function googleAnalyticsDataTransformer(data) {
  const {
    anonymousId,
    language,
    screenName
  } = data;
  const siteSearchString = getSiteSearchStrings();
  const pageCategory = getCurrentCatalogUrl(data.currentCatalogUrl);
  const userId = String(data.userId || '');
  const loginStatus = data.authStatus ? google/* LoginStatus.Logged */.IC.Logged : google/* LoginStatus.NotLogged */.IC.NotLogged;
  const pageType = getPageType(siteSearchString, pageCategory, screenName);
  const formName = getFormName(pageType);
  return {
    anonymousId,
    language,
    siteSearchString,
    loginStatus,
    userId,
    pageCategory,
    pageType,
    formName
  };
}
;// CONCATENATED MODULE: ../app/hooks/useGoogleTagManagerTrack.ts


function ownKeys(object, enumerableOnly) {
  var keys = Object.keys(object);

  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object);
    enumerableOnly && (symbols = symbols.filter(function (sym) {
      return Object.getOwnPropertyDescriptor(object, sym).enumerable;
    })), keys.push.apply(keys, symbols);
  }

  return keys;
}

function _objectSpread(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = null != arguments[i] ? arguments[i] : {};
    i % 2 ? ownKeys(Object(source), !0).forEach(function (key) {
      (0,defineProperty/* default */.Z)(target, key, source[key]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) {
      Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
    });
  }

  return target;
}











function useGoogleTagManagerTrack() {
  const googleAnalyticsData = googleAnalyticsDataTransformer((0,es/* useSelector */.v9)(state_selectors/* getGoogleAnalyticsData */.Pk));
  const isGoogleAnalyticsTrackEnabled = (0,es/* useSelector */.v9)((0,selectors/* getIsFeatureSwitchEnabled */.z)('web_ga4_analytics'));
  const isGtmEcFieldEnabled = (0,es/* useSelector */.v9)((0,selectors/* getIsFeatureSwitchEnabled */.z)('web_gtm_ec_field'));
  const googleTagManagerTrack = (0,react.useCallback)((event, data) => (0,utils_google/* googleTagManagerTrack */.E6)(event, data, isGtmEcFieldEnabled), [isGtmEcFieldEnabled]);
  const googleAnalyticsTrack = (0,react.useCallback)(_ref => {
    let {
      event = google/* GoogleTagManagerEvent.pageLoad */.Nx.pageLoad,
      customTagObject
    } = _ref;
    const eventObject = (0,object/* filterEmptyStringAttributes */.Mr)(_objectSpread(_objectSpread(_objectSpread({}, googleAnalyticsData), customTagObject), {}, {
      domain: (0,utils_window/* getHost */.XF)()
    }));

    if (isGoogleAnalyticsTrackEnabled) {
      (0,utils_google/* googleTagManagerTrack */.E6)(event, eventObject);
    }
  }, [googleAnalyticsData, isGoogleAnalyticsTrackEnabled]);
  return {
    googleTagManagerTrack,
    googleAnalyticsTrack
  };
}

/* harmony default export */ var hooks_useGoogleTagManagerTrack = (useGoogleTagManagerTrack);

/***/ }),

/***/ 64076:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "f": function() { return /* binding */ getFingerprint; }
/* harmony export */ });
/* harmony import */ var fingerprintjs2__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(3030);
/* harmony import */ var fingerprintjs2__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(fingerprintjs2__WEBPACK_IMPORTED_MODULE_0__);


const getFingerprint = async () => {
  const options = {
    excludes: {
      hasLiedOs: true,
      hasLiedBrowser: true,
      sessionStorage: true,
      hasLiedLanguages: true,
      fontsFlash: true,
      enumerateDevices: true
    }
  };
  const components = await fingerprintjs2__WEBPACK_IMPORTED_MODULE_0___default().getPromise(options);
  return fingerprintjs2__WEBPACK_IMPORTED_MODULE_0___default().x64hash128(components.map(_ref => {
    let {
      value
    } = _ref;
    return value;
  }).join(''), 0);
};



/***/ }),

/***/ 89523:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "EK": function() { return /* binding */ loadGoogleApi; },
/* harmony export */   "TO": function() { return /* binding */ loadGoogleSdk; },
/* harmony export */   "rL": function() { return /* binding */ removeGoogleCallback; },
/* harmony export */   "sR": function() { return /* binding */ getGoogleRedirectUrl; }
/* harmony export */ });
/* harmony import */ var constants_google__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(31967);
/* harmony import */ var _authentication__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(85202);
/* harmony import */ var _script__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(68046);



let googleApiLoadedCallbacks = [];

const callGoogleApiCallbacks = () => {
  googleApiLoadedCallbacks.forEach(callback => callback());
};

const onGoogleCallback = onGoogleApiLoaded => {
  var _window$google;

  window.googleApiLoaded = callGoogleApiCallbacks;

  if (!googleApiLoadedCallbacks.includes(onGoogleApiLoaded)) {
    googleApiLoadedCallbacks.push(onGoogleApiLoaded);
  }

  if (!((_window$google = window.google) !== null && _window$google !== void 0 && _window$google.maps)) return;
  callGoogleApiCallbacks();
};

const loadGoogleApi = _ref => {
  let {
    apiKey,
    onGoogleApiLoaded
  } = _ref;
  onGoogleCallback(onGoogleApiLoaded);

  if (document.getElementById(constants_google__WEBPACK_IMPORTED_MODULE_0__/* .GOOGLE_MAPS_SERVICE_ID */ .Uc)) {
    return;
  }

  const url = new URL('/maps/api/js', 'https://maps.googleapis.com');
  url.searchParams.set('key', apiKey);
  url.searchParams.set('libraries', ['places', 'geometry'].toString());
  url.searchParams.set('callback', 'googleApiLoaded');
  const src = url.toString();
  (0,_script__WEBPACK_IMPORTED_MODULE_1__/* .loadScript */ .v)({
    id: constants_google__WEBPACK_IMPORTED_MODULE_0__/* .GOOGLE_MAPS_SERVICE_ID */ .Uc,
    src
  });
};
const loadGoogleSdk = () => {
  return (0,_script__WEBPACK_IMPORTED_MODULE_1__/* .loadScript */ .v)({
    id: constants_google__WEBPACK_IMPORTED_MODULE_0__/* .GOOGLE_SDK_SCRIPT_ID */ .PI,
    isAsync: true,
    src: constants_google__WEBPACK_IMPORTED_MODULE_0__/* .GOOGLE_SDK_LINK */ .KU
  });
};
const removeGoogleCallback = callback => {
  googleApiLoadedCallbacks = googleApiLoadedCallbacks.filter(loadedCallback => loadedCallback !== callback);
};
const getGoogleRedirectUrl = state => {
  const decodedState = (0,_authentication__WEBPACK_IMPORTED_MODULE_2__/* .decodeBase64Object */ .B)(state);
  return (decodedState === null || decodedState === void 0 ? void 0 : decodedState.redirect_uri) || state;
};

/***/ }),

/***/ 14386:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "E": function() { return /* binding */ getSustainabilityUrl; },
/* harmony export */   "J": function() { return /* binding */ getPressCenterUrl; }
/* harmony export */ });
/* harmony import */ var constants_routes__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85263);

const SUSTAINABILITY_REPORT_LOCALES = ['pl', 'nl', 'de', 'it', 'es'];
const PRESS_CENTER_LOCALES = ['en', 'fr', 'lt'];

const getLangParam = activeLocale => {
  const isLocaleSupported = SUSTAINABILITY_REPORT_LOCALES.includes(activeLocale);
  return isLocaleSupported ? "?lang=".concat(activeLocale) : '';
};

const getLocaleSubPath = activeLocale => PRESS_CENTER_LOCALES.includes(activeLocale) ? "/".concat(activeLocale) : '';

const getPressCenterUrl = activeLocale => "".concat(constants_routes__WEBPACK_IMPORTED_MODULE_0__/* .PRESS_CENTER_URL */ .n$).concat(getLocaleSubPath(activeLocale));
const getSustainabilityUrl = activeLocale => "".concat(getPressCenterUrl(activeLocale), "/sustainability").concat(getLangParam(activeLocale));

/***/ }),

/***/ 71462:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "J": function() { return /* binding */ isEmailValid; }
/* harmony export */ });
/* unused harmony export emailRegex */
// eslint-disable-next-line no-control-regex
const emailRegex = /^((([a-z]|\d|[!#$%&'*+\-/=?^_`{|}~]|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])+(\.([a-z]|\d|[!#$%&'*+\-/=?^_`{|}~]|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])+)*)|((\x22)((((\x20|\x09)*(\x0d\x0a))?(\x20|\x09)+)?(([\x01-\x08\x0b\x0c\x0e-\x1f\x7f]|\x21|[\x23-\x5b]|[\x5d-\x7e]|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])|(\\([\x01-\x09\x0b\x0c\x0d-\x7f]|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF]))))*(((\x20|\x09)*(\x0d\x0a))?(\x20|\x09)+)?(\x22)))@((([a-z]|\d|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])|(([a-z]|\d|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])([a-z]|\d|-|\.|_|~|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])*([a-z]|\d|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])))\.)+(([a-z]|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])|(([a-z]|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])([a-z]|\d|-|\.|_|~|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])*([a-z]|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])))$/i;
const isEmailValid = email => emailRegex.test(email);

/***/ }),

/***/ 63208:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "v": function() { return /* binding */ isFullNameValid; }
/* harmony export */ });
/* unused harmony export fullNameRegex */
// backend uses same regexp
const fullNameRegex = /^\s*[a-zA-Z\u00C0-\u1FFF\u2C00-\uD7FF\-.,'`‘’]+(\s+[a-zA-Z\u00C0-\u1FFF\u2C00-\uD7FF\-.,'`‘’]+)+\s*$/i;
const isFullNameValid = fullName => fullNameRegex.test(fullName);

/***/ }),

/***/ 87728:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Cm": function() { return /* binding */ getAuthView; },
/* harmony export */   "Hi": function() { return /* binding */ getIsSelectTypeLogin; },
/* harmony export */   "J$": function() { return /* binding */ getIsRealNameRequired; },
/* harmony export */   "LP": function() { return /* binding */ getIsRandomUserSignupEnabled; },
/* harmony export */   "Uc": function() { return /* binding */ getIsBusinessAuth; },
/* harmony export */   "VG": function() { return /* binding */ getReferrerId; },
/* harmony export */   "_z": function() { return /* binding */ getIsBusinessRegistrationLinkVisible; },
/* harmony export */   "ab": function() { return /* binding */ getNewsletterSubscription; },
/* harmony export */   "rU": function() { return /* binding */ getExternalRegisterData; },
/* harmony export */   "so": function() { return /* binding */ getIsFacebookIsInitialized; },
/* harmony export */   "y1": function() { return /* binding */ getIsAuthModalOpen; }
/* harmony export */ });
/* harmony import */ var libs_utils_cookies__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(80216);
/* harmony import */ var _constants__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(29702);



const localState = state => state[_constants__WEBPACK_IMPORTED_MODULE_0__/* .stateName */ .AN];

const getReferrerId = state => localState(state).referrerId;
const getIsRealNameRequired = state => localState(state).isRealNameRequired;
const getIsRandomUserSignupEnabled = state => localState(state).isRandomUserSignupEnabled;
const getNewsletterSubscription = state => localState(state).newsletterSubscription;
const getIsAuthModalOpen = state => localState(state).isAuthModalOpen || false;
const getAuthView = state => localState(state).authView || ((0,libs_utils_cookies__WEBPACK_IMPORTED_MODULE_1__/* .getCookie */ .ej)('last_user_id') ? _constants__WEBPACK_IMPORTED_MODULE_0__/* .AuthView.SelectTypeLogin */ .GT.SelectTypeLogin : _constants__WEBPACK_IMPORTED_MODULE_0__/* .AuthView.SelectTypeRegister */ .GT.SelectTypeRegister);
const getIsSelectTypeLogin = state => getAuthView(state) === _constants__WEBPACK_IMPORTED_MODULE_0__/* .AuthView.SelectTypeLogin */ .GT.SelectTypeLogin;
const getIsBusinessRegistrationLinkVisible = state => localState(state).isBusinessRegistrationLinkVisible;
const getExternalRegisterData = state => localState(state).externalRegisterData;
const getIsFacebookIsInitialized = state => localState(state).isFacebookIsInitialized || false;
const getIsBusinessAuth = state => localState(state).isBusiness || false;

/***/ }),

/***/ 53084:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "$G": function() { return /* binding */ getAppleClientId; },
/* harmony export */   "A3": function() { return /* binding */ getGoogleMapsApiKey; },
/* harmony export */   "Xl": function() { return /* binding */ getNethoneWebProfilerUrl; },
/* harmony export */   "iJ": function() { return /* binding */ getFacebookAppId; },
/* harmony export */   "sd": function() { return /* binding */ getGoogleClientId; }
/* harmony export */ });
/* unused harmony export getEnv */
/* harmony import */ var reselect__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(65148);
/* harmony import */ var state_session_selectors__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(77165);
/* harmony import */ var _constants__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(54312);




const localState = state => state[_constants__WEBPACK_IMPORTED_MODULE_1__/* .stateName */ .A];

const getEnv = name => state => localState(state)[name]; // TODO: These break isolation and access session state in order to remain compatible with rails; the session access should be removed after migration

const getFacebookAppId = (0,reselect__WEBPACK_IMPORTED_MODULE_0__/* .createSelector */ .P1)([state_session_selectors__WEBPACK_IMPORTED_MODULE_2__/* .getSessionFacebookAppId */ .kw, getEnv('FACEBOOK_CLIENT_ID')], (sessionFacebookAppId, facebookAppId) => sessionFacebookAppId || facebookAppId);
const getAppleClientId = (0,reselect__WEBPACK_IMPORTED_MODULE_0__/* .createSelector */ .P1)([state_session_selectors__WEBPACK_IMPORTED_MODULE_2__/* .getSessionAppleClientId */ .g8, getEnv('APPLE_CLIENT_ID')], (sessionAppleClientId, appleClientId) => sessionAppleClientId || appleClientId);
const getGoogleClientId = (0,reselect__WEBPACK_IMPORTED_MODULE_0__/* .createSelector */ .P1)([state_session_selectors__WEBPACK_IMPORTED_MODULE_2__/* .getSessionGoogleClientId */ .dE, getEnv('GOOGLE_CLIENT_ID')], (sessionGoogleClientId, googleClientId) => sessionGoogleClientId || googleClientId);
const getGoogleMapsApiKey = (0,reselect__WEBPACK_IMPORTED_MODULE_0__/* .createSelector */ .P1)([state_session_selectors__WEBPACK_IMPORTED_MODULE_2__/* .getSessionGoogleMapsApiKey */ .NP, getEnv('GOOGLE_MAPS_API_KEY')], (sessionGoogleMapsApiKey, googleMapsApiKey) => sessionGoogleMapsApiKey || googleMapsApiKey || '');
const getNethoneWebProfilerUrl = (0,reselect__WEBPACK_IMPORTED_MODULE_0__/* .createSelector */ .P1)([state_session_selectors__WEBPACK_IMPORTED_MODULE_2__/* .getSessionNethoneWebProfilerUrl */ .ZF, getEnv('NETHONE_WEB_PROFILER_URL')], (sessionNethoneWebProfilerUrl, nethoneWebProfilerUrl) => sessionNethoneWebProfilerUrl || nethoneWebProfilerUrl);

/***/ })

}]);